import { _ as e, a as t, c as n, d as r, f as i, h as a, i as o, l as s, m as c, n as l, o as u, p as d, r as f, s as p, t as m, u as h } from "./jsx-runtime-9E0c_URc.js";
//#region node_modules/react-dom/cjs/react-dom.production.js
var g = /* @__PURE__ */ a(((e) => {
	var t = c();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal"), o = Symbol.for("react.recoverable"), s = Symbol.for("react.optimistic_key");
	function l(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : r === s ? s : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var u = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function d(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.browser = function(e) {
		return {
			$$typeof: o,
			_reason: e
		};
	}, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return l(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = u.T, n = i.p;
		try {
			if (u.T = null, i.p = 2, e) return e();
		} finally {
			u.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = d(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") {
			if (typeof t == "object" && t) {
				if (t.as == null || t.as === "script") {
					var n = d(t.as, t.crossOrigin);
					i.d.M(e, {
						crossOrigin: n,
						integrity: typeof t.integrity == "string" ? t.integrity : void 0,
						nonce: typeof t.nonce == "string" ? t.nonce : void 0,
						fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0
					});
				}
			} else t ?? i.d.M(e);
		}
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = d(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") {
			if (t) {
				var n = d(t.as, t.crossOrigin);
				i.d.m(e, {
					as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0,
					fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0
				});
			} else i.d.m(e);
		}
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return u.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return u.H.useHostTransitionStatus();
	}, e.version = "19.3.0";
})), _ = /* @__PURE__ */ a(((e, t) => {
	function n() {
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == "function") try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = g();
})), v = /* @__PURE__ */ a(((e) => {
	var t = d(), n = c(), r = _();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		for (var t = e, n = t; n && !n.alternate;) t = n, t.flags & 4098 && (e = t.return), n = t.return;
		for (; t.return;) t = t.return;
		return t.tag === 3 ? e : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function u(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function f(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return u(a), e;
					if (s === r) return u(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, l = a.child; l;) {
					if (l === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (l === r) {
						c = !0, r = a, n = s;
						break;
					}
					l = l.sibling;
				}
				if (!c) {
					for (l = s.child; l;) {
						if (l === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (l === r) {
							c = !0, r = s, n = a;
							break;
						}
						l = l.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function p(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = p(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	function m(e, t, n, r, i, a) {
		for (; e !== null;) {
			if ((e.tag === 5 || e.tag === 27 || e.tag === 6) && n(e, r, i, a) || (e.tag !== 22 || e.memoizedState === null) && (t || e.tag !== 5 && e.tag !== 27) && m(e.child, t, n, r, i, a)) return !0;
			e = e.sibling;
		}
		return !1;
	}
	function h(e) {
		for (e = e.return; e !== null;) {
			if (e.tag === 3 || e.tag === 5 || e.tag === 27) return e;
			e = e.return;
		}
		return null;
	}
	function g(e) {
		var t = !1;
		for (e = e.return; e !== null && (e.tag === 4 && (t = !0), e.tag !== 3 && e.tag !== 5 && e.tag !== 27);) e = e.return;
		return t;
	}
	function v(e) {
		var t = [null, null], n = h(e);
		return n === null || y(t, e, n.child, { foundSelf: !1 }), t;
	}
	function y(e, t, n, r) {
		for (; n !== null;) {
			if (n === t) r.foundSelf = !0;
			else if (n.tag === 5 || n.tag === 27 || n.tag === 6) {
				if (r.foundSelf) return e[1] = n, !0;
				e[0] = n;
			} else if ((n.tag !== 22 || n.memoizedState === null) && y(e, t, n.child, r)) return !0;
			n = n.sibling;
		}
		return !1;
	}
	function b(e) {
		switch (e.tag) {
			case 5:
			case 27:
			case 6: return e.stateNode;
			case 3: return e.stateNode.containerInfo;
			default: throw Error(i(559));
		}
	}
	var ee = null, te = null;
	function x(e, t, n) {
		return e === n || e === t && (ee = e, !0);
	}
	function ne(e, t, n) {
		return e === n ? (te = e, !1) : e === t && (te !== null && (ee = e), !0);
	}
	function re(e) {
		if (e === null) return null;
		do
			e = e === null ? null : e.return;
		while (e && e.tag !== 5 && e.tag !== 27 && e.tag !== 3);
		return e || null;
	}
	function ie(e, t, n) {
		for (var r = 0, i = e; i; i = n(i)) r++;
		i = 0;
		for (var a = t; a; a = n(a)) i++;
		for (; 0 < r - i;) e = n(e), r--;
		for (; 0 < i - r;) t = n(t), i--;
		for (; r--;) {
			if (e === t || t !== null && e === t.alternate) return e;
			e = n(e), t = n(t);
		}
		return null;
	}
	var S = Object.assign, C = Symbol.for("react.element"), ae = Symbol.for("react.transitional.element"), oe = Symbol.for("react.portal"), se = Symbol.for("react.fragment"), ce = Symbol.for("react.strict_mode"), le = Symbol.for("react.profiler"), ue = Symbol.for("react.consumer"), w = Symbol.for("react.context"), T = Symbol.for("react.forward_ref"), de = Symbol.for("react.suspense"), fe = Symbol.for("react.suspense_list"), pe = Symbol.for("react.memo"), me = Symbol.for("react.lazy"), he = Symbol.for("react.activity"), ge = Symbol.for("react.legacy_hidden"), _e = Symbol.for("react.memo_cache_sentinel"), ve = Symbol.for("react.view_transition"), ye = Symbol.for("react.recoverable"), be = Symbol.iterator;
	function xe(e) {
		return typeof e != "object" || !e ? null : (e = be && e[be] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var Se = Symbol.for("react.client.reference");
	function Ce(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === Se ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case se: return "Fragment";
			case le: return "Profiler";
			case ce: return "StrictMode";
			case de: return "Suspense";
			case fe: return "SuspenseList";
			case he: return "Activity";
			case ve: return "ViewTransition";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case oe: return "Portal";
			case w: return e.displayName || "Context";
			case ue: return (e._context.displayName || "Context") + ".Consumer";
			case T:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case pe: return t = e.displayName || null, t === null ? Ce(e.type) || "Memo" : t;
			case me:
				t = e._payload, e = e._init;
				try {
					return Ce(e(t));
				} catch {}
		}
		return null;
	}
	var we = Array.isArray, E = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, D = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Te = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, Ee = [], De = -1;
	function O(e) {
		return { current: e };
	}
	function k(e) {
		0 > De || (e.current = Ee[De], Ee[De] = null, De--);
	}
	function A(e, t) {
		De++, Ee[De] = e.current, e.current = t;
	}
	var Oe = O(null), ke = O(null), Ae = O(null), je = O(null);
	function Me(e, t) {
		switch (A(Ae, t), A(ke, e), A(Oe, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? up(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = up(t), e = dp(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		k(Oe), A(Oe, e);
	}
	function Ne() {
		k(Oe), k(ke), k(Ae);
	}
	function Pe(e) {
		var t = e.memoizedState;
		t !== null && (sh._currentValue = t.memoizedState, A(je, e)), t = Oe.current;
		var n = dp(t, e.type);
		t !== n && (A(ke, e), A(Oe, n));
	}
	function Fe(e) {
		ke.current === e && (k(Oe), k(ke)), je.current === e && (k(je), sh._currentValue = Te);
	}
	var Ie, Le;
	function Re(e) {
		if (Ie === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			Ie = t && t[1] || "", Le = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + Ie + e + Le;
	}
	var ze = !1;
	function Be(e, t) {
		if (!e || ze) return "";
		ze = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							n = !1;
							try {
								var i = Object.getOwnPropertyDescriptor(e.prototype, "props");
								Object.defineProperty(e.prototype, "props", {
									configurable: !0,
									set: function() {
										throw Error();
									}
								}), n = !0, new e();
							} finally {
								n && (i === void 0 ? delete e.prototype.props : Object.defineProperty(e.prototype, "props", i));
							}
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			ze = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? Re(n) : "";
	}
	function Ve(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return Re(e.type);
			case 16: return Re("Lazy");
			case 13: return e.child !== t && t !== null ? Re("Suspense Fallback") : Re("Suspense");
			case 19: return Re("SuspenseList");
			case 0:
			case 15: return Be(e.type, !1);
			case 11: return Be(e.type.render, !1);
			case 1: return Be(e.type, !0);
			case 31: return Re("Activity");
			case 30: return Re("ViewTransition");
			default: return "";
		}
	}
	function He(e) {
		try {
			var t = "", n = null;
			do
				t += Ve(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var Ue = Object.prototype.hasOwnProperty, We = t.unstable_scheduleCallback, Ge = t.unstable_cancelCallback, Ke = t.unstable_shouldYield, qe = t.unstable_requestPaint, Je = t.unstable_now, Ye = t.unstable_getCurrentPriorityLevel, Xe = t.unstable_ImmediatePriority, Ze = t.unstable_UserBlockingPriority, Qe = t.unstable_NormalPriority, $e = t.unstable_LowPriority, et = t.unstable_IdlePriority, tt = t.log, nt = t.unstable_setDisableYieldValue, rt = null, it = null;
	function at(e) {
		if (typeof tt == "function" && nt(e), it && typeof it.setStrictMode == "function") try {
			it.setStrictMode(rt, e);
		} catch {}
	}
	var ot = Math.clz32 ? Math.clz32 : lt, st = Math.log, ct = Math.LN2;
	function lt(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (st(e) / ct | 0) | 0;
	}
	var ut = 256, dt = 262144, ft = 4194304;
	function pt(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & -e;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function mt(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = pt(n))) : i = pt(o) : i = pt(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = pt(n))) : i = pt(o)) : i = pt(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function ht(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function gt(e, t) {
		t & 8 && (t |= t & 32);
		var n = e.entangledLanes;
		if (n !== 0) for (e = e.entanglements, n &= t; 0 < n;) {
			var r = 31 - ot(n), i = 1 << r;
			t |= e[r], n &= ~i;
		}
		return t;
	}
	function _t(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function vt() {
		var e = ft;
		return ft <<= 1, !(ft & 62914560) && (ft = 4194304), e;
	}
	function yt(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function bt(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function xt(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - ot(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && St(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function St(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - ot(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function Ct(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - ot(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function wt(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : Tt(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function Tt(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function Et(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function Dt() {
		var e = D.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : Ch(e.type)) : e;
	}
	function Ot(e, t) {
		var n = D.p;
		try {
			return D.p = e, t();
		} finally {
			D.p = n;
		}
	}
	var kt = Math.random().toString(36).slice(2), At = "__reactFiber$" + kt, jt = "__reactProps$" + kt, Mt = "__reactContainer$" + kt, Nt = "__reactEvents$" + kt, Pt = "__reactListeners$" + kt, Ft = "__reactHandles$" + kt, It = "__reactResources$" + kt, Lt = "__reactMarker$" + kt, Rt = "__reactLoad$" + kt;
	function zt(e) {
		delete e[At], delete e[jt], delete e[Pt], delete e[Ft];
	}
	function Bt(e) {
		var t;
		if (t = e[At]) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[Mt] || n[At]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = fm(e); e !== null;) {
					if (n = e[At]) return n;
					e = fm(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function Vt(e) {
		if (e = e[At] || e[Mt]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function Ht(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function Ut(e) {
		var t = e[It];
		return t ||= e[It] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function Wt(e) {
		e[Lt] = !0;
	}
	function Gt(e) {
		e[Rt] = void 0;
	}
	var Kt = /* @__PURE__ */ new Set(), qt = {};
	function Jt(e, t) {
		Yt(e, t), Yt(e + "Capture", t);
	}
	function Yt(e, t) {
		for (qt[e] = t, e = 0; e < t.length; e++) Kt.add(t[e]);
	}
	var Xt = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Zt = {}, Qt = {};
	function $t(e) {
		return Ue.call(Qt, e) ? !0 : Ue.call(Zt, e) ? !1 : Xt.test(e) ? Qt[e] = !0 : (Zt[e] = !0, !1);
	}
	var j = !1;
	function en() {
		var e = j;
		return j = !1, e;
	}
	function tn(e, t, n) {
		if ($t(t)) {
			if (n === null) e.removeAttribute(t);
			else {
				switch (typeof n) {
					case "undefined":
					case "function":
					case "symbol":
						e.removeAttribute(t);
						return;
					case "boolean":
						var r = t.toLowerCase().slice(0, 5);
						if (r !== "data-" && r !== "aria-") {
							e.removeAttribute(t);
							return;
						}
				}
				e.setAttribute(t, n);
			}
		}
	}
	function nn(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, n);
		}
	}
	function rn(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, r);
		}
	}
	function an(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function on(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function sn(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function cn(e) {
		if (!e._valueTracker) {
			var t = on(e) ? "checked" : "value";
			e._valueTracker = sn(e, t, "" + e[t]);
		}
	}
	function ln(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = on(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n && (t.setValue(e), !0);
	}
	var un = /[\n"\\]/g;
	function dn(e) {
		return e.replace(un, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function fn(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + an(t)) : e.value !== "" + an(t) && (e.value = "" + an(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : mn(e, an(n)) : o === "number" && e.value == t ? mn(e, an(e.value)) : mn(e, an(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + an(s) : e.removeAttribute("name");
	}
	function pn(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				cn(e);
				return;
			}
			n = n == null ? "" : "" + an(n), t = t == null ? n : "" + an(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), cn(e);
	}
	function mn(e, t) {
		e.defaultValue !== "" + t && (e.defaultValue = "" + t);
	}
	function hn(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + an(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function gn(e, t, n) {
		if (t != null && (t = "" + an(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + an(n);
	}
	function _n(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (we(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = an(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), cn(e);
	}
	function vn(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var yn = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function bn(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || yn.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function xn(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "", j = !0);
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && (bn(e, a, r), j = !0);
		} else for (var o in t) t.hasOwnProperty(o) && bn(e, o, t[o]);
	}
	function Sn(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var Cn = /* @__PURE__ */ new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["maskType", "mask-type"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), wn = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function Tn(e) {
		return wn.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function En() {}
	var Dn = null;
	function On(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var kn = null, An = null;
	function jn(e) {
		var t = Vt(e);
		if (t && (e = t.stateNode)) {
			var n = e[jt] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (fn(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + dn("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[jt] || null;
								if (!a) throw Error(i(90));
								fn(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && ln(r);
					}
					break a;
				case "textarea":
					gn(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && hn(e, !!n.multiple, t, !1);
			}
		}
	}
	var Mn = !1;
	function Nn(e, t, n) {
		if (Mn) return e(t, n);
		Mn = !0;
		try {
			return e(t);
		} finally {
			if (Mn = !1, (kn !== null || An !== null) && (zd(), kn && (t = kn, e = An, An = kn = null, jn(t), e))) for (t = 0; t < e.length; t++) jn(e[t]);
		}
	}
	function Pn(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[jt] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = e !== "button" && e !== "input" && e !== "select" && e !== "textarea"), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var Fn = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, In = !1;
	if (Fn) try {
		var Ln = {};
		Object.defineProperty(Ln, "passive", { get: function() {
			In = !0;
		} }), window.addEventListener("test", Ln, Ln), window.removeEventListener("test", Ln, Ln);
	} catch {
		In = !1;
	}
	var Rn = null, zn = null, Bn = null;
	function Vn() {
		if (Bn) return Bn;
		var e, t = zn, n = t.length, r, i = "value" in Rn ? Rn.value : Rn.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return Bn = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function Hn(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function Un() {
		return !0;
	}
	function Wn() {
		return !1;
	}
	function Gn(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? Un : Wn, this.isPropagationStopped = Wn, this;
		}
		return S(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Un);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Un);
			},
			persist: function() {},
			isPersistent: Un
		}), t;
	}
	var Kn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, qn = Gn(Kn), Jn = S({}, Kn, {
		view: 0,
		detail: 0
	}), Yn = Gn(Jn), Xn, Zn, Qn, $n = S({}, Jn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: ur,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== Qn && (Qn && e.type === "mousemove" ? (Xn = e.screenX - Qn.screenX, Zn = e.screenY - Qn.screenY) : Zn = Xn = 0, Qn = e), Xn);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : Zn;
		}
	}), er = Gn($n), tr = Gn(S({}, $n, { dataTransfer: 0 })), nr = Gn(S({}, Jn, { relatedTarget: 0 })), rr = Gn(S({}, Kn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), ir = Gn(S({}, Kn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), ar = Gn(S({}, Kn, { data: 0 })), or = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, sr = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, cr = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function lr(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = cr[e]) ? !!t[e] : !1;
	}
	function ur() {
		return lr;
	}
	var dr = Gn(S({}, Jn, {
		key: function(e) {
			if (e.key) {
				var t = or[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = Hn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? sr[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: ur,
		charCode: function(e) {
			return e.type === "keypress" ? Hn(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? Hn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), fr = Gn(S({}, $n, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), pr = Gn(S({}, Kn, { submitter: 0 })), mr = Gn(S({}, Jn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: ur
	})), hr = Gn(S({}, Kn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), gr = Gn(S({}, $n, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), _r = Gn(S({}, Kn, {
		newState: 0,
		oldState: 0,
		source: 0
	})), vr = [
		9,
		13,
		27,
		32
	], yr = Fn && "CompositionEvent" in window, br = null;
	Fn && "documentMode" in document && (br = document.documentMode);
	var xr = Fn && "TextEvent" in window && !br, Sr = Fn && (!yr || br && 8 < br && 11 >= br), Cr = " ", wr = !1;
	function Tr(e, t) {
		switch (e) {
			case "keyup": return vr.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function Er(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var Dr = !1;
	function Or(e, t) {
		switch (e) {
			case "compositionend": return Er(t);
			case "keypress": return t.which === 32 ? (wr = !0, Cr) : null;
			case "textInput": return e = t.data, e === Cr && wr ? null : e;
			default: return null;
		}
	}
	function kr(e, t) {
		if (Dr) return e === "compositionend" || !yr && Tr(e, t) ? (e = Vn(), Bn = zn = Rn = null, Dr = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return Sr && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var Ar = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function jr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!Ar[e.type] : t === "textarea";
	}
	function Mr(e, t, n, r) {
		kn ? An ? An.push(r) : An = [r] : kn = r, t = Jf(t, "onChange"), 0 < t.length && (n = new qn("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var Nr = null, Pr = null;
	function Fr(e) {
		Vf(e, 0);
	}
	function Ir(e) {
		if (ln(Ht(e))) return e;
	}
	function Lr(e, t) {
		if (e === "change") return t;
	}
	var Rr = !1;
	if (Fn) {
		var zr;
		if (Fn) {
			var Br = "oninput" in document;
			if (!Br) {
				var Vr = document.createElement("div");
				Vr.setAttribute("oninput", "return;"), Br = typeof Vr.oninput == "function";
			}
			zr = Br;
		} else zr = !1;
		Rr = zr && (!document.documentMode || 9 < document.documentMode);
	}
	function Hr() {
		Nr && (Nr.detachEvent("onpropertychange", Ur), Pr = Nr = null);
	}
	function Ur(e) {
		if (e.propertyName === "value" && Ir(Pr)) {
			var t = [];
			Mr(t, Pr, e, On(e)), Nn(Fr, t);
		}
	}
	function Wr(e, t, n) {
		e === "focusin" ? (Hr(), Nr = t, Pr = n, Nr.attachEvent("onpropertychange", Ur)) : e === "focusout" && Hr();
	}
	function Gr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return Ir(Pr);
	}
	function Kr(e, t) {
		if (e === "click") return Ir(t);
	}
	function qr(e, t) {
		if (e === "input" || e === "change") return Ir(t);
	}
	function Jr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var Yr = typeof Object.is == "function" ? Object.is : Jr;
	function Xr(e, t) {
		if (Yr(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!Ue.call(t, i) || !Yr(e[i], t[i])) return !1;
		}
		return !0;
	}
	function Zr(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	function Qr(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function $r(e, t) {
		var n = Qr(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = Qr(n);
		}
	}
	function ei(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? ei(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function ti(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = Zr(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = Zr(e.document);
		}
		return t;
	}
	function ni(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var ri = Fn && "documentMode" in document && 11 >= document.documentMode, ii = null, ai = null, oi = null, si = !1;
	function ci(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		si || ii == null || ii !== Zr(r) || (r = ii, "selectionStart" in r && ni(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), oi && Xr(oi, r) || (oi = r, r = Jf(ai, "onSelect"), 0 < r.length && (t = new qn("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = ii)));
	}
	function li(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var ui = {
		animationend: li("Animation", "AnimationEnd"),
		animationiteration: li("Animation", "AnimationIteration"),
		animationstart: li("Animation", "AnimationStart"),
		transitionrun: li("Transition", "TransitionRun"),
		transitionstart: li("Transition", "TransitionStart"),
		transitioncancel: li("Transition", "TransitionCancel"),
		transitionend: li("Transition", "TransitionEnd")
	}, di = {}, fi = {};
	Fn && (fi = document.createElement("div").style, "AnimationEvent" in window || (delete ui.animationend.animation, delete ui.animationiteration.animation, delete ui.animationstart.animation), "TransitionEvent" in window || delete ui.transitionend.transition);
	function pi(e) {
		if (di[e]) return di[e];
		if (!ui[e]) return e;
		var t = ui[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in fi) return di[e] = t[n];
		return e;
	}
	var mi = pi("animationend"), hi = pi("animationiteration"), gi = pi("animationstart"), _i = pi("transitionrun"), vi = pi("transitionstart"), yi = pi("transitioncancel"), bi = pi("transitionend"), xi = /* @__PURE__ */ new Map(), Si = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Si.push("scrollEnd");
	function Ci(e, t) {
		xi.set(e, t), Jt(t, [e]);
	}
	var wi = 0;
	function Ti(e, t) {
		if (e.name != null && e.name !== "auto") return e.name;
		if (t.autoName !== null) return t.autoName;
		e = bd.identifierPrefix;
		var n = wi++;
		return e = "_" + e + "t_" + n.toString(32) + "_", t.autoName = e;
	}
	function Ei(e) {
		if (e == null || typeof e == "string") return e;
		var t = null, n = Od;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var i = e[n[r]];
			if (i != null) {
				if (i === "none") return "none";
				t = t == null ? i : t + (" " + i);
			}
		}
		return t ?? e.default;
	}
	function Di(e, t) {
		return e = Ei(e), t = Ei(t), t == null ? e === "auto" ? null : e : t === "auto" ? null : t;
	}
	var Oi = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, ki = [], Ai = 0, ji = 0;
	function Mi() {
		for (var e = Ai, t = ji = Ai = 0; t < e;) {
			var n = ki[t];
			ki[t++] = null;
			var r = ki[t];
			ki[t++] = null;
			var i = ki[t];
			ki[t++] = null;
			var a = ki[t];
			if (ki[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && Ii(n, i, a);
		}
	}
	function Ni(e, t, n, r) {
		ki[Ai++] = e, ki[Ai++] = t, ki[Ai++] = n, ki[Ai++] = r, ji |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function Pi(e, t, n, r) {
		return Ni(e, t, n, r), Li(e);
	}
	function Fi(e, t) {
		return Ni(e, null, null, t), Li(e);
	}
	function Ii(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - ot(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function Li(e) {
		if (50 < kd) throw kd = 0, Ad = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var Ri = {};
	function zi(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function Bi(e, t, n, r) {
		return new zi(e, t, n, r);
	}
	function Vi(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function Hi(e, t) {
		var n = e.alternate;
		return n === null ? (n = Bi(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 1206910976, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function Ui(e, t) {
		e.flags &= 1206910978;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function Wi(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof r == "function") Vi(r) && (s = 1);
		else if (typeof r == "string") s = qm(e, n, Oe.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (r) {
			case he: return e = Bi(31, n, t, a), e.elementType = he, e.lanes = o, e;
			case se: return Gi(n.children, a, o, t);
			case ce:
				s = 8, a |= 24;
				break;
			case le: return e = Bi(12, n, t, a | 2), e.elementType = le, e.lanes = o, e;
			case de: return e = Bi(13, n, t, a), e.elementType = de, e.lanes = o, e;
			case fe: return e = Bi(19, n, t, a), e.elementType = fe, e.lanes = o, e;
			case ge:
			case ve: return e = a | 32, e = Bi(30, n, t, e), e.elementType = ve, e.lanes = o, e.stateNode = {
				autoName: null,
				paired: null,
				clones: null,
				ref: null
			}, e;
			default:
				if (typeof r == "object" && r) switch (r.$$typeof) {
					case w:
						s = 10;
						break a;
					case ue:
						s = 9;
						break a;
					case T:
						s = 11;
						break a;
					case pe:
						s = 14;
						break a;
					case me:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = Bi(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function Gi(e, t, n, r) {
		return e = Bi(7, e, r, t), e.lanes = n, e;
	}
	function Ki(e, t, n) {
		return e = Bi(6, e, null, t), e.lanes = n, e;
	}
	function qi(e) {
		var t = Bi(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function Ji(e, t, n) {
		return t = Bi(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var Yi = /* @__PURE__ */ new WeakMap();
	function Xi(e, t) {
		if (typeof e == "object" && e) {
			var n = Yi.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: He(t)
			}, Yi.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: He(t)
		};
	}
	var Zi = [], Qi = 0, $i = null, ea = 0, ta = [], na = 0, ra = null, ia = 1, aa = "";
	function oa(e, t) {
		Zi[Qi++] = ea, Zi[Qi++] = $i, $i = e, ea = t;
	}
	function sa(e, t, n) {
		ta[na++] = ia, ta[na++] = aa, ta[na++] = ra, ra = e;
		var r = ia;
		e = aa;
		var i = 32 - ot(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - ot(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, ia = 1 << 32 - ot(t) + i | n << i | r, aa = a + e;
		} else ia = 1 << a | n << i | r, aa = e;
	}
	function ca(e) {
		e.return !== null && (oa(e, 1), sa(e, 1, 0));
	}
	function la(e) {
		for (; e === $i;) $i = Zi[--Qi], Zi[Qi] = null, ea = Zi[--Qi], Zi[Qi] = null;
		for (; e === ra;) ra = ta[--na], ta[na] = null, aa = ta[--na], ta[na] = null, ia = ta[--na], ta[na] = null;
	}
	function ua(e, t) {
		ta[na++] = ia, ta[na++] = aa, ta[na++] = ra, ia = t.id, aa = t.overflow, ra = e;
	}
	var da = null, M = null, N = !1, fa = null, pa = !1, ma = Error(i(519));
	function ha(e) {
		throw xa(Xi(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), ma;
	}
	function ga(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[At] = e, t[jt] = r, n) {
			case "dialog":
				Q("cancel", t), Q("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				Q("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < zf.length; n++) Q(zf[n], t);
				break;
			case "source":
				Q("error", t);
				break;
			case "img":
			case "image":
			case "link":
				Q("error", t), Q("load", t);
				break;
			case "details":
				Q("toggle", t);
				break;
			case "input":
				Q("invalid", t), pn(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				Q("invalid", t);
				break;
			case "textarea": Q("invalid", t), _n(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || ep(t.textContent, n) ? (r.popover != null && (Q("beforetoggle", t), Q("toggle", t)), r.onScroll != null && Q("scroll", t), r.onScrollEnd != null && Q("scrollend", t), r.onClick != null && (t.onclick = En), t = !0) : t = !1, t || ha(e, !0);
	}
	function _a(e) {
		for (da = e.return; da;) switch (da.tag) {
			case 5:
			case 31:
			case 13:
				pa = !1;
				return;
			case 27:
			case 3:
				pa = !0;
				return;
			default: da = da.return;
		}
	}
	function va(e) {
		if (e !== da) return !1;
		if (!N) return _a(e), N = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = n === "form" || n === "button" || pp(e.type, e.memoizedProps)), n = !n), n && M && ha(e), _a(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			M = dm(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			M = dm(e);
		} else t === 27 ? (t = M, Sp(e.type) ? (e = um, um = null, M = e) : M = t) : M = da ? lm(e.stateNode.nextSibling) : null;
		return !0;
	}
	function ya() {
		M = da = null, N = !1;
	}
	function ba() {
		var e = fa;
		return e !== null && (pd === null ? pd = e : pd.push.apply(pd, e), fa = null), e;
	}
	function xa(e) {
		fa === null ? fa = [e] : fa.push(e);
	}
	var Sa = O(null), Ca = null, wa = null;
	function Ta(e, t, n) {
		A(Sa, t._currentValue), t._currentValue = n;
	}
	function Ea(e) {
		e._currentValue = Sa.current, k(Sa);
	}
	function Da(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Oa(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Da(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Da(s, n, e), s = null;
			} else a.tag === 13 && a.memoizedState !== null && a.memoizedState.dehydrated === null ? (a.lanes |= n, s = a.alternate, s !== null && (s.lanes |= n), Da(a.return, n, e), s = a.child, s = s === null ? null : s.sibling) : s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function ka(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					Yr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === je.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [sh] : e.push(sh));
			}
			a = a.return;
		}
		return e !== null && Oa(t, e, n, r), t.flags |= 262144, e !== null;
	}
	function Aa(e) {
		for (e = e.firstContext; e !== null;) {
			if (!Yr(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function ja(e) {
		Ca = e, wa = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function Ma(e) {
		return Pa(Ca, e);
	}
	function Na(e, t) {
		return Ca === null && ja(e), Pa(e, t);
	}
	function Pa(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, wa === null) {
			if (e === null) throw Error(i(308));
			wa = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else wa = wa.next = t;
		return n;
	}
	var Fa = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, Ia = t.unstable_scheduleCallback, La = t.unstable_NormalPriority, P = {
		$$typeof: w,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function Ra() {
		return {
			controller: new Fa(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function za(e) {
		e.refCount--, e.refCount === 0 && Ia(La, function() {
			e.controller.abort();
		});
	}
	function Ba(e, t) {
		if (e.pendingLanes & 4194048) {
			var n = e.transitionTypes;
			for (n === null && (n = e.transitionTypes = []), e = 0; e < t.length; e++) {
				var r = t[e];
				n.indexOf(r) === -1 && n.push(r);
			}
		}
	}
	var Va = null;
	function Ha(e) {
		var t = e.transitionTypes;
		return e.transitionTypes = null, t;
	}
	var Ua = null, Wa = 0, Ga = 0, Ka = null;
	function qa(e, t) {
		if (Ua === null) {
			var n = Ua = [];
			Wa = 0, Ga = Pf(), Ka = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return Wa++, t.then(Ja, Ja), t;
	}
	function Ja() {
		if (--Wa === 0 && (Va = null, Ua !== null)) {
			Ka !== null && (Ka.status = "fulfilled");
			var e = Ua;
			Ua = null, Ga = 0, Ka = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function Ya(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var Xa = E.S;
	E.S = function(e, t) {
		if (gd = Je(), typeof t == "object" && t && typeof t.then == "function" && qa(e, t), Va !== null) for (var n = bf; n !== null;) Ba(n, Va), n = n.next;
		if (n = e.types, n !== null) {
			for (var r = bf; r !== null;) Ba(r, n), r = r.next;
			if (Ga !== 0) {
				r = Va, r === null && (r = Va = []);
				for (var i = 0; i < n.length; i++) {
					var a = n[i];
					r.indexOf(a) === -1 && r.push(a);
				}
			}
		}
		Xa !== null && Xa(e, t);
	};
	var Za = O(null);
	function Qa() {
		var e = Za.current;
		return e === null ? G.pooledCache : e;
	}
	function $a(e, t) {
		t === null ? A(Za, Za.current) : A(Za, t.pool);
	}
	function eo() {
		var e = Qa();
		return e === null ? null : {
			parent: P._currentValue,
			pool: e
		};
	}
	var to = Error(i(460)), no = Error(i(474)), ro = Error(i(542)), io = { then: function() {} };
	function ao(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function oo(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(En, En), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, uo(e), e === void 0 && !("reason" in t) ? Error(i(600)) : e;
			default:
				if (typeof t.status == "string") t.then(En, En);
				else {
					if (e = G, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, uo(e), e;
				}
				throw co = t, to;
		}
	}
	function so(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (co = e, to) : e;
		}
	}
	var co = null;
	function lo() {
		if (co === null) throw Error(i(459));
		var e = co;
		return co = null, e;
	}
	function uo(e) {
		if (e === to || e === ro) throw Error(i(483));
	}
	var fo = null, po = 0;
	function mo(e) {
		var t = po;
		return po += 1, fo === null && (fo = []), oo(fo, e, t);
	}
	function ho(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function go(e, t) {
		throw t.$$typeof === C ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function _o(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = Hi(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 134217730, n) : (r = r.index, r < n ? (t.flags |= 2, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 134217730), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = Ki(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === se ? (e = d(e, t, n.props.children, r, n.key), ho(e, n), e) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === me && so(i) === t.type) ? (t = a(t, n.props), ho(t, n), t.return = e, t) : (t = Wi(n.type, n.key, n.props, null, e.mode, r), ho(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = Ji(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = Gi(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = Ki("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case ae: return n = Wi(t.type, t.key, t.props, null, e.mode, n), ho(n, t), n.return = e, n;
					case oe: return t = Ji(t, e.mode, n), t.return = e, t;
					case me: return t = so(t), f(e, t, n);
				}
				if (we(t) || xe(t)) return t = Gi(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, mo(t), n);
				if (t.$$typeof === w) return f(e, Na(e, t), n);
				go(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case ae: return n.key === i ? l(e, t, n, r) : null;
					case oe: return n.key === i ? u(e, t, n, r) : null;
					case me: return n = so(n), p(e, t, n, r);
				}
				if (we(n) || xe(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, mo(n), r);
				if (n.$$typeof === w) return p(e, t, Na(e, n), r);
				go(e, n);
			}
			return null;
		}
		function m(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case ae: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case oe: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case me: return r = so(r), m(e, t, n, r, i);
				}
				if (we(r) || xe(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return m(e, t, n, mo(r), i);
				if (r.$$typeof === w) return m(e, t, n, Na(t, r), i);
				go(t, r);
			}
			return null;
		}
		function h(i, a, s, c) {
			for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
				d.index > h ? (g = d, d = null) : g = d.sibling;
				var _ = p(i, d, s[h], c);
				if (_ === null) {
					d === null && (d = g);
					break;
				}
				e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
			}
			if (h === s.length) return n(i, d), N && oa(i, h), l;
			if (d === null) {
				for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
				return N && oa(i, h), l;
			}
			for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && (_ = g.alternate, _ !== null && d.delete(_.key === null ? h : _.key)), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), N && oa(i, h), l;
		}
		function g(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
				h.index > g ? (_ = h, h = null) : _ = h.sibling;
				var y = p(a, h, v.value, l);
				if (y === null) {
					h === null && (h = _);
					break;
				}
				e && h && y.alternate === null && t(a, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
			}
			if (v.done) return n(a, h), N && oa(a, g), u;
			if (h === null) {
				for (; !v.done; g++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
				return N && oa(a, g), u;
			}
			for (h = r(h); !v.done; g++, v = c.next()) v = m(h, a, g, v.value, l), v !== null && (e && (_ = v.alternate, _ !== null && h.delete(_.key === null ? g : _.key)), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
			return e && h.forEach(function(e) {
				return t(a, e);
			}), N && oa(a, g), u;
		}
		function _(e, r, o, c) {
			if (typeof o == "object" && o && o.type === se && o.key === null && o.props.ref === void 0 && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case ae:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === se) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), ho(c, o), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === me && so(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), ho(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								}
								t(e, r), r = r.sibling;
							}
							o.type === se ? (c = Gi(o.props.children, e.mode, c, o.key), ho(c, o), c.return = e, e = c) : (c = Wi(o.type, o.key, o.props, null, e.mode, c), ho(c, o), c.return = e, e = c);
						}
						return s(e);
					case oe:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) {
									if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
										n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								}
								t(e, r), r = r.sibling;
							}
							c = Ji(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case me: return o = so(o), _(e, r, o, c);
				}
				if (we(o)) return h(e, r, o, c);
				if (xe(o)) {
					if (l = xe(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), g(e, r, o, c);
				}
				if (typeof o.then == "function") return _(e, r, mo(o), c);
				if (o.$$typeof === w) return _(e, r, Na(e, o), c);
				go(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = Ki(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				po = 0;
				var i = _(e, t, n, r);
				return fo = null, i;
			} catch (t) {
				if (t === to || t === ro) throw t;
				var a = Bi(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var vo = _o(!0), yo = _o(!1), bo = !1;
	function xo(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function So(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function Co(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function wo(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, W & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Li(e), Ii(e, null, n), t;
		}
		return Ni(e, r, t, n), Li(e);
	}
	function To(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Ct(e, n);
		}
	}
	function Eo(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Do = !1;
	function Oo() {
		if (Do) {
			var e = Ka;
			if (e !== null) throw e;
		}
	}
	function ko(e, t, n, r) {
		Do = !1;
		var i = e.updateQueue;
		bo = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var f = s.lane & -536870913, p = f !== s.lane;
				if (p ? (q & f) === f : (r & f) === f) {
					f !== 0 && f === Ga && (Do = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var m = e, h = s;
						f = t;
						var g = n;
						switch (h.tag) {
							case 1:
								if (m = h.payload, typeof m == "function") {
									d = m.call(g, d, f);
									break a;
								}
								d = m;
								break a;
							case 3: m.flags = m.flags & -65537 | 128;
							case 0:
								if (m = h.payload, f = typeof m == "function" ? m.call(g, d, f) : m, f == null) break a;
								d = S({}, d, f);
								break a;
							case 2: bo = !0;
						}
					}
					f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f));
				} else p = {
					lane: f,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), sd |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Ao(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function jo(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Ao(n[e], t);
	}
	var Mo = O(null), No = O(0);
	function Po(e, t) {
		e = od, A(No, e), A(Mo, t), od = e | t.baseLanes;
	}
	function Fo() {
		A(No, od), A(Mo, Mo.current);
	}
	function Io() {
		od = No.current, k(Mo), k(No);
	}
	var Lo = O(null), Ro = null;
	function zo(e) {
		var t = e.alternate;
		A(Wo, Wo.current & 1), A(Lo, e), Ro === null && (t === null || Mo.current !== null || t.memoizedState !== null) && (Ro = e);
	}
	function Bo(e) {
		A(Wo, Wo.current), A(Lo, e), Ro === null && (Ro = e);
	}
	function Vo(e) {
		e.tag === 22 ? (A(Wo, Wo.current), A(Lo, e), Ro === null && (Ro = e)) : Ho();
	}
	function Ho() {
		A(Wo, Wo.current), A(Lo, Lo.current);
	}
	function Uo(e) {
		k(Lo), Ro === e && (Ro = null), k(Wo);
	}
	var Wo = O(0);
	function Go(e, t) {
		A(Lo, Lo.current), A(Wo, t);
	}
	function Ko(e) {
		k(Wo), k(Lo), Ro === e && (Ro = null);
	}
	function qo(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || om(n) || sm(n))) return t;
			} else if (t.tag === 19 && t.memoizedProps.revealOrder !== "independent") {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var Jo = 0, F = null, I = null, L = null, Yo = !1, Xo = !1, Zo = !1, Qo = 0, $o = 0, es = null, ts = 0;
	function R() {
		throw Error(i(321));
	}
	function ns(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!Yr(e[n], t[n])) return !1;
		return !0;
	}
	function rs(e, t, n, r, i, a) {
		return Jo = a, F = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, E.H = e === null || e.memoizedState === null ? yc : bc, Zo = !1, a = n(r, i), Zo = !1, Xo && (a = as(t, n, r, i)), is(e), a;
	}
	function is(e) {
		E.H = vc;
		var t = I !== null && I.next !== null;
		if (Jo = 0, L = I = F = null, Yo = !1, $o = 0, es = null, t) throw Error(i(300));
		e === null || B || (e = e.dependencies, e !== null && Aa(e) && (B = !0));
	}
	function as(e, t, n, r) {
		F = e;
		var a = 0;
		do {
			if (Xo && (es = null), $o = 0, Xo = !1, 25 <= a) throw Error(i(301));
			if (a += 1, L = I = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			E.H = xc, o = t(n, r);
		} while (Xo);
		return o;
	}
	function os() {
		var e = E.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? fs(t) : t, e = e.useState()[0], (I === null ? null : I.memoizedState) !== e && (F.flags |= 1024), t;
	}
	function ss() {
		var e = Qo !== 0;
		return Qo = 0, e;
	}
	function cs(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function ls(e) {
		if (Yo) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			Yo = !1;
		}
		Jo = 0, L = I = F = null, Xo = !1, $o = Qo = 0, es = null;
	}
	function us() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return L === null ? F.memoizedState = L = e : L = L.next = e, L;
	}
	function z() {
		if (I === null) {
			var e = F.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = I.next;
		var t = L === null ? F.memoizedState : L.next;
		if (t !== null) L = t, I = e;
		else {
			if (e === null) throw F.alternate === null ? Error(i(467)) : Error(i(310));
			I = e, e = {
				memoizedState: I.memoizedState,
				baseState: I.baseState,
				baseQueue: I.baseQueue,
				queue: I.queue,
				next: null
			}, L === null ? F.memoizedState = L = e : L = L.next = e;
		}
		return L;
	}
	function ds() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function fs(e) {
		var t = $o;
		return $o += 1, es === null && (es = []), e = oo(es, e, t), t = F, (L === null ? t.memoizedState : L.next) === null && (t = t.alternate, E.H = t === null || t.memoizedState === null ? yc : bc), e;
	}
	function ps(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return fs(e);
			if (e.$$typeof === ye) return;
			if (e.$$typeof === w) return Ma(e);
		}
		throw Error(i(438, String(e)));
	}
	function ms(e) {
		var t = null, n = F.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = F.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = ds(), F.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = _e;
		return t.index++, n;
	}
	function hs(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function gs(e) {
		return _s(z(), I, e);
	}
	function _s(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (Jo & f) === f : (q & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === Ga && (d = !0);
					else if ((Jo & p) === p) {
						u = u.next, p === Ga && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, F.lanes |= p, sd |= p;
					f = u.action, Zo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, F.lanes |= f, sd |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !Yr(o, e.memoizedState) && (B = !0, d && (n = Ka, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function vs(e) {
		var t = z(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			Yr(o, t.memoizedState) || (B = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function ys(e, t, n) {
		var r = F, a = z(), o = N;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !Yr((I || a).memoizedState, n);
		if (s && (a.memoizedState = n, B = !0), a = a.queue, Ws(Ss.bind(null, r, a, e), [e]), e = a.getSnapshot !== t || s || L !== null && !!(L.memoizedState.tag & 1), zs(e ? 9 : 8, { destroy: void 0 }, xs.bind(null, r, a, n, t), null), e) {
			if (r.flags |= 2048, G === null) throw Error(i(349));
			o || Jo & 127 || bs(r, t, n);
		}
		return n;
	}
	function bs(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = F.updateQueue, t === null ? (t = ds(), F.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function xs(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Cs(t) && ws(e);
	}
	function Ss(e, t, n) {
		return n(function() {
			Cs(t) && ws(e);
		});
	}
	function Cs(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !Yr(e, n);
		} catch {
			return !0;
		}
	}
	function ws(e) {
		var t = Fi(e, 2);
		t !== null && Pd(t, e, 2);
	}
	function Ts(e) {
		var t = us();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), Zo) {
				at(!0);
				try {
					n();
				} finally {
					at(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: hs,
			lastRenderedState: e
		}, t;
	}
	function Es(e, t, n, r) {
		return e.baseState = n, _s(e, I, typeof r == "function" ? r : hs);
	}
	function Ds(e, t, n, r, a) {
		if (hc(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			E.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Os(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Os(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = E.T, o = {};
			o.types = a === null ? null : a.types, E.T = o;
			try {
				var s = n(i, r), c = E.S;
				c !== null && c(o, s), ks(e, t, s);
			} catch (n) {
				js(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), E.T = a;
			}
		} else try {
			a = n(i, r), ks(e, t, a);
		} catch (n) {
			js(e, t, n);
		}
	}
	function ks(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			As(e, t, n);
		}, function(n) {
			return js(e, t, n);
		}) : As(e, t, n);
	}
	function As(e, t, n) {
		t.status = "fulfilled", t.value = n, Ms(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Os(e, n)));
	}
	function js(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, Ms(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function Ms(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function Ns(e, t) {
		return t;
	}
	function Ps(e, t) {
		if (N) {
			var n = G.formState;
			if (n !== null) {
				a: {
					var r = F;
					if (N) {
						if (M) {
							b: {
								for (var i = M, a = pa; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = lm(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								M = lm(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						ha(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = us(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Ns,
			lastRenderedState: t
		}, n.queue = r, n = fc.bind(null, F, r), r.dispatch = n, r = Ts(!1), a = mc.bind(null, F, !1, r.queue), r = us(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Ds.bind(null, F, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function Fs(e) {
		return Is(z(), I, e);
	}
	function Is(e, t, n) {
		if (t = _s(e, t, Ns)[0], e = gs(hs)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = fs(t);
		} catch (e) {
			throw e === to ? ro : e;
		}
		else r = t;
		t = z();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (F.flags |= 2048, zs(9, { destroy: void 0 }, Ls.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function Ls(e, t) {
		e.action = t;
	}
	function Rs(e) {
		var t = z(), n = I;
		if (n !== null) return Is(t, n, e);
		z(), t = t.memoizedState, n = z();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function zs(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = F.updateQueue, t === null && (t = ds(), F.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function Bs() {
		return z().memoizedState;
	}
	function Vs(e, t, n, r) {
		var i = us();
		F.flags |= e, i.memoizedState = zs(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function Hs(e, t, n, r) {
		var i = z();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		I !== null && r !== null && ns(r, I.memoizedState.deps) ? i.memoizedState = zs(t, a, n, r) : (F.flags |= e, i.memoizedState = zs(1 | t, a, n, r));
	}
	function Us(e, t) {
		Vs(8390656, 8, e, t);
	}
	function Ws(e, t) {
		Hs(2048, 8, e, t);
	}
	function Gs(e) {
		F.flags |= 4;
		var t = F.updateQueue;
		if (t === null) t = ds(), F.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function Ks(e) {
		var t = z().memoizedState;
		return Gs({
			ref: t,
			nextImpl: e
		}), function() {
			if (W & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function qs(e, t) {
		return Hs(4, 2, e, t);
	}
	function Js(e, t) {
		return Hs(4, 4, e, t);
	}
	function Ys(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function Xs(e, t, n) {
		n = n == null ? null : n.concat([e]), Hs(4, 4, Ys.bind(null, t, e), n);
	}
	function Zs() {}
	function Qs(e, t) {
		var n = z();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && ns(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function $s(e, t) {
		var n = z();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && ns(t, r[1])) return r[0];
		if (r = e(), Zo) {
			at(!0);
			try {
				e();
			} finally {
				at(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function ec(e, t, n) {
		return n === void 0 || Jo & 1073741824 && !(q & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = Md(), F.lanes |= e, sd |= e, n);
	}
	function tc(e, t, n, r) {
		return Yr(n, t) ? n : Mo.current === null ? !(Jo & 106) || Jo & 1073741824 && !(q & 261930) ? (B = !0, e.memoizedState = n) : (e = Md(), F.lanes |= e, sd |= e, t) : (e = ec(e, n, r), Yr(e, t) || (B = !0), e);
	}
	function nc(e, t, n, r, i) {
		var a = D.p;
		D.p = a !== 0 && 8 > a ? a : 8;
		var o = E.T, s = {};
		s.types = o === null ? null : o.types, E.T = s, mc(e, !1, t, n);
		try {
			var c = i(), l = E.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? pc(e, t, Ya(c, r), jd(e)) : pc(e, t, r, jd(e));
		} catch (n) {
			pc(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, jd());
		} finally {
			D.p = a, o !== null && s.types !== null && (o.types = s.types), E.T = o;
		}
	}
	function rc() {}
	function ic(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = ac(e).queue;
		nc(e, a, t, Te, n === null ? rc : function() {
			return oc(e), n(r);
		});
	}
	function ac(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: Te,
			baseState: Te,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: hs,
				lastRenderedState: Te
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: hs,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function oc(e) {
		var t = ac(e);
		t.next === null && (t = e.alternate.memoizedState), pc(e, t.next.queue, {}, jd());
	}
	function sc() {
		return Ma(sh);
	}
	function cc() {
		return z().memoizedState;
	}
	function lc() {
		return z().memoizedState;
	}
	function uc(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = jd();
					e = Co(n);
					var r = wo(t, e, n);
					r !== null && (Pd(r, t, n), To(r, t, n)), t = { cache: Ra() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function dc(e, t, n) {
		var r = jd();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, hc(e) ? gc(t, n) : (n = Pi(e, t, n, r), n !== null && (Pd(n, e, r), _c(n, t, r)));
	}
	function fc(e, t, n) {
		pc(e, t, n, jd());
	}
	function pc(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (hc(e)) gc(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, Yr(s, o)) return Ni(e, t, i, 0), G === null && Mi(), !1;
			} catch {}
			if (n = Pi(e, t, i, r), n !== null) return Pd(n, e, r), _c(n, t, r), !0;
		}
		return !1;
	}
	function mc(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: Pf(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, hc(e)) {
			if (t) throw Error(i(479));
		} else t = Pi(e, n, r, 2), t !== null && Pd(t, e, 2);
	}
	function hc(e) {
		var t = e.alternate;
		return e === F || t !== null && t === F;
	}
	function gc(e, t) {
		Xo = Yo = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function _c(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Ct(e, n);
		}
	}
	var vc = {
		readContext: Ma,
		use: ps,
		useCallback: R,
		useContext: R,
		useEffect: R,
		useImperativeHandle: R,
		useLayoutEffect: R,
		useInsertionEffect: R,
		useMemo: R,
		useReducer: R,
		useRef: R,
		useState: R,
		useDebugValue: R,
		useDeferredValue: R,
		useTransition: R,
		useSyncExternalStore: R,
		useId: R,
		useHostTransitionStatus: R,
		useFormState: R,
		useActionState: R,
		useOptimistic: R,
		useMemoCache: R,
		useCacheRefresh: R,
		useEffectEvent: R
	}, yc = {
		readContext: Ma,
		use: ps,
		useCallback: function(e, t) {
			return us().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Ma,
		useEffect: Us,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), Vs(4194308, 4, Ys.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return Vs(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			Vs(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = us();
			t = t === void 0 ? null : t;
			var r = e();
			if (Zo) {
				at(!0);
				try {
					e();
				} finally {
					at(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = us();
			if (n !== void 0) {
				var i = n(t);
				if (Zo) {
					at(!0);
					try {
						n(t);
					} finally {
						at(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = dc.bind(null, F, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = us();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Ts(e);
			var t = e.queue, n = fc.bind(null, F, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: Zs,
		useDeferredValue: function(e, t) {
			return ec(us(), e, t);
		},
		useTransition: function() {
			var e = Ts(!1);
			return e = nc.bind(null, F, e.queue, !0, !1), us().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = F, a = us();
			if (N) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), G === null) throw Error(i(349));
				q & 127 || bs(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, Us(Ss.bind(null, r, o, e), [e]), r.flags |= 2048, zs(9, { destroy: void 0 }, xs.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = us(), t = G.identifierPrefix;
			if (N) {
				var n = aa, r = ia;
				n = (r & ~(1 << 32 - ot(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = Qo++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = ts++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: sc,
		useFormState: Ps,
		useActionState: Ps,
		useOptimistic: function(e) {
			var t = us();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = mc.bind(null, F, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: ms,
		useCacheRefresh: function() {
			return us().memoizedState = uc.bind(null, F);
		},
		useEffectEvent: function(e) {
			var t = us(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (W & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, bc = {
		readContext: Ma,
		use: ps,
		useCallback: Qs,
		useContext: Ma,
		useEffect: Ws,
		useImperativeHandle: Xs,
		useInsertionEffect: qs,
		useLayoutEffect: Js,
		useMemo: $s,
		useReducer: gs,
		useRef: Bs,
		useState: function() {
			return gs(hs);
		},
		useDebugValue: Zs,
		useDeferredValue: function(e, t) {
			return tc(z(), I.memoizedState, e, t);
		},
		useTransition: function() {
			var e = gs(hs)[0], t = z().memoizedState;
			return [typeof e == "boolean" ? e : fs(e), t];
		},
		useSyncExternalStore: ys,
		useId: cc,
		useHostTransitionStatus: sc,
		useFormState: Fs,
		useActionState: Fs,
		useOptimistic: function(e, t) {
			return Es(z(), I, e, t);
		},
		useMemoCache: ms,
		useCacheRefresh: lc,
		useEffectEvent: Ks
	}, xc = {
		readContext: Ma,
		use: ps,
		useCallback: Qs,
		useContext: Ma,
		useEffect: Ws,
		useImperativeHandle: Xs,
		useInsertionEffect: qs,
		useLayoutEffect: Js,
		useMemo: $s,
		useReducer: vs,
		useRef: Bs,
		useState: function() {
			return vs(hs);
		},
		useDebugValue: Zs,
		useDeferredValue: function(e, t) {
			var n = z();
			return I === null ? ec(n, e, t) : tc(n, I.memoizedState, e, t);
		},
		useTransition: function() {
			var e = vs(hs)[0], t = z().memoizedState;
			return [typeof e == "boolean" ? e : fs(e), t];
		},
		useSyncExternalStore: ys,
		useId: cc,
		useHostTransitionStatus: sc,
		useFormState: Rs,
		useActionState: Rs,
		useOptimistic: function(e, t) {
			var n = z();
			return I === null ? (n.baseState = e, [e, n.queue.dispatch]) : Es(n, I, e, t);
		},
		useMemoCache: ms,
		useCacheRefresh: lc,
		useEffectEvent: Ks
	};
	function Sc(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : S({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Cc = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = jd(), i = Co(r);
			i.payload = t, n != null && (i.callback = n), t = wo(e, i, r), t !== null && (Pd(t, e, r), To(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = jd(), i = Co(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = wo(e, i, r), t !== null && (Pd(t, e, r), To(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = jd(), r = Co(n);
			r.tag = 2, t != null && (r.callback = t), t = wo(e, r, n), t !== null && (Pd(t, e, n), To(t, e, n));
		}
	};
	function wc(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !Xr(n, r) || !Xr(i, a) : !0;
	}
	function Tc(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Cc.enqueueReplaceState(t, t.state, null);
	}
	function Ec(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = S({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Dc(e) {
		Oi(e);
	}
	function Oc(e) {
		console.error(e);
	}
	function kc(e) {
		Oi(e);
	}
	function Ac(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function jc(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Mc(e, t, n) {
		return n = Co(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Ac(e, t);
		}, n;
	}
	function Nc(e) {
		return e = Co(e), e.tag = 3, e;
	}
	function Pc(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				jc(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			jc(t, n, r), typeof i != "function" && (yd === null ? yd = /* @__PURE__ */ new Set([this]) : yd.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function Fc(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && ka(t, n, a, !0), n = Lo.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13:
					case 19: return Ro === null ? Kd() : n.alternate === null && Y === 0 && (Y = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === io ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = /* @__PURE__ */ new Set([r]) : t.add(r), mf(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === io ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: /* @__PURE__ */ new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = /* @__PURE__ */ new Set([r]) : n.add(r)), mf(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return mf(e, r, a), Kd(), !1;
		}
		if (N) return t = Lo.current, t === null ? (r !== ma && (t = Error(i(423), { cause: r }), xa(Xi(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = Xi(r, n), a = Mc(e.stateNode, r, a), Eo(e, a), Y !== 4 && (Y = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== ma && (e = Error(i(422), { cause: r }), xa(Xi(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = Xi(o, n), fd === null ? fd = [o] : fd.push(o), Y !== 4 && (Y = 2), t === null) return !0;
		r = Xi(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = Mc(n.stateNode, r, e), Eo(n, e), !1;
				case 1:
					if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (yd === null || !yd.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = Nc(a), Pc(a, e, n, r), Eo(n, a), !1;
					break;
				case 22: if (n.memoizedState !== null) return n.flags |= 65536, !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var Ic = Error(i(461)), B = !1;
	function Lc(e, t, n, r) {
		t.child = e === null ? yo(t, null, n, r) : vo(t, e.child, n, r);
	}
	function Rc(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return ja(t), r = rs(e, t, n, o, a, i), s = ss(), e !== null && !B ? (cs(e, t, i), fl(e, t, i)) : (N && s && ca(t), t.flags |= 1, Lc(e, t, r, i), t.child);
	}
	function zc(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !Vi(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, Bc(e, t, a, r, i)) : (e = Wi(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !pl(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? Xr : n, n(o, r) && e.ref === t.ref) return fl(e, t, i);
		}
		return t.flags |= 1, e = Hi(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function Bc(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (Xr(a, r) && e.ref === t.ref) {
				if (B = !1, t.pendingProps = r = a, pl(e, i)) e.flags & 131072 && (B = !0);
				else return t.lanes = e.lanes, fl(e, t, i);
			}
		}
		return Jc(e, t, n, r, i);
	}
	function Vc(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return Uc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && $a(t, a === null ? null : a.cachePool), a === null ? Fo() : Po(t, a), Vo(t);
			else return r = t.lanes = 536870912, Uc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && $a(t, null), Fo(), Ho()) : ($a(t, a.cachePool), Po(t, a), Ho(), t.memoizedState = null);
		return Lc(e, t, i, n), t.child;
	}
	function Hc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function Uc(e, t, n, r, i) {
		var a = Qa();
		return a = a === null ? null : {
			parent: P._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && $a(t, null), Fo(), Vo(t), e !== null && ka(e, t, r, !0), t.childLanes = i, null;
	}
	function Wc(e, t) {
		return t = rl({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function Gc(e, t, n) {
		return vo(t, e.child, null, n), e = Wc(t, t.pendingProps), e.flags |= 2, Uo(t), t.memoizedState = null, e;
	}
	function Kc(e, t, n) {
		var r = t.pendingProps, a = !!(t.flags & 128);
		if (t.flags &= -129, e === null) {
			if (N) {
				if (r.mode === "hidden") return e = Wc(t, r), t.lanes = 536870912, e.memoizedState = {
					baseLanes: 0,
					cachePool: null
				}, Hc(null, e);
				if (Bo(t), (e = M) ? (e = am(e, pa), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: ra === null ? null : {
						id: ia,
						overflow: aa
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = qi(e), n.return = t, t.child = n, da = t, M = null)) : e = null, e === null) throw ha(t);
				return t.lanes = 536870912, null;
			}
			return Wc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (Bo(t), a) {
				if (t.flags & 256) t.flags &= -257, t = Gc(e, t, n);
				else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
				else throw Error(i(558));
			} else if (B || ka(e, t, n, !1), a = (n & e.childLanes) !== 0, B || a) {
				if (Mo.current === null) {
					if (r = G, r !== null && (s = wt(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, Fi(e, s), Pd(r, e, s), Ic;
					Kd();
				}
				t = Gc(e, t, n);
			} else e = o.treeContext, M = lm(s.nextSibling), da = t, N = !0, fa = null, pa = !1, e !== null && ua(t, e), t = Wc(t, r), t.flags |= 134221824;
			return t;
		}
		return e = Hi(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function qc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function Jc(e, t, n, r, i) {
		return ja(t), n = rs(e, t, n, r, void 0, i), r = ss(), e !== null && !B ? (cs(e, t, i), fl(e, t, i)) : (N && r && ca(t), t.flags |= 1, Lc(e, t, n, i), t.child);
	}
	function Yc(e, t, n, r, i, a) {
		return ja(t), t.updateQueue = null, n = as(t, r, n, i), is(e), r = ss(), e !== null && !B ? (cs(e, t, a), fl(e, t, a)) : (N && r && ca(t), t.flags |= 1, Lc(e, t, n, a), t.child);
	}
	function Xc(e, t, n, r, i) {
		if (ja(t), t.stateNode === null) {
			var a = Ri, o = n.contextType;
			typeof o == "object" && o && (a = Ma(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Cc, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, xo(t), o = n.contextType, a.context = typeof o == "object" && o ? Ma(o) : Ri, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Sc(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Cc.enqueueReplaceState(a, a.state, null), ko(t, r, a, i), Oo(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Ec(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = Ri, typeof u == "object" && u && (o = Ma(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Tc(t, a, r, o), bo = !1;
			var f = t.memoizedState;
			a.state = f, ko(t, r, a, i), Oo(), l = t.memoizedState, s || f !== l || bo ? (typeof d == "function" && (Sc(t, n, d, r), l = t.memoizedState), (c = bo || wc(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, So(e, t), o = t.memoizedProps, u = Ec(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = Ri, typeof l == "object" && l && (c = Ma(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Tc(t, a, r, c), bo = !1, f = t.memoizedState, a.state = f, ko(t, r, a, i), Oo();
			var p = t.memoizedState;
			o !== d || f !== p || bo || e !== null && e.dependencies !== null && Aa(e.dependencies) ? (typeof s == "function" && (Sc(t, n, s, r), p = t.memoizedState), (u = bo || wc(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Aa(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, qc(e, t), r = !!(t.flags & 128), a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = vo(t, e.child, null, i), t.child = vo(t, null, n, i)) : Lc(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = fl(e, t, i), e;
	}
	function Zc(e, t, n, r) {
		return ya(), t.flags |= 256, Lc(e, t, n, r), t.child;
	}
	var Qc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function $c(e) {
		return {
			baseLanes: e,
			cachePool: eo()
		};
	}
	function el(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= ud), e;
	}
	function tl(e, t, n) {
		var r = t.pendingProps, i = !1, a = !!(t.flags & 128), o;
		if ((o = a) || (o = e !== null && e.memoizedState === null ? !1 : !!(Wo.current & 2)), o && (i = !0, t.flags &= -129), o = !!(t.flags & 32), t.flags &= -33, e === null) {
			if (N) {
				if (i ? zo(t) : Ho(), (e = M) ? (e = am(e, pa), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: ra === null ? null : {
						id: ia,
						overflow: aa
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = qi(e), n.return = t, t.child = n, da = t, M = null)) : e = null, e === null) throw ha(t);
				return t.lanes = sm(e) ? 32 : 536870912, null;
			}
			return a = r.children, r = r.fallback, i ? (Ho(), i = t.mode, a = rl({
				mode: "hidden",
				children: a
			}, i), r = Gi(r, i, n, null), a.return = t, r.return = t, a.sibling = r, t.child = a, r = t.child, r.memoizedState = $c(n), r.childLanes = el(e, o, n), t.memoizedState = Qc, Hc(null, r)) : (zo(t), nl(t, a));
		}
		var s = e.memoizedState;
		if (s !== null) {
			var c = s.dehydrated;
			if (c !== null) return al(e, t, a, o, r, c, s, n);
		}
		return i ? (Ho(), i = r.fallback, a = t.mode, s = e.child, c = s.sibling, r = Hi(s, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = s.subtreeFlags & 1206910976, c === null ? (i = Gi(i, a, n, null), i.flags |= 2) : i = Hi(c, i), i.return = t, r.return = t, r.sibling = i, t.child = r, Hc(null, r), r = t.child, i = e.child.memoizedState, i === null ? i = $c(n) : (a = i.cachePool, a === null ? a = eo() : (s = P._currentValue, a = a.parent === s ? a : {
			parent: s,
			pool: s
		}), i = {
			baseLanes: i.baseLanes | n,
			cachePool: a
		}), r.memoizedState = i, r.childLanes = el(e, o, n), t.memoizedState = Qc, Hc(e.child, r)) : (zo(t), n = e.child, e = n.sibling, n = Hi(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (o = t.deletions, o === null ? (t.deletions = [e], t.flags |= 16) : o.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function nl(e, t) {
		return t = rl({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function rl(e, t) {
		return e = Bi(22, e, null, t), e.lanes = 0, e;
	}
	function il(e, t, n) {
		return vo(t, e.child, null, n), e = nl(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function al(e, t, n, r, a, o, s, c) {
		if (n) return t.flags & 256 ? (zo(t), t.flags &= -257, il(e, t, c)) : t.memoizedState === null ? (Ho(), o = a.fallback, s = t.mode, a = rl({
			mode: "visible",
			children: a.children
		}, s), o = Gi(o, s, c, null), o.flags |= 2, a.return = t, o.return = t, a.sibling = o, t.child = a, vo(t, e.child, null, c), a = t.child, a.memoizedState = $c(c), a.childLanes = el(e, r, c), t.memoizedState = Qc, Hc(null, a)) : (Ho(), t.child = e.child, t.flags |= 128, null);
		if (zo(t), sm(o)) {
			if (r = o.nextSibling && o.nextSibling.dataset, r) var l = r.dgst;
			return r = l, r !== "" && (a = Error(i(419)), a.stack = "", a.digest = r, xa({
				value: a,
				source: null,
				stack: null
			})), il(e, t, c);
		}
		if (B || ka(e, t, c, !1), r = (c & e.childLanes) !== 0, B || r) {
			if (Mo.current !== null) return il(e, t, c);
			if (r = G, r !== null && (a = wt(r, c), a !== 0 && a !== s.retryLane)) throw s.retryLane = a, Fi(e, a), Pd(r, e, a), Ic;
			return om(o) || Kd(), il(e, t, c);
		}
		return om(o) ? (t.flags |= 192, t.child = e.child, null) : (e = s.treeContext, M = lm(o.nextSibling), da = t, N = !0, fa = null, pa = !1, e !== null && ua(t, e), t = nl(t, a.children), t.flags |= 134221824, t);
	}
	function ol(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Da(e.return, t, n);
	}
	function sl(e) {
		for (var t = null; e !== null;) {
			var n = e.alternate;
			n !== null && qo(n) === null && (t = e), e = e.sibling;
		}
		return t;
	}
	function cl(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function ll(e) {
		var t = e.child;
		for (e.child = null; t !== null;) {
			var n = t.sibling;
			t.sibling = e.child, e.child = t, t = n;
		}
	}
	function ul(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = Wo.current;
		if (t.flags & 128) return Go(t, o), null;
		var s = !!(o & 2);
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, Go(t, o), i === "backwards" && e !== null ? (ll(e), Lc(e, t, r, n), ll(e)) : Lc(e, t, r, n), r = N ? ea : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && ol(e, n, t);
			else if (e.tag === 19) ol(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "backwards":
				n = sl(t.child), n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null, ll(t)), cl(t, !0, i, null, a, r);
				break;
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && qo(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				cl(t, !0, n, null, a, r);
				break;
			case "together":
				cl(t, !1, null, null, void 0, r);
				break;
			case "independent":
				t.memoizedState = null;
				break;
			default: n = sl(t.child), n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), cl(t, !1, i, n, a, r);
		}
		return t.child;
	}
	function dl(e, t, n) {
		var r = t.pendingProps;
		return Ta(t, t.type, r.value), Lc(e, t, r.children, n), t.child;
	}
	function fl(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), sd |= t.lanes, (n & t.childLanes) === 0) {
			if (e !== null) {
				if (ka(e, t, n, !1), (n & t.childLanes) === 0) return null;
			} else return null;
		}
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = Hi(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = Hi(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function pl(e, t) {
		return (e.lanes & t) !== 0 || (e = e.dependencies, !!(e !== null && Aa(e)));
	}
	function ml(e, t, n) {
		switch (t.tag) {
			case 3:
				Me(t, t.stateNode.containerInfo), Ta(t, P, e.memoizedState.cache), ya();
				break;
			case 27:
			case 5:
				Pe(t);
				break;
			case 4:
				Me(t, t.stateNode.containerInfo);
				break;
			case 10:
				Ta(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, Bo(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) {
					if (r.dehydrated !== null) return zo(t), t.flags |= 128, null;
					r = ka(e, t, n, !1);
					var i = t.child.childLanes;
					return r || (n & i) !== 0 ? tl(e, t, n) : (zo(t), e = fl(e, t, n), e === null ? null : e.sibling);
				}
				zo(t);
				break;
			case 19:
				if (t.flags & 128) return ul(e, t, n);
				if (i = !!(e.flags & 128), r = (n & t.childLanes) !== 0, r ||= (ka(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return ul(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), Go(t, Wo.current), r) break;
				return null;
			case 22: return t.lanes = 0, Vc(e, t, n, t.pendingProps);
			case 24: Ta(t, P, e.memoizedState.cache);
		}
		return fl(e, t, n);
	}
	function hl(e, t, n) {
		if (e !== null) {
			if (e.memoizedProps !== t.pendingProps) B = !0;
			else {
				if (!pl(e, n) && !(t.flags & 128)) return B = !1, ml(e, t, n);
				B = !!(e.flags & 131072);
			}
		} else B = !1, N && t.flags & 1048576 && sa(t, ea, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = so(t.elementType), t.type = e, typeof e == "function") Vi(e) ? (r = Ec(e, r), t.tag = 1, t = Xc(null, t, e, r, n)) : (t.tag = 0, t = Jc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === T) {
								t.tag = 11, t = Rc(null, t, e, r, n);
								break a;
							}
							if (a === pe) {
								t.tag = 14, t = zc(null, t, e, r, n);
								break a;
							}
							if (a === w) {
								t.tag = 10, t.type = e, t = dl(null, t, n);
								break a;
							}
						}
						throw t = Ce(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return Jc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = Ec(r, t.pendingProps), Xc(e, t, r, a, n);
			case 3:
				a: {
					if (Me(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, So(e, t), ko(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Ta(t, P, r), r !== o.cache && Oa(t, [P], n, !0), Oo(), r = s.element, o.isDehydrated) {
						if (o = {
							element: r,
							isDehydrated: !1,
							cache: s.cache
						}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
							t = Zc(e, t, r, n);
							break a;
						}
						if (r !== a) {
							a = Xi(Error(i(424)), t), xa(a), t = Zc(e, t, r, n);
							break a;
						}
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (M = lm(e.firstChild), da = t, N = !0, fa = null, pa = !0, n = yo(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 134221824, n = n.sibling;
					} else {
						if (ya(), r === a) {
							t = fl(e, t, n);
							break a;
						}
						Lc(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return qc(e, t), e === null ? (n = Nm(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : N || (t.stateNode = fp(t.type, t.pendingProps, Ae.current, t)) : t.memoizedState = Nm(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return Pe(t), e === null && N && (r = t.stateNode = hm(t.type, t.pendingProps, Ae.current), da = t, pa = !0, a = M, Sp(t.type) ? (um = a, M = lm(r.firstChild)) : M = a), Lc(e, t, t.pendingProps.children, n), qc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && N && ((a = r = M) && (r = rm(r, t.type, t.pendingProps, pa), r === null ? a = !1 : (t.stateNode = r, da = t, M = lm(r.firstChild), pa = !1, a = !0)), a || ha(t)), Pe(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, pp(a, o) ? r = null : s !== null && pp(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = rs(e, t, os, null, null, n), sh._currentValue = a), qc(e, t), Lc(e, t, r, n), t.child;
			case 6: return e === null && N && ((e = n = M) && (n = im(n, t.pendingProps, pa), n === null ? e = !1 : (t.stateNode = n, da = t, M = null, e = !0)), e || ha(t)), null;
			case 13: return tl(e, t, n);
			case 4: return Me(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = vo(t, null, r, n) : Lc(e, t, r, n), t.child;
			case 11: return Rc(e, t, t.type, t.pendingProps, n);
			case 7: return r = t.pendingProps, qc(e, t), Lc(e, t, r, n), t.child;
			case 8: return Lc(e, t, t.pendingProps.children, n), t.child;
			case 12: return Lc(e, t, t.pendingProps.children, n), t.child;
			case 10: return dl(e, t, n);
			case 9: return a = t.type._context, r = t.pendingProps.children, ja(t), a = Ma(a), r = r(a), t.flags |= 1, Lc(e, t, r, n), t.child;
			case 14: return zc(e, t, t.type, t.pendingProps, n);
			case 15: return Bc(e, t, t.type, t.pendingProps, n);
			case 19: return ul(e, t, n);
			case 31: return Kc(e, t, n);
			case 22: return Vc(e, t, n, t.pendingProps);
			case 24: return ja(t), r = Ma(P), e === null ? (a = Qa(), a === null && (a = G, o = Ra(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, xo(t), Ta(t, P, a)) : ((e.lanes & n) !== 0 && (So(e, t), ko(t, null, null, n), Oo()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, Ta(t, P, r), r !== a.cache && Oa(t, [P], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), Ta(t, P, r))), Lc(e, t, t.pendingProps.children, n), t.child;
			case 30: return t.stateNode === null && (t.stateNode = {
				autoName: null,
				paired: null,
				clones: null,
				ref: null
			}), r = t.pendingProps, r.name != null && r.name !== "auto" ? t.flags |= e === null ? 18882560 : 18874368 : N && ca(t), e !== null && e.memoizedProps.name !== r.name ? t.flags |= 4194816 : qc(e, t), Lc(e, t, r.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function gl(e) {
		e.flags |= 4;
	}
	function _l(e, t, n, r, i) {
		var a;
		if ((a = !!(e.mode & 32)) && (a = n === null ? Jm(t, r) : Jm(t, r) && (r.src !== n.src || r.srcSet !== n.srcSet)), a) {
			if (e.flags |= 16777216, (i & 335544128) === i) {
				if (e.stateNode.complete) e.flags |= 8192;
				else if (Ud()) e.flags |= 8192;
				else throw co = io, no;
			}
		} else e.flags &= -16777217;
	}
	function vl(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Ym(t)) {
			if (Ud()) e.flags |= 8192;
			else throw co = io, no;
		}
	}
	function yl(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : vt(), e.lanes |= t, dd |= t);
	}
	function bl(e, t) {
		if (!N) switch (e.tailMode) {
			case "visible": break;
			case "collapsed":
				for (var n = e.tail, r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
				break;
			default:
				for (t = e.tail, n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
		}
	}
	function V(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 1206910976, r |= i.flags & 1206910976, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function xl(e, t, n) {
		var r = t.pendingProps;
		switch (la(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return V(t), null;
			case 1: return V(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Ea(P), Ne(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (va(t) ? gl(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, ba())), V(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (gl(t), o === null ? (V(t), _l(t, a, null, r, n)) : (V(t), vl(t, o))) : o ? o === e.memoizedState ? (V(t), t.flags &= -16777217) : (gl(t), V(t), vl(t, o)) : (e = e.memoizedProps, e !== r && gl(t), V(t), _l(t, a, e, r, n)), null;
			case 27:
				if (Fe(t), n = Ae.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && gl(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return V(t), t.subtreeFlags &= -33554433, null;
					}
					e = Oe.current, va(t) ? ga(t, e) : (e = hm(a, r, n), t.stateNode = e, gl(t));
				}
				return V(t), t.subtreeFlags &= -33554433, null;
			case 5:
				if (Fe(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && gl(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return V(t), t.subtreeFlags &= -33554433, null;
					}
					if (o = Oe.current, va(t)) ga(t, o);
					else {
						var s = lp(Ae.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[At] = t, o[jt] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (np(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && gl(t);
					}
				}
				return V(t), t.subtreeFlags &= -33554433, _l(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && gl(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = Ae.current, va(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = da, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[At] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || ep(e.nodeValue, n)), e || ha(t, !0);
					} else e = lp(e).createTextNode(r), e[At] = t, t.stateNode = e;
				}
				return V(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = va(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[At] = t;
						} else ya(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						V(t), e = !1;
					} else n = ba(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (Uo(t), t) : (Uo(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return V(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = va(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[At] = t;
						} else ya(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						V(t), a = !1;
					} else a = ba(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (Uo(t), t) : (Uo(t), null);
				}
				return Uo(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), yl(t, t.updateQueue), V(t), null);
			case 4: return Ne(), e === null && Wf(t.stateNode.containerInfo), t.flags |= 67108864, V(t), null;
			case 10: return Ea(t.type), V(t), null;
			case 19:
				if (Ko(t), r = t.memoizedState, r === null) return V(t), null;
				if (a = !!(t.flags & 128), o = r.rendering, o === null) {
					if (a) bl(r, !1);
					else {
						if (Y !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
							if (o = qo(e), o !== null) {
								for (t.flags |= 128, bl(r, !1), e = o.updateQueue, t.updateQueue = e, yl(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) Ui(n, e), n = n.sibling;
								return Go(t, Wo.current & 1 | 2), N && oa(t, r.treeForkCount), t.child;
							}
							e = e.sibling;
						}
						r.tail !== null && Je() > _d && (t.flags |= 128, a = !0, bl(r, !1), t.lanes = 4194304);
					}
				} else {
					if (!a) {
						if (e = qo(o), e !== null) {
							if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, yl(t, e), bl(r, !0), r.tail === null && r.tailMode !== "collapsed" && r.tailMode !== "visible" && !o.alternate && !N) return V(t), null;
						} else 2 * Je() - r.renderingStartTime > _d && n !== 536870912 && (t.flags |= 128, a = !0, bl(r, !1), t.lanes = 4194304);
					}
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				if (r.tail !== null) {
					e = r.tail;
					a: {
						for (n = e; n !== null;) {
							if (n.alternate !== null) {
								n = !1;
								break a;
							}
							n = n.sibling;
						}
						n = !0;
					}
					return r.rendering = e, r.tail = e.sibling, r.renderingStartTime = Je(), e.sibling = null, o = Wo.current, o = a ? o & 1 | 2 : o & 1, r.tailMode === "visible" || r.tailMode === "collapsed" || !n || N ? Go(t, o) : (n = o, A(Lo, t), A(Wo, n), Ro === null && (Ro = t)), N && oa(t, r.treeForkCount), e;
				}
				return V(t), null;
			case 22:
			case 23: return Uo(t), Io(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (V(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : V(t), n = t.updateQueue, n !== null && yl(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && k(Za), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Ea(P), V(t), null;
			case 25: return null;
			case 30: return t.flags |= 33554432, V(t), null;
		}
		throw Error(i(156, t.tag));
	}
	function Sl(e, t) {
		switch (la(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return Ea(P), Ne(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return Fe(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (Uo(t), t.alternate === null) throw Error(i(340));
					ya();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (Uo(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					ya();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return Ko(t), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, e = t.memoizedState, e !== null && (e.rendering = null, e.tail = null), t.flags |= 4, t) : null;
			case 4: return Ne(), null;
			case 10: return Ea(t.type), null;
			case 22:
			case 23: return Uo(t), Io(), e !== null && k(Za), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return Ea(P), null;
			case 25: return null;
			default: return null;
		}
	}
	function Cl(e, t) {
		switch (la(t), t.tag) {
			case 3:
				Ea(P), Ne();
				break;
			case 26:
			case 27:
			case 5:
				Fe(t);
				break;
			case 4:
				Ne();
				break;
			case 31:
				t.memoizedState !== null && Uo(t);
				break;
			case 13:
				Uo(t);
				break;
			case 19:
				Ko(t);
				break;
			case 10:
				Ea(t.type);
				break;
			case 22:
			case 23:
				Uo(t), Io(), e !== null && k(Za);
				break;
			case 24: Ea(P);
		}
	}
	function wl(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Tl(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Z(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function El(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				jo(t, n);
			} catch (t) {
				Z(e, e.return, t);
			}
		}
	}
	function Dl(e, t, n) {
		n.props = Ec(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Z(e, t, n);
		}
	}
	function Ol(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						var i = e.stateNode, a = Ti(e.memoizedProps, i);
						(i.ref === null || i.ref.name !== a) && (i.ref = Pp(a)), r = i.ref;
						break;
					case 7:
						if (e.stateNode === null) {
							var o = new Fp(e);
							m(e.child, !1, Qp, o, void 0, void 0), e.stateNode = o;
						}
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Z(e, t, n);
		}
	}
	function kl(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) {
			if (typeof r == "function") try {
				r();
			} catch (n) {
				Z(e, t, n);
			} finally {
				e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
			}
			else if (typeof n == "function") try {
				n(null);
			} catch (n) {
				Z(e, t, n);
			}
			else n.current = null;
		}
	}
	function Al(e, t) {
		if ((e.tag === 5 || e.tag === 27 || e.tag === 6) && e.alternate === null && t !== null) for (var n = 0; n < t.length; n++) em(e.stateNode, t[n]);
	}
	function jl(e) {
		for (var t = e.return; t !== null && (Pl(t) && em(e.stateNode, t.stateNode), !Nl(t));) t = t.return;
	}
	function Ml(e) {
		for (var t = e.return; t !== null && (Pl(t) && tm(e.stateNode, t.stateNode), !Nl(t));) t = t.return;
	}
	function Nl(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 27;
	}
	function Pl(e) {
		return e && e.tag === 7 && e.stateNode !== null;
	}
	function Fl(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Il(e, t, n) {
		try {
			var r = e.stateNode;
			ip(r, e.type, n, t), r[jt] = t;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Ll(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Sp(e.type) || e.tag === 4;
	}
	function Rl(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Ll(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Sp(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function zl(e, t, n, r) {
		var i = e.tag;
		if (i === 5 || i === 6) i = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(i, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(i), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = En)), Al(e, r), j = !0;
		else if (i !== 4 && (i === 27 && (Al(e, r), r = null, Sp(e.type) && (n = e.stateNode, t = null)), e = e.child, e !== null)) for (zl(e, t, n, r), e = e.sibling; e !== null;) zl(e, t, n, r), e = e.sibling;
	}
	function Bl(e, t, n, r) {
		var i = e.tag;
		if (i === 5 || i === 6) i = e.stateNode, t ? n.insertBefore(i, t) : n.appendChild(i), Al(e, r), j = !0;
		else if (i !== 4 && (i === 27 && (Al(e, r), r = null, Sp(e.type) && (n = e.stateNode)), e = e.child, e !== null)) for (Bl(e, t, n, r), e = e.sibling; e !== null;) Bl(e, t, n, r), e = e.sibling;
	}
	function Vl(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			np(t, r, n), t[At] = e, t[jt] = n;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	var Hl = !1, Ul = null;
	function Wl(e) {
		(e.tag === 30 || e.subtreeFlags & 33554432) && (Hl = !0);
	}
	var Gl = null;
	function Kl() {
		var e = Gl;
		return Gl = null, e;
	}
	var ql = 0;
	function Jl(e, t, n, r, i) {
		return ql = 0, Yl(e.child, t, n, r, i);
	}
	function Yl(e, t, n, r, i) {
		for (var a = !1; e !== null;) {
			if (e.tag === 5) {
				var o = e.stateNode;
				if (r !== null) {
					var s = Op(o);
					r.push(s), s.view && (a = !0);
				} else a || Op(o).view && (a = !0);
				Hl = !0, Tp(o, ql === 0 ? t : t + "_" + ql, n), ql++;
			} else (e.tag !== 22 || e.memoizedState === null) && (e.tag === 30 && i || Yl(e.child, t, n, r, i) && (a = !0));
			e = e.sibling;
		}
		return a;
	}
	function Xl(e, t) {
		for (; e !== null;) e.tag === 5 ? Ep(e.stateNode, e.memoizedProps) : (e.tag !== 22 || e.memoizedState === null) && (e.tag === 30 && t || Xl(e.child, t)), e = e.sibling;
	}
	function Zl(e) {
		if (e.subtreeFlags & 18874368) for (e = e.child; e !== null;) {
			if ((e.tag !== 22 || e.memoizedState === null) && (Zl(e), e.tag === 30 && e.flags & 18874368 && e.stateNode.paired)) {
				var t = e.memoizedProps;
				if (t.name == null || t.name === "auto") throw Error(i(544));
				var n = t.name;
				t = Di(t.default, t.share), t !== "none" && (Jl(e, n, t, null, !1) || Xl(e.child, !1));
			}
			e = e.sibling;
		}
	}
	function Ql(e, t) {
		if (e.tag === 30) {
			var n = e.stateNode, r = e.memoizedProps, i = Ti(r, n), a = Di(r.default, n.paired ? r.share : r.enter);
			a === "none" ? Zl(e) : Jl(e, i, a, null, !1) ? (Zl(e), n.paired || t || Nd(e, r.onEnter)) : Xl(e.child, !1);
		} else if (e.subtreeFlags & 33554432) for (e = e.child; e !== null;) Ql(e, t), e = e.sibling;
		else Zl(e);
	}
	function $l(e) {
		if (Ul !== null && Ul.size !== 0) {
			var t = Ul;
			if (e.subtreeFlags & 18874368) for (e = e.child; e !== null;) {
				if (e.tag !== 22 || e.memoizedState === null) {
					if (e.tag === 30 && e.flags & 18874368) {
						var n = e.memoizedProps, r = n.name;
						if (r != null && r !== "auto") {
							var i = t.get(r);
							if (i !== void 0) {
								var a = Di(n.default, n.share);
								if (a !== "none" && (Jl(e, r, a, null, !1) ? (a = e.stateNode, i.paired = a, a.paired = i, Nd(e, n.onShare)) : Xl(e.child, !1)), t.delete(r), t.size === 0) break;
							}
						}
					}
					$l(e);
				}
				e = e.sibling;
			}
		}
	}
	function eu(e) {
		if (e.tag === 30) {
			var t = e.memoizedProps, n = Ti(t, e.stateNode), r = Ul === null ? void 0 : Ul.get(n), i = Di(t.default, r === void 0 ? t.exit : t.share);
			i !== "none" && (Jl(e, n, i, null, !1) ? r === void 0 ? Nd(e, t.onExit) : (i = e.stateNode, r.paired = i, i.paired = r, Ul.delete(n), Nd(e, t.onShare)) : Xl(e.child, !1)), Ul !== null && $l(e);
		} else if (e.subtreeFlags & 33554432) for (e = e.child; e !== null;) eu(e), e = e.sibling;
		else Ul !== null && $l(e);
	}
	function tu(e) {
		for (e = e.child; e !== null;) {
			if (e.tag === 30) {
				var t = e.memoizedProps, n = Ti(t, e.stateNode);
				t = Di(t.default, t.update), e.flags &= -5, t !== "none" && Jl(e, n, t, e.memoizedState = [], !1);
			} else e.subtreeFlags & 33554432 && tu(e);
			e = e.sibling;
		}
	}
	function nu(e) {
		if (e.subtreeFlags & 18874368) for (e = e.child; e !== null;) {
			if (e.tag !== 22 || e.memoizedState === null) {
				if (e.tag === 30 && e.flags & 18874368) {
					var t = e.stateNode;
					t.paired !== null && (t.paired = null, Xl(e.child, !1));
				}
				nu(e);
			}
			e = e.sibling;
		}
	}
	function ru(e) {
		if (e.tag === 30) e.stateNode.paired = null, Xl(e.child, !1), nu(e);
		else if (e.subtreeFlags & 33554432) for (e = e.child; e !== null;) ru(e), e = e.sibling;
		else nu(e);
	}
	function iu(e) {
		for (e = e.child; e !== null;) e.tag === 30 ? Xl(e.child, !1) : e.subtreeFlags & 33554432 && iu(e), e = e.sibling;
	}
	function au(e, t, n, r, i, a, o) {
		for (var s = !1; t !== null;) {
			if (t.tag === 5) {
				var c = t.stateNode;
				if (a !== null && ql < a.length) {
					var l = a[ql], u = Op(c);
					(l.view || u.view) && (s = !0);
					var d;
					if (d = !(e.flags & 4)) {
						if (u.clip) d = !0;
						else {
							d = l.rect;
							var f = u.rect;
							d = d.y !== f.y || d.x !== f.x || d.height !== f.height || d.width !== f.width;
						}
					}
					d && (e.flags |= 4), u.abs ? u = !l.abs : (l = l.rect, u = u.rect, u = l.height !== u.height || l.width !== u.width), u && (e.flags |= 32);
				} else e.flags |= 32;
				e.flags & 4 && Tp(c, ql === 0 ? n : n + "_" + ql, i), s && e.flags & 4 || (Gl === null && (Gl = []), Gl.push(c, ql === 0 ? r : r + "_" + ql, t.memoizedProps)), ql++;
			} else (t.tag !== 22 || t.memoizedState === null) && (t.tag === 30 && o ? e.flags |= t.flags & 32 : au(e, t.child, n, r, i, a, o) && (s = !0));
			t = t.sibling;
		}
		return s;
	}
	function ou(e, t) {
		for (e = e.child; e !== null;) {
			if (e.tag === 30) {
				var n = e.memoizedProps, r = e.stateNode, i = Ti(n, r), a = Di(n.default, n.update);
				if (t) {
					r = r.clones;
					var o = r === null ? null : r.map(kp);
				} else o = e.memoizedState, e.memoizedState = null;
				r = e;
				var s = e.child;
				ql = 0, i = au(r, s, i, i, a, o, !1), e.flags & 4 && i && (t || Nd(e, n.onUpdate));
			} else e.subtreeFlags & 33554432 && ou(e, t);
			e = e.sibling;
		}
	}
	var su = !1, H = !1, cu = !1, lu = !1, uu = typeof WeakSet == "function" ? WeakSet : Set, du = null, fu = !1, pu = !1, mu = !1, hu = !1;
	function gu(e, t, n) {
		if (e = e.containerInfo, sp = gh, e = ti(e), ni(e)) {
			if ("selectionStart" in e) var r = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				r = (r = e.ownerDocument) && r.defaultView || window;
				var i = r.getSelection && r.getSelection();
				if (i && i.rangeCount !== 0) {
					r = i.anchorNode;
					var a = i.anchorOffset, o = i.focusNode;
					i = i.focusOffset;
					try {
						r.nodeType, o.nodeType;
					} catch {
						r = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== r || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || i !== 0 && f.nodeType !== 3 || (l = s + i), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === r && ++u === a && (c = s), p === o && ++d === i && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					r = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else r = null;
			}
			r ||= {
				start: 0,
				end: 0
			};
		} else r = null;
		for (cp = {
			focusedElem: e,
			selectionRange: r
		}, gh = !1, n = (n & 335544064) === n, du = t, t = n ? 9270 : 1024; du !== null;) {
			if (e = du, n && (r = e.deletions, r !== null)) for (a = 0; a < r.length; a++) n && eu(r[a]);
			if (e.alternate === null && e.flags & 2) n && Wl(e), _u(n);
			else {
				if (e.tag === 22) {
					if (r = e.alternate, e.memoizedState !== null) {
						r !== null && r.memoizedState === null && n && eu(r), _u(n);
						continue;
					}
					if (r !== null && r.memoizedState !== null) {
						n && Wl(e), _u(n);
						continue;
					}
				}
				r = e.child, (e.subtreeFlags & t) !== 0 && r !== null ? (r.return = e, du = r) : (n && tu(e), _u(n));
			}
		}
		Ul = null;
	}
	function _u(e) {
		for (; du !== null;) {
			var t = du, n = e, r = t.alternate, a = t.flags;
			switch (t.tag) {
				case 0:
				case 11:
				case 15: break;
				case 1:
					if (a & 1024 && r !== null) {
						n = void 0, a = r.memoizedProps, r = r.memoizedState;
						var o = t.stateNode;
						try {
							var s = Ec(t.type, a);
							n = o.getSnapshotBeforeUpdate(s, r), o.__reactInternalSnapshotBeforeUpdate = n;
						} catch (e) {
							Z(t, t.return, e);
						}
					}
					break;
				case 3:
					if (a & 1024) {
						if (r = t.stateNode.containerInfo, n = r.nodeType, n === 9) nm(r);
						else if (n === 1) switch (r.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								nm(r);
								break;
							default: r.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				case 30:
					n && r !== null && (n = Ti(r.memoizedProps, r.stateNode), a = t.memoizedProps, a = Di(a.default, a.update), a !== "none" && Jl(r, n, a, r.memoizedState = [], !0));
					break;
				default: if (a & 1024) throw Error(i(163));
			}
			if (r = t.sibling, r !== null) {
				r.return = t.return, du = r;
				break;
			}
			du = t.return;
		}
	}
	function vu(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				Lu(e, n), r & 4 && wl(5, n);
				break;
			case 1:
				if (Lu(e, n), r & 4) {
					if (e = n.stateNode, t === null) try {
						e.componentDidMount();
					} catch (e) {
						Z(n, n.return, e);
					}
					else {
						var i = Ec(n.type, t.memoizedProps);
						t = t.memoizedState;
						try {
							e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
						} catch (e) {
							Z(n, n.return, e);
						}
					}
				}
				r & 64 && El(n), r & 512 && Ol(n, n.return);
				break;
			case 3:
				if (Lu(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						jo(e, t);
					} catch (e) {
						Z(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && Vl(n);
			case 26:
			case 5:
				Lu(e, n), t === null && r & 4 && Fl(n), r & 512 && Ol(n, n.return);
				break;
			case 12:
				Lu(e, n);
				break;
			case 31:
				Lu(e, n), r & 4 && Eu(e, n);
				break;
			case 13:
				Lu(e, n), r & 4 && Du(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = _f.bind(null, n), cm(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || su, !r) {
					var a = t !== null && t.memoizedState !== null || H;
					t = su, i = H, su = r, (H = a) && !i ? (r = 2, n.subtreeFlags & 8772 && (r |= 1), zu(e, n, r)) : Lu(e, n), su = t, H = i;
				}
				break;
			case 30:
				Lu(e, n), r & 512 && Ol(n, n.return);
				break;
			case 7: r & 512 && Ol(n, n.return);
			default: Lu(e, n);
		}
	}
	function yu(e, t) {
		for (e = e.child; e !== null;) bu(e, t), e = e.sibling;
	}
	function bu(e, t) {
		switch (e.tag) {
			case 5:
			case 26:
				try {
					var n = e.stateNode;
					if (t) {
						var r = n.style;
						typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";
					} else {
						var i = e.stateNode, a = e.memoizedProps.style, o = a != null && a.hasOwnProperty("display") ? a.display : null;
						i.style.display = o == null || typeof o == "boolean" ? "" : ("" + o).trim();
					}
				} catch (t) {
					Z(e, e.return, t);
				}
				xu(e, t);
				break;
			case 6:
				try {
					e.stateNode.nodeValue = t ? "" : e.memoizedProps, j = !0;
				} catch (t) {
					Z(e, e.return, t);
				}
				break;
			case 18:
				try {
					var s = e.stateNode;
					t ? wp(s, !0) : wp(e.stateNode, !1);
				} catch (t) {
					Z(e, e.return, t);
				}
				break;
			case 22:
			case 23:
				e.memoizedState === null && yu(e, t);
				break;
			default: yu(e, t);
		}
	}
	function xu(e, t) {
		if (e.subtreeFlags & 67108864) for (e = e.child; e !== null;) {
			a: {
				var n = e, r = t;
				switch (n.tag) {
					case 4:
						bu(n, r);
						break a;
					case 22:
						n.memoizedState === null && xu(n, r);
						break a;
					default: xu(n, r);
				}
			}
			e = e.sibling;
		}
	}
	function Su(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, Su(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && zt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var U = null, Cu = !1;
	function wu(e, t, n) {
		for (n = n.child; n !== null;) Tu(e, t, n), n = n.sibling;
	}
	function Tu(e, t, n) {
		if (it && typeof it.onCommitFiberUnmount == "function") try {
			it.onCommitFiberUnmount(rt, n);
		} catch {}
		switch (n.tag) {
			case 26:
				H || kl(n, t), wu(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && !H && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				H || kl(n, t), Ml(n);
				var r = U, i = Cu;
				Sp(n.type) && (U = n.stateNode, Cu = !1), wu(e, t, n), gm(n.stateNode, n.type, n.memoizedProps), U = r, Cu = i;
				break;
			case 5: H || kl(n, t), Ml(n);
			case 6:
				if (n.tag === 6 && Ml(n), r = U, i = Cu, U = null, wu(e, t, n), U = r, Cu = i, U !== null) {
					if (Cu) try {
						(U.nodeType === 9 ? U.body : U.nodeName === "HTML" ? U.ownerDocument.body : U).removeChild(n.stateNode), j = !0;
					} catch (e) {
						Z(n, t, e);
					}
					else try {
						U.removeChild(n.stateNode), j = !0;
					} catch (e) {
						Z(n, t, e);
					}
				}
				break;
			case 18:
				U !== null && (Cu ? (e = U, Cp(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Hh(e)) : Cp(U, n.stateNode));
				break;
			case 4:
				r = U, i = Cu, U = n.stateNode.containerInfo, Cu = !0, wu(e, t, n), U = r, Cu = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Tl(2, n, t), H || Tl(4, n, t), wu(e, t, n);
				break;
			case 1:
				H || (kl(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Dl(n, t, r)), wu(e, t, n);
				break;
			case 21:
				wu(e, t, n);
				break;
			case 22:
				H = (r = H) || n.memoizedState !== null, wu(e, t, n), H = r;
				break;
			case 30:
				kl(n, t), wu(e, t, n);
				break;
			case 7:
				H || kl(n, t), wu(e, t, n);
				break;
			default: wu(e, t, n);
		}
	}
	function Eu(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Hh(e);
			} catch (e) {
				Z(t, t.return, e);
			}
		}
	}
	function Du(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Hh(e);
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Ou(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new uu()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new uu()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function ku(e, t) {
		var n = Ou(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = vf.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function Au(e, t, n) {
		var r = t.deletions;
		if (r !== null) for (var a = 0; a < r.length; a++) {
			var o = r[a], s = e, c = t, l = c;
			a: for (; l !== null;) {
				switch (l.tag) {
					case 27:
						if (Sp(l.type)) {
							U = l.stateNode, Cu = !1;
							break a;
						}
						break;
					case 5:
						U = l.stateNode, Cu = !1;
						break a;
					case 3:
					case 4:
						U = l.stateNode.containerInfo, Cu = !0;
						break a;
				}
				l = l.return;
			}
			if (U === null) throw Error(i(160));
			Tu(s, c, o), U = null, Cu = !1, s = o.alternate, s !== null && (s.return = null), o.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) Mu(t, e, n), t = t.sibling;
	}
	var ju = null;
	function Mu(e, t, n) {
		var r = e.alternate, a = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				if (a & 4 && (r = e.updateQueue, r = r === null ? null : r.events, r !== null)) for (var o = 0; o < r.length; o++) {
					var s = r[o];
					s.ref.impl = s.nextImpl;
				}
				Au(t, e, n), Nu(e), a & 4 && (Tl(3, e, e.return), wl(3, e), Tl(5, e, e.return));
				break;
			case 1:
				Au(t, e, n), Nu(e), a & 512 && (H || r === null || kl(r, r.return)), a & 64 && su && (e = e.updateQueue, e !== null && (t = e.callbacks, t !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? t : n.concat(t))));
				break;
			case 26:
				if (o = ju, Au(t, e, n), Nu(e), a & 512 && (H || r === null || kl(r, r.return)), a & 4) {
					if (a = r === null ? null : r.memoizedState, n = e.memoizedState, r === null) {
						if (n === null) {
							if (e.stateNode === null) {
								if (su) e.stateNode = fp(e.type, e.memoizedProps, t.containerInfo, e);
								else {
									a: {
										t = e.type, n = e.memoizedProps, a = o.ownerDocument || o;
										b: switch (t) {
											case "title":
												r = a.getElementsByTagName("title")[0], (!r || r[Lt] || r[At] || r.namespaceURI === "http://www.w3.org/2000/svg" || r.hasAttribute("itemprop")) && (r = a.createElement(t), a.head.insertBefore(r, a.querySelector("head > title"))), np(r, t, n), r[At] = e, Wt(r), t = r;
												break a;
											case "link":
												if (o = Gm("link", "href", a).get(t + (n.href || ""))) {
													for (s = 0; s < o.length; s++) if (r = o[s], r.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && r.getAttribute("rel") === (n.rel == null ? null : n.rel) && r.getAttribute("title") === (n.title == null ? null : n.title) && r.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
														o.splice(s, 1);
														break b;
													}
												}
												r = a.createElement(t), np(r, t, n), a.head.appendChild(r);
												break;
											case "meta":
												if (o = Gm("meta", "content", a).get(t + (n.content || ""))) {
													for (s = 0; s < o.length; s++) if (r = o[s], r.getAttribute("content") === (n.content == null ? null : "" + n.content) && r.getAttribute("name") === (n.name == null ? null : n.name) && r.getAttribute("property") === (n.property == null ? null : n.property) && r.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && r.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
														o.splice(s, 1);
														break b;
													}
												}
												r = a.createElement(t), np(r, t, n), a.head.appendChild(r);
												break;
											default: throw Error(i(468, t));
										}
										r[At] = e, Wt(r), t = r;
									}
									e.stateNode = t;
								}
							} else su || Km(o, e.type, e.stateNode);
						} else e.stateNode = Bm(o, n, e.memoizedProps);
					} else a === n ? n === null && e.stateNode !== null && Il(e, e.memoizedProps, r.memoizedProps) : (a === null ? (t = r.stateNode, t === null || H || t.parentNode.removeChild(t)) : a.count--, n === null ? su || Km(o, e.type, e.stateNode) : Bm(o, n, e.memoizedProps));
				}
				break;
			case 27:
				Au(t, e, n), Nu(e), a & 512 && (H || r === null || kl(r, r.return)), r !== null && a & 4 && Il(e, e.memoizedProps, r.memoizedProps);
				break;
			case 5:
				if (o = cu, cu = !1, Au(t, e, n), cu = o, Nu(e), a & 512 && (H || r === null || kl(r, r.return)), e.flags & 32) {
					t = e.stateNode;
					try {
						vn(t, ""), j = !0;
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				a & 4 && e.stateNode != null && (t = e.memoizedProps, Il(e, t, r === null ? t : r.memoizedProps)), a & 1024 && (lu = !0);
				break;
			case 6:
				if (Au(t, e, n), Nu(e), a & 4) {
					if (e.stateNode === null) throw Error(i(162));
					t = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = t, j = !0;
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				break;
			case 3:
				if (j = !1, Wm = null, o = ju, ju = bm(t.containerInfo), Au(t, e, n), ju = o, Nu(e), a & 4 && r !== null && r.memoizedState.isDehydrated) try {
					Hh(t.containerInfo);
				} catch (t) {
					Z(e, e.return, t);
				}
				lu && (lu = !1, Pu(e)), j = !1;
				break;
			case 4:
				a = cu, cu = su, r = en(), o = ju, ju = bm(e.stateNode.containerInfo), Au(t, e, n), Nu(e), ju = o, j && pu && (mu = !0), j = r, cu = a;
				break;
			case 12:
				Au(t, e, n), Nu(e);
				break;
			case 31:
				Au(t, e, n), Nu(e), a & 4 && (t = e.updateQueue, t !== null && (e.updateQueue = null, ku(e, t)));
				break;
			case 13:
				Au(t, e, n), Nu(e), e.child.flags & 8192 && e.memoizedState !== null != (r !== null && r.memoizedState !== null) && (hd = Je()), a & 4 && (t = e.updateQueue, t !== null && (e.updateQueue = null, ku(e, t)));
				break;
			case 22:
				o = e.memoizedState !== null, s = r !== null && r.memoizedState !== null;
				var c = su, l = H, u = cu;
				su = c || o, cu = u || o, H = l || s, Au(t, e, n), H = l, cu = u, su = c, Nu(e), a & 8192 && (t = e.stateNode, t._visibility = o ? t._visibility & -2 : t._visibility | 1, !o || r === null || s || su || H || (t = s || H, n = su, r = H, su = o || su, H = t, Ru(e, 2), su = n, H = r), !o && cu || yu(e, o)), a & 4 && (t = e.updateQueue, t !== null && (n = t.retryQueue, n !== null && (t.retryQueue = null, ku(e, n))));
				break;
			case 19:
				Au(t, e, n), Nu(e), a & 4 && (t = e.updateQueue, t !== null && (e.updateQueue = null, ku(e, t)));
				break;
			case 30:
				a & 512 && (H || r === null || kl(r, r.return)), a = en(), o = pu, s = (n & 335544064) === n, c = e.memoizedProps, pu = s && Di(c.default, c.update) !== "none", Au(t, e, n), Nu(e), s && r !== null && j && (e.flags |= 4), pu = o, j = a;
				break;
			case 21: break;
			case 7: a & 512 && (H || r === null || kl(r, r.return)), r && r.stateNode !== null && (r.stateNode._fragmentFiber = e);
			default: Au(t, e, n), Nu(e);
		}
	}
	function Nu(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (Ll(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				r = null;
				for (var a = e.return; a !== null;) {
					if (Pl(a)) {
						var o = a.stateNode;
						r === null ? r = [o] : r.push(o);
					}
					if (Nl(a)) break;
					a = a.return;
				}
				var s = r;
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var c = n.stateNode;
						Bl(e, Rl(e), c, s);
						break;
					case 5:
						var l = n.stateNode;
						n.flags & 32 && (vn(l, ""), n.flags &= -33), Bl(e, Rl(e), l, s);
						break;
					case 3:
					case 4:
						var u = n.stateNode.containerInfo;
						zl(e, Rl(e), u, s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Z(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function Pu(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			Pu(t), t.tag === 5 && t.flags & 1024 && (t = t.stateNode, gh = !0, t.reset(), gh = !1), e = e.sibling;
		}
	}
	function Fu(e, t) {
		if (t.subtreeFlags & 9270) for (t = t.child; t !== null;) Iu(t, e), t = t.sibling;
		else ou(t, !1);
	}
	function Iu(e, t) {
		var n = e.alternate;
		if (n === null) Ql(e, !1);
		else switch (e.tag) {
			case 3:
				if (hu = fu = !1, Kl(), Fu(t, e), !fu && !mu) {
					if (e = Gl, e !== null) for (var r = 0; r < e.length; r += 3) {
						n = e[r];
						var i = e[r + 1];
						Ep(n, e[r + 2]), n = n.ownerDocument.documentElement, n !== null && n.animate({
							opacity: [0, 0],
							pointerEvents: ["none", "none"]
						}, {
							duration: 0,
							fill: "forwards",
							pseudoElement: "::view-transition-group(" + i + ")"
						});
					}
					e = t.containerInfo, e = e.nodeType === 9 ? e.documentElement : e.ownerDocument.documentElement, e !== null && e.style.viewTransitionName === "" && (e.style.viewTransitionName = "none", e.animate({
						opacity: [0, 0],
						pointerEvents: ["none", "none"]
					}, {
						duration: 0,
						fill: "forwards",
						pseudoElement: "::view-transition-group(root)"
					}), e.animate({
						width: [0, 0],
						height: [0, 0]
					}, {
						duration: 0,
						fill: "forwards",
						pseudoElement: "::view-transition"
					})), hu = !0;
				}
				Gl = null;
				break;
			case 5:
				Fu(t, e);
				break;
			case 4:
				r = fu, fu = !1, Fu(t, e), fu && (mu = !0), fu = r;
				break;
			case 22:
				e.memoizedState === null && (n.memoizedState === null ? Fu(t, e) : Ql(e, !1));
				break;
			case 30:
				r = fu, i = Kl(), fu = !1, Fu(t, e), fu && (e.flags |= 4);
				var a = e.memoizedProps, o = e.stateNode;
				t = Ti(a, o), o = Ti(n.memoizedProps, o);
				var s = Di(a.default, a.update);
				s === "none" ? t = !1 : (a = n.memoizedState, n.memoizedState = null, n = e.child, ql = 0, t = au(e, n, t, o, s, a, !0), ql !== (a === null ? 0 : a.length) && (e.flags |= 32)), e.flags & 4 && t ? (Nd(e, e.memoizedProps.onUpdate), Gl = i) : i !== null && (i.push.apply(i, Gl), Gl = i), fu = e.flags & 32 ? !0 : r;
				break;
			default: Fu(t, e);
		}
	}
	function Lu(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) vu(e, t.alternate, t), t = t.sibling;
	}
	function Ru(e, t) {
		for (e = e.child; e !== null;) {
			var n = e, r = t;
			switch (n.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Tl(4, n, n.return), Ru(n, r);
					break;
				case 1:
					kl(n, n.return);
					var i = n.stateNode;
					typeof i.componentWillUnmount == "function" && Dl(n, n.return, i), Ru(n, r);
					break;
				case 27: r & 2 && gm(n.stateNode, n.type, n.memoizedProps);
				case 5:
					kl(n, n.return), n.tag !== 5 && n.tag !== 27 || Ml(n), Ru(n, r);
					break;
				case 6:
					Ml(n);
					break;
				case 26:
					kl(n, n.return), i = n.stateNode, n.memoizedState !== null || i === null || H || i.parentNode.removeChild(i), Ru(n, r);
					break;
				case 22:
					n.memoizedState === null && Ru(n, r);
					break;
				case 30:
					kl(n, n.return), Ru(n, r);
					break;
				case 7: kl(n, n.return);
				default: Ru(n, r);
			}
			e = e.sibling;
		}
	}
	function zu(e, t, n) {
		for (n = t.subtreeFlags & 8772 ? n : n & -2, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags, s = !!(n & 1);
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					zu(i, a, n), wl(4, a);
					break;
				case 1:
					if (zu(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Z(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var c = r.stateNode;
						try {
							var l = i.shared.hiddenCallbacks;
							if (l !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < l.length; i++) Ao(l[i], c);
						} catch (e) {
							Z(r, r.return, e);
						}
					}
					s && o & 64 && El(a), Ol(a, a.return);
					break;
				case 27: n & 2 && Vl(a);
				case 5:
					a.tag !== 5 && a.tag !== 27 || jl(a), zu(i, a, n), s && r === null && o & 4 && Fl(a), Ol(a, a.return);
					break;
				case 6:
					jl(a);
					break;
				case 26:
					c = a.stateNode, a.memoizedState !== null || c === null || su || Km(bm(c.ownerDocument), a.type, c), zu(i, a, n), s && r === null && o & 4 && Fl(a), Ol(a, a.return);
					break;
				case 12:
					zu(i, a, n);
					break;
				case 31:
					zu(i, a, n), s && o & 4 && Eu(i, a);
					break;
				case 13:
					zu(i, a, n), s && o & 4 && Du(i, a);
					break;
				case 22:
					a.memoizedState === null && zu(i, a, n), Ol(a, a.return);
					break;
				case 30:
					zu(i, a, n), Ol(a, a.return);
					break;
				case 7: Ol(a, a.return);
				default: zu(i, a, n);
			}
			t = t.sibling;
		}
	}
	function Bu(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && za(n));
	}
	function Vu(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && za(e));
	}
	function Hu(e, t, n, r) {
		var i = (n & 335544064) === n;
		if (t.subtreeFlags & (i ? 10262 : 10256)) for (t = t.child; t !== null;) Uu(e, t, n, r), t = t.sibling;
		else i && iu(t);
	}
	function Uu(e, t, n, r) {
		var i = (n & 335544064) === n;
		i && t.alternate === null && t.return !== null && t.return.alternate !== null && ru(t);
		var a = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				Hu(e, t, n, r), a & 2048 && wl(9, t);
				break;
			case 1:
				Hu(e, t, n, r);
				break;
			case 3:
				Hu(e, t, n, r), i && hu && (e = e.containerInfo, e = e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, e.style.viewTransitionName === "root" && (e.style.viewTransitionName = ""), e = e.ownerDocument.documentElement, e !== null && e.style.viewTransitionName === "none" && (e.style.viewTransitionName = "")), a & 2048 && (a = null, t.alternate !== null && (a = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== a && (t.refCount++, a != null && za(a)));
				break;
			case 12:
				if (a & 2048) {
					Hu(e, t, n, r), a = t.stateNode;
					try {
						var o = t.memoizedProps, s = o.id, c = o.onPostCommit;
						typeof c == "function" && c(s, t.alternate === null ? "mount" : "update", a.passiveEffectDuration, -0);
					} catch (e) {
						Z(t, t.return, e);
					}
				} else Hu(e, t, n, r);
				break;
			case 31:
				Hu(e, t, n, r);
				break;
			case 13:
				Hu(e, t, n, r);
				break;
			case 23: break;
			case 22:
				o = t.stateNode, s = t.alternate, t.memoizedState === null ? (i && s !== null && s.memoizedState !== null && ru(t), o._visibility & 2 ? Hu(e, t, n, r) : (o._visibility |= 2, Wu(e, t, n, r, !!(t.subtreeFlags & 10256) || !1))) : (i && s !== null && s.memoizedState === null && ru(s), o._visibility & 2 ? Hu(e, t, n, r) : Gu(e, t)), a & 2048 && Bu(s, t);
				break;
			case 24:
				Hu(e, t, n, r), a & 2048 && Vu(t.alternate, t);
				break;
			case 30:
				i && (a = t.alternate, a !== null && (Xl(a.child, !0), Xl(t.child, !0))), Hu(e, t, n, r);
				break;
			default: Hu(e, t, n, r);
		}
	}
	function Wu(e, t, n, r, i) {
		for (i &&= !!(t.subtreeFlags & 10256) || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					Wu(a, o, s, c, i), wl(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, Wu(a, o, s, c, i)) : u._visibility & 2 ? Wu(a, o, s, c, i) : Gu(a, o), i && l & 2048 && Bu(o.alternate, o);
					break;
				case 24:
					Wu(a, o, s, c, i), i && l & 2048 && Vu(o.alternate, o);
					break;
				default: Wu(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function Gu(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					Gu(n, r), i & 2048 && Bu(r.alternate, r);
					break;
				case 24:
					Gu(n, r), i & 2048 && Vu(r.alternate, r);
					break;
				default: Gu(n, r);
			}
			t = t.sibling;
		}
	}
	var Ku = 8192;
	function qu(e, t, n) {
		if (e.subtreeFlags & Ku) for (e = e.child; e !== null;) Ju(e, t, n), e = e.sibling;
	}
	function Ju(e, t, n) {
		switch (e.tag) {
			case 26:
				qu(e, t, n), e.flags & Ku && (e.memoizedState === null ? (e = e.stateNode, (t & 335544128) === t && Zm(n, e)) : Qm(n, ju, e.memoizedState, e.memoizedProps));
				break;
			case 5:
				qu(e, t, n), e.flags & Ku && (e = e.stateNode, (t & 335544128) === t && Zm(n, e));
				break;
			case 3:
			case 4:
				var r = ju;
				ju = bm(e.stateNode.containerInfo), qu(e, t, n), ju = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Ku, Ku = 16777216, qu(e, t, n), Ku = r) : qu(e, t, n));
				break;
			case 30:
				if ((e.flags & Ku) !== 0 && (r = e.memoizedProps.name, r != null && r !== "auto")) {
					var i = e.stateNode;
					i.paired = null, Ul === null && (Ul = /* @__PURE__ */ new Map()), Ul.set(r, i);
				}
				qu(e, t, n);
				break;
			default: qu(e, t, n);
		}
	}
	function Yu(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function Xu(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				du = r, $u(r, e);
			}
			Yu(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Zu(e), e = e.sibling;
	}
	function Zu(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				Xu(e), e.flags & 2048 && Tl(9, e, e.return);
				break;
			case 3:
				Xu(e);
				break;
			case 12:
				Xu(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Qu(e)) : Xu(e);
				break;
			default: Xu(e);
		}
	}
	function Qu(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				du = r, $u(r, e);
			}
			Yu(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Tl(8, t, t.return), Qu(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Qu(t));
					break;
				default: Qu(t);
			}
			e = e.sibling;
		}
	}
	function $u(e, t) {
		for (; du !== null;) {
			var n = du;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Tl(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: za(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, du = r;
			else a: for (n = e; du !== null;) {
				r = du;
				var i = r.sibling, a = r.return;
				if (Su(r), r === n) {
					du = null;
					break a;
				}
				if (i !== null) {
					i.return = a, du = i;
					break a;
				}
				du = a;
			}
		}
	}
	var ed = {
		getCacheForType: function(e) {
			var t = Ma(P), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return Ma(P).controller.signal;
		}
	}, td = typeof WeakMap == "function" ? WeakMap : Map, W = 0, G = null, K = null, q = 0, J = 0, nd = null, rd = !1, id = !1, ad = !1, od = 0, Y = 0, sd = 0, cd = 0, ld = 0, ud = 0, dd = 0, fd = null, pd = null, md = !1, hd = 0, gd = 0, _d = Infinity, vd = null, yd = null, X = 0, bd = null, xd = null, Sd = 0, Cd = 0, wd = null, Td = null, Ed = null, Dd = null, Od = null, kd = 0, Ad = null;
	function jd() {
		return W & 2 && q !== 0 ? q & -q : E.T === null ? Dt() : Pf();
	}
	function Md() {
		if (ud === 0) {
			if (!(q & 536870912) || N) {
				var e = dt;
				dt <<= 1, !(dt & 3932160) && (dt = 262144), ud = e;
			} else ud = 536870912;
		}
		return e = Lo.current, e !== null && (e.flags |= 32), ud;
	}
	function Nd(e, t) {
		if (t != null) {
			var n = e.stateNode, r = n.ref;
			r === null && (r = n.ref = Pp(Ti(e.memoizedProps, n))), Dd === null && (Dd = []), Dd.push(t.bind(null, r));
		}
	}
	function Pd(e, t, n) {
		(e === G && (J === 2 || J === 9) || e.cancelPendingCommit !== null) && (Vd(e, 0), Rd(e, q, ud, !1)), bt(e, n), (!(W & 2) || e !== G) && (e === G && (!(W & 2) && (cd |= n), Y === 4 && Rd(e, q, ud, !1)), Ef(e));
	}
	function Fd(e, t, n) {
		if (W & 6) throw Error(i(327));
		var r = !n && !(t & 127) && (t & e.expiredLanes) === 0 || ht(e, t), a = r ? Yd(e, t) : qd(e, t, !0), o = r;
		do {
			if (a === 0) {
				id && !r && Rd(e, t, 0, !1);
				break;
			}
			if (n = e.current.alternate, o && !Ld(n)) {
				a = qd(e, t, !1), o = !1;
				continue;
			}
			if (a === 2) {
				if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
				else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
				if (s !== 0) {
					t = s;
					a: {
						var c = e;
						a = fd;
						var l = c.current.memoizedState.isDehydrated;
						if (l && (Vd(c, s).flags |= 256), s = qd(c, s, !1), s !== 2 && s !== 6) {
							if (ad && !l) {
								c.errorRecoveryDisabledLanes |= o, cd |= o, a = 4;
								break a;
							}
							o = pd, pd = a, o !== null && (pd === null ? pd = o : pd.push.apply(pd, o));
						}
						a = s;
					}
					if (o = !1, a !== 2) continue;
				}
			}
			if (a === 1) {
				Vd(e, 0), Rd(e, t, 0, !0);
				break;
			}
			a: {
				switch (r = e, o = a, o) {
					case 0:
					case 1: throw Error(i(345));
					case 4: if ((t & 4194048) !== t && (t & 62914560) !== t) break;
					case 6:
						Rd(r, t, ud, !rd);
						break a;
					case 2:
						pd = null;
						break;
					case 3:
					case 5: break;
					default: throw Error(i(329));
				}
				if ((t & 62914560) === t && (a = hd + 300 - Je(), 10 < a)) {
					if (Rd(r, t, ud, !rd), mt(r, 0, !0) !== 0) break a;
					Sd = t, r.timeoutHandle = gp(Id.bind(null, r, n, pd, vd, md, t, ud, cd, dd, rd, o, "Throttled", -0, 0), a);
					break a;
				}
				Id(r, n, pd, vd, md, t, ud, cd, dd, rd, o, null, -0, 0);
			}
			break;
		} while (1);
		Ef(e);
	}
	function Id(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		e.timeoutHandle = -1;
		var m = t.subtreeFlags, h = (a & 335544064) === a;
		if (d = null, (h || m & 8192 || (m & 16785408) == 16785408) && (d = {
			stylesheets: null,
			count: 0,
			imgCount: 0,
			imgBytes: 0,
			suspenseyImages: [],
			waitingForImages: !0,
			waitingForViewTransition: !1,
			unsuspend: En
		}, Ul = null, Ju(t, a, d), h && (m = d, h = e.containerInfo, h = (h.nodeType === 9 ? h : h.ownerDocument).__reactViewTransition, h != null && (m.count++, m.waitingForViewTransition = !0, m = nh.bind(m), h.finished.then(m, m))), m = (a & 62914560) === a ? hd - Je() : (a & 4194048) === a ? gd - Je() : 0, m = eh(d, m), m !== null)) {
			Sd = a, e.cancelPendingCommit = m(nf.bind(null, e, t, a, n, r, i, o, s, c, l, u, d, null, f, p)), Rd(e, a, o, !l);
			return;
		}
		nf(e, t, a, n, r, i, o, s, c, l, u, d);
	}
	function Ld(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!Yr(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function Rd(e, t, n, r) {
		t = gt(e, t), t &= ~ld, t &= ~cd, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - ot(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && St(e, n, t);
	}
	function zd() {
		return W & 6 ? !0 : (Df(0, !1), !1);
	}
	function Bd() {
		if (K !== null) {
			if (J === 0) var e = K.return;
			else e = K, wa = Ca = null, ls(e), fo = null, po = 0, e = K;
			for (; e !== null;) Cl(e.alternate, e), e = e.return;
			K = null;
		}
	}
	function Vd(e, t) {
		var n = e.timeoutHandle;
		return n !== -1 && (e.timeoutHandle = -1, _p(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), Sd = 0, Bd(), G = e, K = n = Hi(e.current, null), q = t, J = 0, nd = null, rd = !1, id = ht(e, t), ad = !1, dd = ud = ld = cd = sd = Y = 0, pd = fd = null, md = !1, od = gt(e, t), Mi(), n;
	}
	function Hd(e, t) {
		F = null, E.H = vc, t === to || t === ro ? (t = lo(), J = 3) : t === no ? (t = lo(), J = 4) : J = t === Ic ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, nd = t, K === null && (Y = 1, Ac(e, Xi(t, e.current)));
	}
	function Ud() {
		var e = Lo.current;
		return e === null ? !0 : (q & 4194048) === q ? Ro === null : (q & 62914560) === q || q & 536870912 ? e === Ro : !1;
	}
	function Wd() {
		var e = E.H;
		return E.H = vc, e === null ? vc : e;
	}
	function Gd() {
		var e = E.A;
		return E.A = ed, e;
	}
	function Kd() {
		Y = 4, rd || (q & 4194048) !== q && Lo.current !== null || (id = !0), !(sd & 134217727) && !(cd & 134217727) || G === null || Rd(G, q, ud, !1);
	}
	function qd(e, t, n) {
		var r = W;
		W |= 2;
		var i = Wd(), a = Gd();
		(G !== e || q !== t) && (vd = null, Vd(e, t)), t = !1;
		var o = Y;
		a: do
			try {
				if (J !== 0 && K !== null) {
					var s = K, c = nd;
					switch (J) {
						case 8:
							Bd(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							Lo.current === null && (t = !0);
							var l = J;
							if (J = 0, nd = null, $d(e, s, c, l), n && id) {
								o = 0;
								break a;
							}
							break;
						default: l = J, J = 0, nd = null, $d(e, s, c, l);
					}
				}
				Jd(), o = Y;
				break;
			} catch (t) {
				Hd(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, wa = Ca = null, W = r, E.H = i, E.A = a, K === null && (G = null, q = 0, Mi()), o;
	}
	function Jd() {
		for (; K !== null;) Zd(K);
	}
	function Yd(e, t) {
		var n = W;
		W |= 2;
		var r = Wd(), a = Gd();
		G !== e || q !== t ? (vd = null, _d = Je() + 500, Vd(e, t)) : id = ht(e, t);
		a: do
			try {
				if (J !== 0 && K !== null) {
					t = K;
					var o = nd;
					b: switch (J) {
						case 1:
							J = 0, nd = null, $d(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (ao(o)) {
								J = 0, nd = null, Qd(t);
								break;
							}
							t = function() {
								J !== 2 && J !== 9 || G !== e || (J = 7), Ef(e);
							}, o.then(t, t);
							break a;
						case 3:
							J = 7;
							break a;
						case 4:
							J = 5;
							break a;
						case 7:
							ao(o) ? (J = 0, nd = null, Qd(t)) : (J = 0, nd = null, $d(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (K.tag) {
								case 26: s = K.memoizedState;
								case 5:
								case 27:
									var c = K;
									if (s ? Ym(s) : c.stateNode.complete) {
										J = 0, nd = null;
										var l = c.sibling;
										if (l !== null) K = l;
										else {
											var u = c.return;
											u === null ? K = null : (K = u, ef(u));
										}
										break b;
									}
							}
							J = 0, nd = null, $d(e, t, o, 5);
							break;
						case 6:
							J = 0, nd = null, $d(e, t, o, 6);
							break;
						case 8:
							Bd(), Y = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				Xd();
				break;
			} catch (t) {
				Hd(e, t);
			}
		while (1);
		return wa = Ca = null, E.H = r, E.A = a, W = n, K === null ? (G = null, q = 0, Mi(), Y) : 0;
	}
	function Xd() {
		for (; K !== null && !Ke();) Zd(K);
	}
	function Zd(e) {
		var t = hl(e.alternate, e, od);
		e.memoizedProps = e.pendingProps, t === null ? ef(e) : K = t;
	}
	function Qd(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = Yc(n, t, t.pendingProps, t.type, void 0, q);
				break;
			case 11:
				t = Yc(n, t, t.pendingProps, t.type.render, t.ref, q);
				break;
			case 5:
				ls(t);
				var r = t;
				r === da && (N ? (_a(r), r.tag === 5 && r.stateNode != null && (M = r.stateNode)) : (_a(r), N = !0));
			default: Cl(n, t), t = K = Ui(t, od), t = hl(n, t, od);
		}
		e.memoizedProps = e.pendingProps, t === null ? ef(e) : K = t;
	}
	function $d(e, t, n, r) {
		wa = Ca = null, ls(t), fo = null, po = 0;
		var i = t.return;
		try {
			if (Fc(e, i, t, n, q)) {
				Y = 1, Ac(e, Xi(n, e.current)), K = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw K = i, t;
			Y = 1, Ac(e, Xi(n, e.current)), K = null;
			return;
		}
		t.flags & 32768 ? (N || r === 1 ? e = !0 : id || q & 536870912 ? e = !1 : (rd = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Lo.current, r !== null && r.tag === 13 && (r.flags |= 16384))), tf(t, e)) : ef(t);
	}
	function ef(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				tf(t, rd);
				return;
			}
			e = t.return;
			var n = xl(t.alternate, t, od);
			if (n !== null) {
				K = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				K = t;
				return;
			}
			K = t = e;
		} while (t !== null);
		Y === 0 && (Y = 5);
	}
	function tf(e, t) {
		do {
			var n = Sl(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, K = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				K = e;
				return;
			}
			K = e = n;
		} while (e !== null);
		Y = 6, K = null;
	}
	function nf(e, t, n, r, a, o, s, c, l, u, d, f) {
		e.cancelPendingCommit = null;
		do
			df();
		while (X !== 0);
		if (W & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			e === G && (K = G = null, q = 0), xd = t, bd = e, Sd = n, wd = a, Td = r, rf(e, t, n, s, c, l, f);
		}
	}
	function rf(e, t, n, r, i, a, o) {
		var s = t.lanes | t.childLanes;
		if (Cd = s, s |= ji, xt(e, n, s, r, i, a), Dd = null, (n & 335544064) === n ? (Od = Ha(e), r = 10262) : (Od = null, r = 10256), (t.subtreeFlags & r) !== 0 || (t.flags & r) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, yf(Qe, function() {
			return ff(), null;
		})) : (e.callbackNode = null, e.callbackPriority = 0), Hl = !1, r = !!(t.flags & 13878), t.subtreeFlags & 13878 || r) {
			r = E.T, E.T = null, i = D.p, D.p = 2, a = W, W |= 4;
			try {
				gu(e, t, n);
			} finally {
				W = a, D.p = i, E.T = r;
			}
		}
		X = 1, Hl ? Ed = Mp(o, e.containerInfo, Od, sf, cf, of, lf, ff, af, null, null) : (sf(), cf(), lf());
	}
	function af(e) {
		if (X !== 0) {
			var t = bd.onRecoverableError;
			t(e, { componentStack: null });
		}
	}
	function of() {
		X === 3 && (X = 0, Iu(xd, bd), X = 4);
	}
	function sf() {
		if (X === 1) {
			X = 0;
			var e = bd, t = xd, n = Sd, r = !!(t.flags & 13878);
			if (t.subtreeFlags & 13878 || r) {
				r = E.T, E.T = null;
				var i = D.p;
				D.p = 2;
				var a = W;
				W |= 4;
				try {
					pu = mu = !1, Mu(t, e, n), n = cp;
					var o = ti(e.containerInfo), s = n.focusedElem, c = n.selectionRange;
					if (o !== s && s && s.ownerDocument && ei(s.ownerDocument.documentElement, s)) {
						if (c !== null && ni(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = $r(s, h), v = $r(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					gh = !!sp, cp = sp = null;
				} finally {
					W = a, D.p = i, E.T = r;
				}
			}
			e.current = t, X = 2;
		}
	}
	function cf() {
		if (X === 2) {
			X = 0;
			var e = bd, t = xd, n = !!(t.flags & 8772);
			if (t.subtreeFlags & 8772 || n) {
				n = E.T, E.T = null;
				var r = D.p;
				D.p = 2;
				var i = W;
				W |= 4;
				try {
					vu(e, t.alternate, t);
				} finally {
					W = i, D.p = r, E.T = n;
				}
			}
			X = 3;
		}
	}
	function lf() {
		if (X === 4 || X === 3) {
			X = 0;
			var e = Ed;
			Ed = null, qe();
			var t = bd, n = xd, r = Sd, i = Td, a = (r & 335544064) === r ? 10262 : 10256;
			if ((n.subtreeFlags & a) !== 0 || (n.flags & a) !== 0 ? X = 5 : (X = 0, xd = bd = null, uf(t, t.pendingLanes)), a = t.pendingLanes, a === 0 && (yd = null), Et(r), n = n.stateNode, it && typeof it.onCommitFiberRoot == "function") try {
				it.onCommitFiberRoot(rt, n, void 0, (n.current.flags & 128) == 128);
			} catch {}
			if (i !== null) {
				n = E.T, a = D.p, D.p = 2, E.T = null;
				try {
					for (var o = t.onRecoverableError, s = 0; s < i.length; s++) {
						var c = i[s];
						o(c.value, { componentStack: c.stack });
					}
				} finally {
					E.T = n, D.p = a;
				}
			}
			if (i = Dd, o = Od, Od = null, i !== null && (Dd = null, o === null && (o = []), e !== null)) for (c = 0; c < i.length; c++) n = (0, i[c])(o), n !== void 0 && e.finished.finally(n);
			Sd & 3 && df(), Ef(t), a = t.pendingLanes, r & 261930 && a & 42 ? t === Ad ? kd++ : (kd = 0, Ad = t) : (kd = 0, Ad = null), Df(0, !1);
		}
	}
	function uf(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, za(t)));
	}
	function df() {
		return Ed !== null && (Ed.skipTransition(), Ed = null), sf(), cf(), lf(), ff();
	}
	function ff() {
		if (X !== 5) return !1;
		var e = bd, t = Cd;
		Cd = 0;
		var n = Et(Sd), r = E.T, a = D.p;
		try {
			D.p = 32 > n ? 32 : n, E.T = null, n = wd, wd = null;
			var o = bd, s = Sd;
			if (X = 0, xd = bd = null, Sd = 0, W & 6) throw Error(i(331));
			var c = W;
			if (W |= 4, Zu(o.current), Uu(o, o.current, s, n), W = c, Df(0, !1), it && typeof it.onPostCommitFiberRoot == "function") try {
				it.onPostCommitFiberRoot(rt, o);
			} catch {}
			return !0;
		} finally {
			D.p = a, E.T = r, uf(e, t);
		}
	}
	function pf(e, t, n) {
		t = Xi(n, t), t = Mc(e.stateNode, t, 2), e = wo(e, t, 2), e !== null && (bt(e, 2), Ef(e));
	}
	function Z(e, t, n) {
		if (e.tag === 3) pf(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				pf(t, e, n);
				break;
			}
			if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (yd === null || !yd.has(r))) {
					e = Xi(n, e), n = Nc(2), r = wo(t, n, 2), r !== null && (Pc(n, r, t, e), bt(r, 2), Ef(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function mf(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new td();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (ad = !0, i.add(n), e = hf.bind(null, e, t, n), t.then(e, e));
	}
	function hf(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, G === e && (q & n) === n && (Y === 4 || Y === 3 && (q & 62914560) === q && 300 > Je() - hd ? W & 2 ? ld |= n : Vd(e, 0) : ld |= n, dd === q && (dd = 0)), Ef(e);
	}
	function gf(e, t) {
		t === 0 && (t = vt()), e = Fi(e, t), e !== null && (bt(e, t), Ef(e));
	}
	function _f(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), gf(e, n);
	}
	function vf(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), gf(e, n);
	}
	function yf(e, t) {
		return We(e, t);
	}
	var bf = null, xf = null, Sf = !1, Cf = !1, wf = !1, Tf = 0;
	function Ef(e) {
		e !== xf && e.next === null && (xf === null ? bf = xf = e : xf = xf.next = e), Cf = !0, Sf || (Sf = !0, Nf());
	}
	function Df(e, t) {
		if (!wf && Cf) {
			wf = !0;
			do
				for (var n = !1, r = bf; r !== null;) {
					if (!t) {
						if (e !== 0) {
							var i = r.pendingLanes;
							if (i === 0) var a = 0;
							else {
								var o = r.suspendedLanes, s = r.pingedLanes;
								a = (1 << 31 - ot(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
							}
							a !== 0 && (n = !0, Mf(r, a));
						} else a = q, a = mt(r, r === G ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || ht(r, a) || (n = !0, Mf(r, a));
					}
					r = r.next;
				}
			while (n);
			wf = !1;
		}
	}
	function Of() {
		kf();
	}
	function kf() {
		Cf = Sf = !1;
		var e = 0;
		Tf !== 0 && hp() && (e = Tf);
		for (var t = Je(), n = null, r = bf; r !== null;) {
			var i = r.next, a = Af(r, t);
			a === 0 ? (r.next = null, n === null ? bf = i : n.next = i, i === null && (xf = n)) : (n = r, (e !== 0 || a & 3) && (Cf = !0)), r = i;
		}
		X !== 0 && X !== 5 || Df(e, !1), Tf !== 0 && (Tf = 0);
	}
	function Af(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - ot(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = _t(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = G, n = q, n = mt(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (J === 2 || J === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && Ge(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || ht(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && Ge(r), Et(n)) {
				case 2:
				case 8:
					n = Ze;
					break;
				case 32:
					n = Qe;
					break;
				case 268435456:
					n = et;
					break;
				default: n = Qe;
			}
			return r = jf.bind(null, e), n = We(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && Ge(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function jf(e, t) {
		if (X !== 0 && X !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (df() && e.callbackNode !== n) return null;
		var r = q;
		return r = mt(e, e === G ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (Fd(e, r, t), Af(e, Je()), e.callbackNode != null && e.callbackNode === n ? jf.bind(null, e) : null);
	}
	function Mf(e, t) {
		if (df()) return null;
		Fd(e, t, !0);
	}
	function Nf() {
		bp(function() {
			W & 6 ? We(Xe, Of) : kf();
		});
	}
	function Pf() {
		if (Tf === 0) {
			var e = Ga;
			e === 0 && (e = ut, ut <<= 1, !(ut & 261888) && (ut = 256)), Tf = e;
		}
		return Tf;
	}
	function Ff(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Tn(e);
	}
	function If(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = Ff((i[jt] || null).action), o = r.submitter;
			o && (t = (t = o[jt] || null) ? Ff(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new qn("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (Tf !== 0) {
								var e = new FormData(i, o);
								ic(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = new FormData(i, o), ic(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var Lf = 0; Lf < Si.length; Lf++) {
		var Rf = Si[Lf];
		Ci(Rf.toLowerCase(), "on" + (Rf[0].toUpperCase() + Rf.slice(1)));
	}
	Ci(mi, "onAnimationEnd"), Ci(hi, "onAnimationIteration"), Ci(gi, "onAnimationStart"), Ci("dblclick", "onDoubleClick"), Ci("focusin", "onFocus"), Ci("focusout", "onBlur"), Ci(_i, "onTransitionRun"), Ci(vi, "onTransitionStart"), Ci(yi, "onTransitionCancel"), Ci(bi, "onTransitionEnd"), Yt("onMouseEnter", ["mouseout", "mouseover"]), Yt("onMouseLeave", ["mouseout", "mouseover"]), Yt("onPointerEnter", ["pointerout", "pointerover"]), Yt("onPointerLeave", ["pointerout", "pointerover"]), Jt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), Jt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), Jt("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), Jt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), Jt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), Jt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Bf = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(zf));
	function Vf(e, t) {
		t = !!(t & 4);
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Oi(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Oi(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function Q(e, t) {
		var n = t[Nt];
		n === void 0 && (n = t[Nt] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Gf(t, e, 2, !1), n.add(r));
	}
	function Hf(e, t, n) {
		var r = 0;
		t && (r |= 4), Gf(n, e, r, t);
	}
	var Uf = "_reactListening" + Math.random().toString(36).slice(2);
	function Wf(e) {
		if (!e[Uf]) {
			e[Uf] = !0, Kt.forEach(function(t) {
				t !== "selectionchange" && (Bf.has(t) || Hf(t, !1, e), Hf(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[Uf] || (t[Uf] = !0, Hf("selectionchange", !1, t));
		}
	}
	function Gf(e, t, n, r) {
		switch (Ch(t)) {
			case 2:
				var i = _h;
				break;
			case 8:
				i = vh;
				break;
			default: i = yh;
		}
		n = i.bind(null, t, n, e), i = void 0, !In || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function Kf(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = Bt(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		Nn(function() {
			var r = a, i = On(n), s = [];
			a: {
				var c = xi.get(e);
				if (c !== void 0) {
					var l = qn, u = e;
					switch (e) {
						case "keypress": if (Hn(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = dr;
							break;
						case "focusin":
							u = "focus", l = nr;
							break;
						case "focusout":
							u = "blur", l = nr;
							break;
						case "beforeblur":
						case "afterblur":
							l = nr;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = er;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = tr;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = mr;
							break;
						case mi:
						case hi:
						case gi:
							l = rr;
							break;
						case bi:
							l = hr;
							break;
						case "scroll":
						case "scrollend":
							l = Yn;
							break;
						case "wheel":
							l = gr;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = ir;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = fr;
							break;
						case "submit":
							l = pr;
							break;
						case "toggle":
						case "beforetoggle": l = _r;
					}
					var d = !!(t & 4), f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = Pn(m, p), g != null && d.push(qf(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (l = e === "mouseover" || e === "pointerover", c = e === "mouseout" || e === "pointerout", l && n !== Dn && (u = n.relatedTarget || n.fromElement) && (Bt(u) || u[Mt])) break a;
					(c || l) && (u = i.window === i ? i : (l = i.ownerDocument) ? l.defaultView || l.parentWindow : window, c ? (l = n.relatedTarget || n.toElement, c = r, l = l ? Bt(l) : null, l !== null && (f = o(l), d = l.tag, l !== f || d !== 5 && d !== 27 && d !== 6) && (l = null)) : (c = null, l = r), c !== l && (d = er, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = fr, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = c == null ? u : Ht(c), h = l == null ? u : Ht(l), u = new d(g, m + "leave", c, n, i), u.target = f, u.relatedTarget = h, g = null, Bt(i) === r && (d = new d(p, m + "enter", l, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, d = c && l ? ie(c, l, Yf) : null, c !== null && Xf(s, u, c, d, !1), l !== null && f !== null && Xf(s, f, l, d, !0)));
				}
				a: {
					if (c = r ? Ht(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var _ = Lr;
					else if (jr(c)) {
						if (Rr) _ = qr;
						else {
							_ = Gr;
							var v = Wr;
						}
					} else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && Sn(r.elementType) && (_ = Lr) : _ = Kr;
					if (_ &&= _(e, r)) {
						Mr(s, _, n, i);
						break a;
					}
					v && v(e, c, r);
				}
				switch (v = r ? Ht(r) : window, e) {
					case "focusin":
						(jr(v) || v.contentEditable === "true") && (ii = v, ai = r, oi = null);
						break;
					case "focusout":
						oi = ai = ii = null;
						break;
					case "mousedown":
						si = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						si = !1, ci(s, n, i);
						break;
					case "selectionchange": if (ri) break;
					case "keydown":
					case "keyup": ci(s, n, i);
				}
				var y;
				if (yr) b: {
					switch (e) {
						case "compositionstart":
							var b = "onCompositionStart";
							break b;
						case "compositionend":
							b = "onCompositionEnd";
							break b;
						case "compositionupdate":
							b = "onCompositionUpdate";
							break b;
					}
					b = void 0;
				}
				else Dr ? Tr(e, n) && (b = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (b = "onCompositionStart");
				b && (Sr && n.locale !== "ko" && (Dr || b !== "onCompositionStart" ? b === "onCompositionEnd" && Dr && (y = Vn()) : (Rn = i, zn = "value" in Rn ? Rn.value : Rn.textContent, Dr = !0)), v = Jf(r, b), 0 < v.length && (b = new ar(b, e, null, n, i), s.push({
					event: b,
					listeners: v
				}), y ? b.data = y : (y = Er(n), y !== null && (b.data = y)))), (y = xr ? Or(e, n) : kr(e, n)) && (b = Jf(r, "onBeforeInput"), 0 < b.length && (v = new ar("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: v,
					listeners: b
				}), v.data = y)), If(s, e, r, n, i);
			}
			Vf(s, t);
		});
	}
	function qf(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Jf(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = Pn(e, n), i != null && r.unshift(qf(e, i, a)), i = Pn(e, t), i != null && r.push(qf(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Yf(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Xf(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = Pn(n, a), l != null && o.unshift(qf(n, l, c))) : i || (l = Pn(n, a), l != null && o.push(qf(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var Zf = /\r\n?/g, Qf = /\u0000|\uFFFD/g;
	function $f(e) {
		return (typeof e == "string" ? e : "" + e).replace(Zf, "\n").replace(Qf, "");
	}
	function ep(e, t) {
		return t = $f(t), $f(e) === t;
	}
	function $(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				if (typeof r == "string") t === "body" || t === "textarea" && r === "" || vn(e, r);
				else if (typeof r == "number" || typeof r == "bigint") t !== "body" && vn(e, "" + r);
				else return;
				break;
			case "className":
				nn(e, "class", r);
				break;
			case "tabIndex":
				nn(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				nn(e, n, r);
				break;
			case "style":
				xn(e, r, o);
				return;
			case "data": if (t !== "object") {
				nn(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Tn(r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				}
				if (typeof o == "function" && (n === "formAction" ? (t !== "input" && $(e, t, "name", a.name, a, null), $(e, t, "formEncType", a.formEncType, a, null), $(e, t, "formMethod", a.formMethod, a, null), $(e, t, "formTarget", a.formTarget, a, null)) : ($(e, t, "encType", a.encType, a, null), $(e, t, "method", a.method, a, null), $(e, t, "target", a.target, a, null))), r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Tn(r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = En);
				return;
			case "onScroll":
				r != null && Q("scroll", e);
				return;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				return;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						o?.__html !== n && (e.innerHTML = n);
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = Tn(r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "credentialless":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				Q("beforetoggle", e), Q("toggle", e), tn(e, "popover", r);
				break;
			case "xlinkActuate":
				rn(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				rn(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				rn(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				rn(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				rn(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				rn(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				rn(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				rn(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				rn(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				tn(e, "is", r);
				break;
			case "innerText":
			case "textContent": return;
			default: if (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") n = Cn.get(n) || n, tn(e, n, r);
			else return;
		}
		j = !0;
	}
	function tp(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				xn(e, r, o);
				return;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						o?.__html !== n && (e.innerHTML = n);
					}
				}
				break;
			case "children":
				if (typeof r == "string") vn(e, r);
				else if (typeof r == "number" || typeof r == "bigint") vn(e, "" + r);
				else return;
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				return;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				return;
			case "onClick":
				r != null && (e.onclick = En);
				return;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": return;
			case "innerText":
			case "textContent": return;
			default:
				if (!qt.hasOwnProperty(n)) a: {
					if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), o = n.slice(2, a ? n.length - 7 : void 0), t = e[jt] || null, t = t == null ? null : t[n], typeof t == "function" && e.removeEventListener(o, t, a), typeof r == "function")) {
						typeof t != "function" && t !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(o, r, a);
						break a;
					}
					j = !0, n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : tn(e, n, r);
				}
				return;
		}
		j = !0;
	}
	function np(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				Q("error", e), Q("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: $(e, t, o, s, n, null);
					}
				}
				a && $(e, t, "srcSet", n.srcSet, n, null), r && $(e, t, "src", n.src, n, null);
				return;
			case "input":
				Q("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: $(e, t, r, d, n, null);
					}
				}
				pn(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in Q("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: $(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && hn(e, !!r, n, !0) : hn(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in Q("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: $(e, t, s, c, n, null);
				}
				_n(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: $(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				Q("beforetoggle", e), Q("toggle", e), Q("cancel", e), Q("close", e);
				break;
			case "iframe":
			case "object":
				Q("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < zf.length; r++) Q(zf[r], e);
				break;
			case "image":
				Q("error", e), Q("load", e);
				break;
			case "details":
				Q("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": Q("error", e), Q("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: $(e, t, u, r, n, null);
				}
				return;
			default: if (Sn(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && tp(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && $(e, t, c, r, n, null));
	}
	var rp = {};
	function ip(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || $(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							m !== f && (j = !0), o = m;
							break;
						case "name":
							m !== f && (j = !0), a = m;
							break;
						case "checked":
							m !== f && (j = !0), u = m;
							break;
						case "defaultChecked":
							m !== f && (j = !0), d = m;
							break;
						case "value":
							m !== f && (j = !0), s = m;
							break;
						case "defaultValue":
							m !== f && (j = !0), c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && $(e, t, p, m, r, f);
					}
				}
				fn(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || $(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						o !== l && (j = !0), p = o;
						break;
					case "defaultValue":
						o !== l && (j = !0), c = o;
						break;
					case "multiple": o !== l && (j = !0), s = o;
					default: o !== l && $(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? hn(e, !!n, n ? [] : "", !1) : hn(e, !!n, t, !0)) : hn(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: $(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						a !== o && (j = !0), p = a;
						break;
					case "defaultValue":
						a !== o && (j = !0), m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && $(e, t, s, a, r, o);
				}
				gn(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: $(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						p !== m && (j = !0), e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: $(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && $(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: $(e, t, u, p, r, m);
				}
				return;
			default: if (Sn(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && tp(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || tp(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && $(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || $(e, t, f, p, r, m);
	}
	function ap(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function op() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && ap(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && ap(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var sp = null, cp = null;
	function lp(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function up(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function dp(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function fp(e, t, n, r) {
		return n = lp(n).createElement(e), n[At] = r, n[jt] = t, np(n, e, t), Wt(n), n;
	}
	function pp(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var mp = null;
	function hp() {
		var e = window.event;
		return e && e.type === "popstate" ? e !== mp && (mp = e, !0) : (mp = null, !1);
	}
	var gp = typeof setTimeout == "function" ? setTimeout : void 0, _p = typeof clearTimeout == "function" ? clearTimeout : void 0, vp = typeof Promise == "function" ? Promise : void 0, yp = typeof requestAnimationFrame == "function" ? requestAnimationFrame : gp, bp = typeof queueMicrotask == "function" ? queueMicrotask : vp === void 0 ? gp : function(e) {
		return vp.resolve(null).then(e).catch(xp);
	};
	function xp(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Sp(e) {
		return e === "head";
	}
	function Cp(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) {
				if (n = i.data, n === "/$" || n === "/&") {
					if (r === 0) {
						e.removeChild(i), Hh(t);
						return;
					}
					r--;
				} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
				else if (n === "html") _m(e.ownerDocument.documentElement);
				else if (n === "head") {
					n = e.ownerDocument.head, _m(n);
					for (var a = n.firstChild; a;) {
						var o = a.nextSibling, s = a.nodeName;
						a[Lt] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
					}
				} else n === "body" && _m(e.ownerDocument.body);
			}
			n = i;
		} while (n);
		Hh(t);
	}
	function wp(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) {
				if (n = r.data, n === "/$") {
					if (e === 0) break;
					e--;
				} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			}
			n = r;
		} while (n);
	}
	function Tp(e, t, n) {
		if (t = CSS.escape(t) === t ? t : "r-" + btoa(t).replace(/=/g, ""), e.style.viewTransitionName = t, n != null && (e.style.viewTransitionClass = n), n = getComputedStyle(e), n.display === "inline") {
			if (t = e.getClientRects(), t.length === 1) var r = 1;
			else for (var i = r = 0; i < t.length; i++) {
				var a = t[i];
				0 < a.width && 0 < a.height && r++;
			}
			r === 1 && (e = e.style, e.display = t.length === 1 ? "inline-block" : "block", e.marginTop = "-" + n.paddingTop, e.marginBottom = "-" + n.paddingBottom);
		}
	}
	function Ep(e, t) {
		e = e.style, t = t.style;
		var n = t == null ? null : t.hasOwnProperty("viewTransitionName") ? t.viewTransitionName : t.hasOwnProperty("view-transition-name") ? t["view-transition-name"] : null;
		e.viewTransitionName = n == null || typeof n == "boolean" ? "" : ("" + n).trim(), n = t == null ? null : t.hasOwnProperty("viewTransitionClass") ? t.viewTransitionClass : t.hasOwnProperty("view-transition-class") ? t["view-transition-class"] : null, e.viewTransitionClass = n == null || typeof n == "boolean" ? "" : ("" + n).trim(), e.display === "inline-block" && (t == null ? e.display = e.margin = "" : (n = t.display, e.display = n == null || typeof n == "boolean" ? "" : n, n = t.margin, n == null ? (n = t.hasOwnProperty("marginTop") ? t.marginTop : t["margin-top"], e.marginTop = n == null || typeof n == "boolean" ? "" : n, t = t.hasOwnProperty("marginBottom") ? t.marginBottom : t["margin-bottom"], e.marginBottom = t == null || typeof t == "boolean" ? "" : t) : e.margin = n));
	}
	function Dp(e, t, n) {
		return n = n.ownerDocument.defaultView, {
			rect: e,
			abs: t.position === "absolute" || t.position === "fixed",
			clip: t.clipPath !== "none" || t.overflow !== "visible" || t.filter !== "none" || t.mask !== "none" || t.mask !== "none" || t.borderRadius !== "0px",
			view: 0 <= e.bottom && 0 <= e.right && e.top <= n.innerHeight && e.left <= n.innerWidth
		};
	}
	function Op(e) {
		return Dp(e.getBoundingClientRect(), getComputedStyle(e), e);
	}
	function kp(e) {
		var t = e.getBoundingClientRect();
		t = new DOMRect(t.x + 2e4, t.y + 2e4, t.width, t.height);
		var n = getComputedStyle(e);
		return Dp(t, n, e);
	}
	function Ap(e) {
		return e.documentElement.clientHeight;
	}
	function jp(e) {
		this.addEventListener("load", e), this.addEventListener("error", e);
	}
	function Mp(e, t, n, r, i, a, o, s, c) {
		var l = t.nodeType === 9 ? t : t.ownerDocument;
		try {
			var u = l.startViewTransition({
				update: function() {
					var t = l.defaultView, n = t.navigation && t.navigation.transition, o = l.fonts.status;
					r();
					var s = [];
					if (o === "loaded" && (Ap(l), l.fonts.status === "loading" && s.push(l.fonts.ready)), o = s.length, e !== null) for (var c = e.suspenseyImages, u = 0, d = 0; d < c.length; d++) {
						var f = c[d];
						if (!f.complete) {
							var p = f.getBoundingClientRect();
							if (0 < p.bottom && 0 < p.right && p.top < t.innerHeight && p.left < t.innerWidth) {
								if (u += Xm(f), u > $m) {
									s.length = o;
									break;
								}
								f = new Promise(jp.bind(f)), s.push(f);
							}
						}
					}
					if (0 < s.length) return t = Promise.race([Promise.all(s), new Promise(function(e) {
						return setTimeout(e, 500);
					})]).then(i, i), (n ? Promise.allSettled([n.finished, t]) : t).then(a, a);
					if (i(), n) return n.finished.then(a, a);
					a();
				},
				types: n
			});
			l.__reactViewTransition = u;
			var d = [];
			return u.ready.then(function() {
				for (var e = l.documentElement.getAnimations({ subtree: !0 }), t = 0; t < e.length; t++) {
					var n = e[t], r = n.effect, i = r.pseudoElement;
					if (i != null && i.startsWith("::view-transition")) {
						d.push(n), n = r.getKeyframes();
						for (var a = i = void 0, s = !0, c = 0; c < n.length; c++) {
							var u = n[c], f = u.width;
							if (i === void 0) i = f;
							else if (i !== f) {
								s = !1;
								break;
							}
							if (f = u.height, a === void 0) a = f;
							else if (a !== f) {
								s = !1;
								break;
							}
							delete u.width, delete u.height, u.transform === "none" && delete u.transform;
						}
						s && i !== void 0 && a !== void 0 && (r.setKeyframes(n), s = getComputedStyle(r.target, r.pseudoElement), s.width !== i || s.height !== a) && (s = n[0], s.width = i, s.height = a, s = n[n.length - 1], s.width = i, s.height = a, r.setKeyframes(n));
					}
				}
				o();
			}, function(e) {
				l.__reactViewTransition === u && (l.__reactViewTransition = null);
				try {
					if (typeof e == "object" && e) switch (e.name) {
						case "InvalidStateError": (e.message === "View transition was skipped because document visibility state is hidden." || e.message === "Skipping view transition because document visibility state has become hidden." || e.message === "Skipping view transition because viewport size changed." || e.message === "Transition was aborted because of invalid state") && (e = null);
					}
					e !== null && c(e);
				} finally {
					r(), i(), o();
				}
			}), u.finished.finally(function() {
				for (var e = 0; e < d.length; e++) d[e].cancel();
				l.__reactViewTransition === u && (l.__reactViewTransition = null), s();
			}), u;
		} catch {
			return r(), i(), o(), null;
		}
	}
	function Np(e, t) {
		this._scope = document.documentElement, this._selector = "::view-transition-" + e + "(" + t + ")";
	}
	Np.prototype.animate = function(e, t) {
		return t = typeof t == "number" ? { duration: t } : S({}, t), t.pseudoElement = this._selector, this._scope.animate(e, t);
	}, Np.prototype.getAnimations = function() {
		for (var e = this._scope, t = this._selector, n = e.getAnimations({ subtree: !0 }), r = [], i = 0; i < n.length; i++) {
			var a = n[i].effect;
			a !== null && a.target === e && a.pseudoElement === t && r.push(n[i]);
		}
		return r;
	}, Np.prototype.getComputedStyle = function() {
		return getComputedStyle(this._scope, this._selector);
	};
	function Pp(e) {
		return {
			name: e,
			group: new Np("group", e),
			imagePair: new Np("image-pair", e),
			old: new Np("old", e),
			new: new Np("new", e)
		};
	}
	function Fp(e) {
		this._fragmentFiber = e, this._observers = this._eventListeners = null;
	}
	Fp.prototype.addEventListener = function(e, t, n) {
		var r = null, i = null;
		if (!(n != null && typeof n != "boolean" && (r = n.signal || null, r !== null && r.aborted))) {
			this._eventListeners === null && (this._eventListeners = []);
			var a = this._eventListeners;
			if (Bp(a, e, t, n) === -1) {
				var o = this, s = t;
				n != null && typeof n != "boolean" && !0 === n.once && (s = function(r) {
					o.removeEventListener(e, t, n), typeof t == "function" ? t.call(this, r) : t.handleEvent(r);
				}), r !== null && (i = o.removeEventListener.bind(o, e, t, n), r.addEventListener("abort", i, { once: !0 }), i = r.removeEventListener.bind(r, "abort", i)), r = Rp(n), a.push({
					type: e,
					listener: t,
					optionsOrUseCapture: n,
					attachedListener: s,
					cleanup: i
				}), m(this._fragmentFiber.child, !1, Ip, e, s, r);
			}
			this._eventListeners = a;
		}
	};
	function Ip(e, t, n, r) {
		return b(e).addEventListener(t, n, r), !1;
	}
	Fp.prototype.removeEventListener = function(e, t, n) {
		var r = this._eventListeners;
		if (r !== null && (t = Bp(r, e, t, n), t !== -1)) {
			var i = r[t];
			n = i.attachedListener;
			var a = i.cleanup;
			i = Rp(i.optionsOrUseCapture), m(this._fragmentFiber.child, !1, Lp, e, n, i), r.splice(t, 1), a !== null && a();
		}
	};
	function Lp(e, t, n, r) {
		return b(e).removeEventListener(t, n, r), !1;
	}
	function Rp(e) {
		return e != null && typeof e != "boolean" && (!0 === e.once || e.signal instanceof AbortSignal) ? {
			capture: e.capture,
			passive: e.passive
		} : e;
	}
	function zp(e) {
		return e == null ? "c=0" : typeof e == "boolean" ? "c=" + (e ? "1" : "0") : "c=" + (e.capture ? "1" : "0");
	}
	function Bp(e, t, n, r) {
		if (e.length === 0) return -1;
		r = zp(r);
		for (var i = 0; i < e.length; i++) {
			var a = e[i];
			if (a.type === t && a.listener === n && zp(a.optionsOrUseCapture) === r) return i;
		}
		return -1;
	}
	Fp.prototype.dispatchEvent = function(e) {
		var t = h(this._fragmentFiber);
		if (t === null) return !0;
		t = b(t);
		var n = this._eventListeners;
		if (n !== null && 0 < n.length || !e.bubbles) {
			var r = t.nodeType === 9 ? t.createComment("") : document.createTextNode("");
			if (n) for (var i = 0; i < n.length; i++) {
				var a = n[i];
				r.addEventListener(a.type, a.attachedListener, Rp(a.optionsOrUseCapture));
			}
			if (t.appendChild(r), e = r.dispatchEvent(e), n) for (i = 0; i < n.length; i++) a = n[i], r.removeEventListener(a.type, a.attachedListener, Rp(a.optionsOrUseCapture));
			return t.removeChild(r), e;
		}
		return t.dispatchEvent(e);
	}, Fp.prototype.focus = function(e) {
		m(this._fragmentFiber.child, !0, Vp, e, void 0, void 0);
	};
	function Vp(e, t) {
		return e.tag !== 6 && (e = b(e), pm(e, t));
	}
	Fp.prototype.focusLast = function(e) {
		var t = [];
		m(this._fragmentFiber.child, !0, Hp, t, void 0, void 0);
		for (var n = t.length - 1; 0 <= n && !Vp(t[n], e); n--);
	};
	function Hp(e, t) {
		return t.push(e), !1;
	}
	Fp.prototype.blur = function() {
		var e = h(this._fragmentFiber);
		e !== null && (e = b(e), e = lp(e).activeElement, e !== null && m(this._fragmentFiber.child, !1, Up, e, void 0, void 0));
	};
	function Up(e, t) {
		return e.tag !== 6 && (e = b(e), e === t || e.contains(t) ? (t.blur(), !0) : !1);
	}
	Fp.prototype.observeUsing = function(e) {
		this._observers === null && (this._observers = /* @__PURE__ */ new Set()), this._observers.add(e), m(this._fragmentFiber.child, !1, Wp, e, void 0, void 0);
	};
	function Wp(e, t) {
		return e.tag !== 6 && (e = b(e), t.observe(e), !1);
	}
	Fp.prototype.unobserveUsing = function(e) {
		var t = this._observers;
		if (t !== null && t.has(e)) {
			t.delete(e), m(this._fragmentFiber.child, !1, Gp, e, void 0, void 0);
			for (var n = t = 0; n < Kp.length; n++) {
				var r = Kp[n];
				r.fragmentInstance === this && r.observer === e ? e.unobserve(r.instance) : Kp[t++] = r;
			}
			Kp.length = t;
		}
	};
	function Gp(e, t) {
		return e.tag !== 6 && (e = b(e), t.unobserve(e), !1);
	}
	var Kp = [], qp = !1;
	function Jp(e, t, n) {
		Kp.push({
			fragmentInstance: e,
			observer: t,
			instance: n
		}), qp || (qp = !0, mm(function() {
			qp = !1;
			var e = Kp;
			Kp = [];
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				n.observer.unobserve(n.instance);
			}
		}));
	}
	Fp.prototype.getClientRects = function() {
		var e = [];
		return m(this._fragmentFiber.child, !1, Yp, e, void 0, void 0), e;
	};
	function Yp(e, t) {
		if (e.tag === 6) {
			e = e.stateNode;
			var n = e.ownerDocument.createRange();
			n.selectNodeContents(e), t.push.apply(t, n.getClientRects());
		} else e = b(e), t.push.apply(t, e.getClientRects());
		return !1;
	}
	Fp.prototype.getRootNode = function(e) {
		var t = h(this._fragmentFiber);
		return t === null ? this : b(t).getRootNode(e);
	}, Fp.prototype.compareDocumentPosition = function(e) {
		var t = h(this._fragmentFiber);
		if (t === null) return Node.DOCUMENT_POSITION_DISCONNECTED;
		var n = [];
		m(this._fragmentFiber.child, !1, Hp, n, void 0, void 0);
		var r = b(t);
		if (n.length === 0) {
			if (n = r, g(this._fragmentFiber)) {
				a: {
					for (t = this._fragmentFiber.return; t !== null;) {
						if (t.tag === 4) {
							t = t.stateNode.containerInfo;
							break a;
						}
						if (t.tag === 3 || t.tag === 5 || t.tag === 27) break;
						t = t.return;
					}
					t = null;
				}
				t != null && (n = t);
			}
			t = this._fragmentFiber;
			var i = r = n.compareDocumentPosition(e);
			return n === e ? i = Node.DOCUMENT_POSITION_CONTAINS : r & Node.DOCUMENT_POSITION_CONTAINED_BY && (n = v(t)[1], n === null ? i = Node.DOCUMENT_POSITION_PRECEDING : (e = b(n).compareDocumentPosition(e), i = e === 0 || e & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING)), i |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
		}
		t = b(n[0]), i = b(n[n.length - 1]);
		var a = g(this._fragmentFiber) ? t.parentElement : r;
		if (a == null) return Node.DOCUMENT_POSITION_DISCONNECTED;
		r = a.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_CONTAINED_BY, a = a.compareDocumentPosition(i) & Node.DOCUMENT_POSITION_CONTAINED_BY;
		var o = t.compareDocumentPosition(e), s = i.compareDocumentPosition(e), c = o & Node.DOCUMENT_POSITION_CONTAINED_BY || s & Node.DOCUMENT_POSITION_CONTAINED_BY;
		return s = r && a && o & Node.DOCUMENT_POSITION_FOLLOWING && s & Node.DOCUMENT_POSITION_PRECEDING, t = r && t === e || a && i === e || c || s ? Node.DOCUMENT_POSITION_CONTAINED_BY : !r && t === e || !a && i === e ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : o, t & Node.DOCUMENT_POSITION_DISCONNECTED || t & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || Xp(t, this._fragmentFiber, n[0], n[n.length - 1], e) ? t : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
	};
	function Xp(e, t, n, r, i) {
		var a = Bt(i);
		if (e & Node.DOCUMENT_POSITION_CONTAINED_BY) {
			if (n = !!a) a: {
				for (; a !== null;) {
					if (a.tag === 7 && (a === t || a.alternate === t)) {
						n = !0;
						break a;
					}
					a = a.return;
				}
				n = !1;
			}
			return n;
		}
		if (e & Node.DOCUMENT_POSITION_CONTAINS) {
			if (a === null) return a = i.ownerDocument, i === a || i === a.documentElement || i === a.body;
			a: {
				for (a = t, t = h(t); a !== null;) {
					if (!(a.tag !== 5 && a.tag !== 3 && a.tag !== 27 || a !== t && a.alternate !== t)) {
						a = !0;
						break a;
					}
					a = a.return;
				}
				a = !1;
			}
			return a;
		}
		return e & Node.DOCUMENT_POSITION_PRECEDING ? ((t = !!a) && !(t = a === n) && (t = ie(n, a, re), t === null ? t = !1 : (m(t, !0, x, a, n), a = ee, ee = null, t = a !== null)), t) : e & Node.DOCUMENT_POSITION_FOLLOWING ? ((t = !!a) && !(t = a === r) && (t = ie(r, a, re), t === null ? t = !1 : (m(t, !0, ne, a, r), a = ee, te = ee = null, t = a !== null)), t) : !1;
	}
	function Zp(e, t) {
		var n = e.ownerDocument.createRange();
		n.selectNodeContents(e), e = n.getBoundingClientRect(), window.scrollTo(window.scrollX + e.left, t ? window.scrollY + e.top : window.scrollY + e.bottom - window.innerHeight);
	}
	Fp.prototype.scrollIntoView = function(e) {
		if (typeof e == "object") throw Error(i(566));
		var t = [];
		m(this._fragmentFiber.child, !1, Hp, t, void 0, void 0);
		var n = !1 !== e;
		if (t.length === 0) {
			var r = v(this._fragmentFiber);
			if (r = n ? r[1] || r[0] || h(this._fragmentFiber) : r[0] || r[1], r === null) return;
			if (r.tag === 6) {
				e = b(r), Zp(e, n);
				return;
			}
			if (r = b(r), r.nodeType !== 9) {
				if (r.nodeType === 11) {
					n = "host" in r ? r.host : null, n !== null && n.scrollIntoView(e);
					return;
				}
				r.scrollIntoView(e);
			}
		}
		for (r = n ? t.length - 1 : 0; r !== (n ? -1 : t.length);) {
			var a = t[r];
			a.tag === 6 ? (a = b(a), Zp(a, n)) : b(a).scrollIntoView(e), r += n ? -1 : 1;
		}
	};
	function Qp(e, t) {
		return e = b(e), $p(e, t), !1;
	}
	function $p(e, t) {
		e.reactFragments ??= /* @__PURE__ */ new Set(), e.reactFragments.add(t);
	}
	function em(e, t) {
		var n = t._eventListeners;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var i = n[r];
			e.addEventListener(i.type, i.attachedListener, Rp(i.optionsOrUseCapture));
		}
		e.nodeType !== 3 && (n = t._observers, n !== null && n.forEach(function(n) {
			for (var r = 0, i = 0; i < Kp.length; i++) {
				var a = Kp[i];
				(a.fragmentInstance !== t || a.observer !== n || a.instance !== e) && (Kp[r++] = a);
			}
			Kp.length = r, n.observe(e);
		}), $p(e, t));
	}
	function tm(e, t) {
		var n = t._eventListeners;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var i = n[r];
			e.removeEventListener(i.type, i.attachedListener, Rp(i.optionsOrUseCapture));
		}
		e.nodeType !== 3 && (n = t._observers, n !== null && n.forEach(function(n) {
			typeof n.rootMargin == "string" ? Jp(t, n, e) : n.unobserve(e);
		}), e.reactFragments != null && e.reactFragments.delete(t));
	}
	function nm(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					nm(n), zt(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function rm(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) {
				if (t === "input" && e.type === "hidden") {
					var a = i.name == null ? null : "" + i.name;
					if (i.type === "hidden" && e.getAttribute("name") === a) return e;
				} else return e;
			} else if (!e[Lt]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = lm(e.nextSibling), e === null) break;
		}
		return null;
	}
	function im(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = lm(e.nextSibling), e === null)) return null;
		return e;
	}
	function am(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = lm(e.nextSibling), e === null)) return null;
		return e;
	}
	function om(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function sm(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function cm(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function lm(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var um = null;
	function dm(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return lm(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function fm(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function pm(e, t) {
		function n() {
			r = !0;
		}
		if (e.ownerDocument.activeElement === e) return !0;
		var r = !1;
		try {
			e.ownerDocument.addEventListener("focus", n, !0), (e.focus || HTMLElement.prototype.focus).call(e, t);
		} finally {
			e.ownerDocument.removeEventListener("focus", n, !0);
		}
		return r;
	}
	function mm(e) {
		yp(function() {
			yp(function(t) {
				return e(t);
			});
		});
	}
	function hm(e, t, n) {
		switch (t = lp(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function gm(e, t, n) {
		for (var r in n) {
			var i = n[r];
			n.hasOwnProperty(r) && i != null && $(e, t, r, null, rp, i);
		}
		n.dangerouslySetInnerHTML != null && (e.textContent = ""), e.onclick === En && (e.onclick = null), zt(e);
	}
	function _m(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		zt(e);
	}
	var vm = /* @__PURE__ */ new Map(), ym = /* @__PURE__ */ new Set();
	function bm(e) {
		if (typeof e.getRootNode == "function") {
			var t = e.getRootNode();
			if (t.nodeType === 9 || t.nodeType === 11) return t;
		}
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	var xm = D.d;
	D.d = {
		f: Sm,
		r: Cm,
		D: Em,
		C: Dm,
		L: Om,
		m: km,
		X: jm,
		S: Am,
		M: Mm
	};
	function Sm() {
		var e = xm.f(), t = zd();
		return e || t;
	}
	function Cm(e) {
		var t = Vt(e);
		t !== null && t.tag === 5 && t.type === "form" ? oc(t) : xm.r(e);
	}
	var wm = typeof document > "u" ? null : document;
	function Tm(e, t, n) {
		var r = wm;
		if (r && typeof t == "string" && t) {
			var i = dn(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), ym.has(i) || (ym.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), np(t, "link", e), Wt(t), r.head.appendChild(t)));
		}
	}
	function Em(e) {
		xm.D(e), Tm("dns-prefetch", e, null);
	}
	function Dm(e, t) {
		xm.C(e, t), Tm("preconnect", e, t);
	}
	function Om(e, t, n) {
		xm.L(e, t, n);
		var r = wm;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + dn(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + dn(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + dn(n.imageSizes) + "\"]")) : i += "[href=\"" + dn(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Pm(e);
					break;
				case "script": a = Rm(e);
			}
			if (!(vm.has(a) || (e = S({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), vm.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(Fm(a)) || t === "script" && r.querySelector(zm(a))))) {
				var o = r.createElement("link");
				np(o, "link", e), t === "style" && (o[Rt] = !0, o.onload = o.onerror = function() {
					Gt(o);
				}), Wt(o), r.head.appendChild(o);
			}
		}
	}
	function km(e, t) {
		xm.m(e, t);
		var n = wm;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + dn(r) + "\"][href=\"" + dn(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Rm(e);
			}
			if (!vm.has(a) && (e = S({
				rel: "modulepreload",
				href: e
			}, t), vm.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(zm(a))) return;
				}
				r = n.createElement("link"), np(r, "link", e), Wt(r), n.head.appendChild(r);
			}
		}
	}
	function Am(e, t, n) {
		xm.S(e, t, n);
		var r = wm;
		if (r && e) {
			var i = Ut(r).hoistableStyles, a = Pm(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(Fm(a))) s.loading = 5;
				else {
					e = S({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = vm.get(a)) && Hm(e, n);
					var c = o = r.createElement("link");
					Wt(c), np(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Vm(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function jm(e, t) {
		xm.X(e, t);
		var n = wm;
		if (n && e) {
			var r = Ut(n).hoistableScripts, i = Rm(e), a = r.get(i);
			a || (a = n.querySelector(zm(i)), a || (e = S({
				src: e,
				async: !0
			}, t), (t = vm.get(i)) && Um(e, t), a = n.createElement("script"), Wt(a), np(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Mm(e, t) {
		xm.M(e, t);
		var n = wm;
		if (n && e) {
			var r = Ut(n).hoistableScripts, i = Rm(e), a = r.get(i);
			a || (a = n.querySelector(zm(i)), a || (e = S({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = vm.get(i)) && Um(e, t), a = n.createElement("script"), Wt(a), np(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Nm(e, t, n, r) {
		var a = (a = Ae.current) ? bm(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (n = Pm(n.href), t = Ut(a).hoistableStyles, r = t.get(n), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, t.set(n, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Pm(n.href);
					var o = Ut(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(Fm(e))) ? o._p || (s.instance = o, s.state.loading = 5) : (o = vm.get(e), o || (o = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, vm.set(e, o)), Lm(a, e, o, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (n = Rm(n), t = Ut(a).hoistableScripts, r = t.get(n), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, t.set(n, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function Pm(e) {
		return "href=\"" + dn(e) + "\"";
	}
	function Fm(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Im(e) {
		return S({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Lm(e, t, n, r) {
		if (t = e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]")) {
			if (!0 !== t[Rt]) {
				r.loading = 1;
				return;
			}
		} else t = e.createElement("link"), t[Rt] = !0, t.onload = t.onerror = Gt.bind(null, t), np(t, "link", n), Wt(t), e.head.appendChild(t);
		r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		});
	}
	function Rm(e) {
		return "[src=\"" + dn(e) + "\"]";
	}
	function zm(e) {
		return "script[async]" + e;
	}
	function Bm(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + dn(n.href) + "\"]");
				if (r) return t.instance = r, Wt(r), r;
				var a = S({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), Wt(r), np(r, "style", a), Vm(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = Pm(n.href);
				var o = e.querySelector(Fm(a));
				if (o) return t.state.loading |= 4, t.instance = o, Wt(o), o;
				r = Im(n), (a = vm.get(a)) && Hm(r, a), o = (e.ownerDocument || e).createElement("link"), Wt(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), np(o, "link", r), t.state.loading |= 4, Vm(o, n.precedence, e), t.instance = o;
			case "script": return o = Rm(n.src), (a = e.querySelector(zm(o))) ? (t.instance = a, Wt(a), a) : (r = n, (a = vm.get(o)) && (r = S({}, n), Um(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), Wt(a), np(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Vm(r, n.precedence, e));
		return t.instance;
	}
	function Vm(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Hm(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function Um(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Wm = null;
	function Gm(e, t, n) {
		if (Wm === null) {
			var r = /* @__PURE__ */ new Map(), i = Wm = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Wm, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[Lt] || a[At] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Km(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function qm(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Jm(e, t) {
		return e === "img" && t.src != null && t.src !== "" && t.onLoad == null && t.loading !== "lazy";
	}
	function Ym(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Xm(e) {
		return (e.width || 100) * (e.height || 100) * (typeof devicePixelRatio == "number" ? devicePixelRatio : 1) * .25;
	}
	function Zm(e, t) {
		typeof t.decode == "function" && (e.imgCount++, t.complete || (e.imgBytes += Xm(t), e.suspenseyImages.push(t)), e = rh.bind(e), t.decode().then(e, e));
	}
	function Qm(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Pm(r.href), a = t.querySelector(Fm(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = nh.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, Wt(a);
					return;
				}
				a = t.ownerDocument || t, r = Im(r), (i = vm.get(i)) && Hm(r, i), a = a.createElement("link"), Wt(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), np(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = nh.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var $m = 0;
	function eh(e, t) {
		return e.stylesheets && e.count === 0 && ah(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && ah(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && $m === 0 && ($m = 62500 * op());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && ah(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > $m ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function th(e) {
		if (e.count === 0 && (e.imgCount === 0 || !e.waitingForImages)) {
			if (e.stylesheets) ah(e, e.stylesheets);
			else if (e.unsuspend) {
				var t = e.unsuspend;
				e.unsuspend = null, t();
			}
		}
	}
	function nh() {
		this.count--, th(this);
	}
	function rh() {
		this.imgCount--, th(this);
	}
	var ih = null;
	function ah(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, ih = /* @__PURE__ */ new Map(), t.forEach(oh, e), ih = null, nh.call(e));
	}
	function oh(e, t) {
		if (!(t.state.loading & 4)) {
			var n = ih.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), ih.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = nh.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var sh = {
		$$typeof: w,
		Provider: null,
		Consumer: null,
		_currentValue: Te,
		_currentValue2: Te,
		_threadCount: 0
	};
	function ch(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = yt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = yt(0), this.hiddenUpdates = yt(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.transitionTypes = null, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function lh(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new ch(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = Bi(3, null, null, t), e.current = a, a.stateNode = e, t = Ra(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, xo(a), e;
	}
	function uh(e) {
		return e ? (e = Ri, e) : Ri;
	}
	function dh(e, t, n, r, i, a) {
		i = uh(i), r.context === null ? r.context = i : r.pendingContext = i, r = Co(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = wo(e, r, t), n !== null && (Pd(n, e, t), To(n, e, t));
	}
	function fh(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ph(e, t) {
		fh(e, t), (e = e.alternate) && fh(e, t);
	}
	function mh(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = Fi(e, 67108864);
			t !== null && Pd(t, e, 67108864), ph(e, 67108864);
		}
	}
	function hh(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = jd();
			t = Tt(t);
			var n = Fi(e, t);
			n !== null && Pd(n, e, t), ph(e, t);
		}
	}
	var gh = !0;
	function _h(e, t, n, r) {
		var i = E.T;
		E.T = null;
		var a = D.p;
		try {
			D.p = 2, yh(e, t, n, r);
		} finally {
			D.p = a, E.T = i;
		}
	}
	function vh(e, t, n, r) {
		var i = E.T;
		E.T = null;
		var a = D.p;
		try {
			D.p = 8, yh(e, t, n, r);
		} finally {
			D.p = a, E.T = i;
		}
	}
	function yh(e, t, n, r) {
		if (gh) {
			var i = bh(r);
			if (i === null) Kf(e, t, r, xh, n), Mh(e, r);
			else if (Ph(i, e, t, n, r)) r.stopPropagation();
			else if (Mh(e, r), t & 4 && -1 < jh.indexOf(e)) {
				for (; i !== null;) {
					var a = Vt(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = pt(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - ot(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									Ef(a), !(W & 6) && (_d = Je() + 500, Df(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = Fi(a, 2), s !== null && Pd(s, a, 2), zd(), ph(a, 2);
					}
					if (a = bh(r), a === null && Kf(e, t, r, xh, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else Kf(e, t, r, null, n);
		}
	}
	function bh(e) {
		return e = On(e), Sh(e);
	}
	var xh = null;
	function Sh(e) {
		if (xh = null, e = Bt(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = l(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return xh = e, null;
	}
	function Ch(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "fullscreenerror":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "resize":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (Ye()) {
				case Xe: return 2;
				case Ze: return 8;
				case Qe:
				case $e: return 32;
				case et: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var wh = !1, Th = null, Eh = null, Dh = null, Oh = /* @__PURE__ */ new Map(), kh = /* @__PURE__ */ new Map(), Ah = [], jh = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Mh(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				Th = null;
				break;
			case "dragenter":
			case "dragleave":
				Eh = null;
				break;
			case "mouseover":
			case "mouseout":
				Dh = null;
				break;
			case "pointerover":
			case "pointerout":
				Oh.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": kh.delete(t.pointerId);
		}
	}
	function Nh(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = Vt(t), t !== null && mh(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Ph(e, t, n, r, i) {
		switch (t) {
			case "focusin": return Th = Nh(Th, e, t, n, r, i), !0;
			case "dragenter": return Eh = Nh(Eh, e, t, n, r, i), !0;
			case "mouseover": return Dh = Nh(Dh, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return Oh.set(a, Nh(Oh.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, kh.set(a, Nh(kh.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Fh(e) {
		var t = Bt(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, Ot(e.priority, function() {
							hh(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = l(n), t !== null) {
						e.blockedOn = t, Ot(e.priority, function() {
							hh(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Ih(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = bh(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				Dn = r, n.target.dispatchEvent(r), Dn = null;
			} else return t = Vt(n), t !== null && mh(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Lh(e, t, n) {
		Ih(e) && n.delete(t);
	}
	function Rh() {
		wh = !1, Th !== null && Ih(Th) && (Th = null), Eh !== null && Ih(Eh) && (Eh = null), Dh !== null && Ih(Dh) && (Dh = null), Oh.forEach(Lh), kh.forEach(Lh);
	}
	function zh(e, n) {
		e.blockedOn === n && (e.blockedOn = null, wh || (wh = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Rh)));
	}
	var Bh = null;
	function Vh(e) {
		Bh !== e && (Bh = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			Bh === e && (Bh = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (Sh(r || n) === null) continue;
					break;
				}
				var a = Vt(n);
				a !== null && (e.splice(t, 3), t -= 3, ic(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Hh(e) {
		function t(t) {
			return zh(t, e);
		}
		Th !== null && zh(Th, e), Eh !== null && zh(Eh, e), Dh !== null && zh(Dh, e), Oh.forEach(t), kh.forEach(t);
		for (var n = 0; n < Ah.length; n++) {
			var r = Ah[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < Ah.length && (n = Ah[0], n.blockedOn === null);) Fh(n), n.blockedOn === null && Ah.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[jt] || null;
			if (typeof a == "function") o || Vh(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[jt] || null) s = o.formAction;
					else if (Sh(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Vh(n);
			}
		}
	}
	function Uh() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Wh(e) {
		this._internalRoot = e;
	}
	Gh.prototype.render = Wh.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		dh(n, jd(), e, t, null, null);
	}, Gh.prototype.unmount = Wh.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			dh(e.current, 2, null, e, null, null), zd(), t[Mt] = null;
		}
	};
	function Gh(e) {
		this._internalRoot = e;
	}
	Gh.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = Dt();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < Ah.length && t !== 0 && t < Ah[n].priority; n++);
			Ah.splice(n, 0, e), n === 0 && Fh(e);
		}
	};
	var Kh = n.version;
	if (Kh !== "19.3.0") throw Error(i(527, Kh, "19.3.0"));
	D.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = f(t), e = e === null ? null : p(e), e = e === null ? null : e.stateNode, e;
	};
	var qh = {
		bundleType: 0,
		version: "19.3.0",
		rendererPackageName: "react-dom",
		currentDispatcherRef: E,
		reconcilerVersion: "19.3.0"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var Jh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!Jh.isDisabled && Jh.supportsFiber) try {
			rt = Jh.inject(qh), it = Jh;
		} catch {}
	}
	e.createRoot = function(e, t) {
		if (!a(e)) throw Error(i(299));
		var n = !1, r = "", o = Dc, s = Oc, c = kc;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = lh(e, 1, !1, null, null, n, r, null, o, s, c, Uh), e[Mt] = t.current, Wf(e), new Wh(t);
	};
})), y = /* @__PURE__ */ a(((e, t) => {
	function n() {
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == "function") try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = v();
})), b = /* @__PURE__ */ e(c(), 1), ee = /* @__PURE__ */ e(y(), 1), te = {
	2: 379,
	3: 394,
	4: 409,
	5: 424,
	6: 439,
	7: 454,
	8: 469
}, x = {
	extraLegplank: 15,
	kapstokAchterop: 40,
	extraGarderobehaak: 10,
	bovenplaat: 30,
	frameHoogte: 100,
	afwijkendeDiepte: 50,
	uitsparing: 50,
	inmeetservice: 50
};
function ne(e) {
	switch (e.type) {
		case "plankenkast": return {
			label: "Plankenkast basis (1 vaste plank)",
			bedrag: te[2]
		};
		case "garderobekast": return e.garderobe === "roede" ? {
			label: "Garderobekast met roede",
			bedrag: 449
		} : {
			label: "Garderobekast met haken",
			bedrag: 439
		};
		case "schoenenkast": return {
			label: "Schoenenkast",
			bedrag: 429
		};
	}
}
function re(e) {
	let t = n(e), i = r(e), a = [{
		id: "basis",
		...ne(e)
	}];
	return e.extraLegplanken > 0 && a.push({
		id: "legplanken",
		label: `Extra legplank${e.extraLegplanken > 1 ? "en" : ""}`,
		detail: `${e.extraLegplanken} × €${x.extraLegplank}`,
		bedrag: e.extraLegplanken * x.extraLegplank
	}), e.type === "garderobekast" && e.extraGarderobehaken > 0 && a.push({
		id: "haken",
		label: "Extra haken",
		detail: `${e.extraGarderobehaken} × €${x.extraGarderobehaak}`,
		bedrag: e.extraGarderobehaken * x.extraGarderobehaak
	}), (e.diepteRoute === "verlaagd" || e.diepteRoute === "verdiept") && a.push({
		id: "diepte",
		label: "Afwijkende diepte",
		detail: `kast ${t.kastDiepte} cm`,
		bedrag: x.afwijkendeDiepte
	}), e.diepteRoute === "uitsparing" && e.uitsparingen.length > 0 && a.push({
		id: "uitsparing",
		label: `Uitsparing${e.uitsparingen.length > 1 ? "en" : ""} voor obstakel`,
		detail: `${e.uitsparingen.length} × €${x.uitsparing}`,
		bedrag: e.uitsparingen.length * x.uitsparing
	}), t.frameHoogteVerplicht && a.push({
		id: "frame-hoogte",
		label: "Frame aanpassing in hoogte",
		detail: "kozijn lager dan 197 cm",
		bedrag: x.frameHoogte,
		verplicht: !0
	}), i.meerprijs > 0 && a.push({
		id: "kleur",
		label: `Kleur ${i.ral}`,
		detail: "afhankelijk van kleur/afwerking",
		bedrag: i.meerprijs,
		vanaf: !0
	}), e.bovenplaat && t.bovenplaatMogelijk && a.push({
		id: "bovenplaat",
		label: "Bovenplaat afwerking",
		bedrag: x.bovenplaat
	}), e.kapstokAchterop && a.push({
		id: "kapstok",
		label: "Kapstok achterop",
		bedrag: x.kapstokAchterop
	}), e.diepteRoute === "laten-inmeten" && a.push({
		id: "inmeten",
		label: "Laten inmeten",
		bedrag: x.inmeetservice
	}), a;
}
function ie(e) {
	return re(e).reduce((e, t) => e + t.bedrag, 0);
}
function S(e) {
	return re(e).some((e) => e.vanaf);
}
function C(e) {
	return new Intl.NumberFormat("nl-NL", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: 0,
		maximumFractionDigits: 2
	}).format(e);
}
//#endregion
//#region src/stappen.ts
var ae = [
	{
		id: "kasttype",
		titel: "Type kast",
		kop: "Welk type kast wil je?"
	},
	{
		id: "draairichting",
		titel: "Draairichting",
		kop: "Welke kant draait je deur op?"
	},
	{
		id: "afmetingen",
		titel: "Afmetingen",
		kop: "Geef je kozijnmaten door"
	},
	{
		id: "diepte",
		titel: "Diepte",
		kop: "Hoeveel ruimte is er achter de deur?"
	},
	{
		id: "controle",
		titel: "Controle",
		kop: "Controleer je kast"
	},
	{
		id: "bestellen",
		titel: "Bestellen",
		kop: "Bestellen"
	}
], oe = {
	linksboven: "linksboven",
	rechtsboven: "rechtsboven",
	linksonder: "linksonder",
	rechtsonder: "rechtsonder"
};
function se(e) {
	return e.type === "plankenkast" ? `plankenkast met 1 vaste plank en ${e.extraLegplanken} verstelbare legplanken` : e.type === "schoenenkast" ? `schoenenkast met ${e.extraLegplanken} schuine schoenenplanken` : `garderobekast met ${e.garderobe === "roede" ? "roede" : "plafondhaken"}, ${p(e)} haken en ${e.extraLegplanken} extra legplanken`;
}
function ce(e) {
	switch (e.diepteRoute) {
		case "standaard": return "standaarddiepte gekozen";
		case "verlaagd": return "ondiepere kast gekozen";
		case "verdiept": return "diepere kast gekozen; ik geef aan dat er meer dan 32 cm ruimte achter de deur is";
		case "uitsparing": return "er zit plaatselijk iets in de weg; uitsparing gekozen";
		case "zelf-inmeten": return "ik wil de extra maten zelf doorgeven";
		case "laten-inmeten": return "ik wil de situatie laten inmeten";
		case "beperkt": return "niet genoeg ruimte of ik weet het niet zeker";
		default: return "nog niet gekozen";
	}
}
function le(e, t) {
	let n = [
		`Hoi Handigekasten, ik stel een kast samen en heb een vraag over ${{
			draairichting: "de draairichting",
			kozijnmaten: "het meten van mijn kozijn",
			diepte: "de ruimte achter mijn deur"
		}[t]}.`,
		"",
		"Mijn voorlopige keuzes in de configurator:",
		`- Kast: ${se(e)}`
	];
	if (e.kapstokAchterop && n.push("- Kapstok achterop: ja"), e.draairichtingBevestigd && n.push(`- Draairichting: scharnieren ${e.draairichting}`), t !== "draairichting" && e.bovenlicht !== "geen" && n.push(`- Bovenlicht: ja (${e.bovenlicht})`), t === "diepte" && (n.push(`- Ruimte achter de deur: ${ce(e)}`), e.uitsparingen.length > 0 && e.diepteRoute === "uitsparing")) for (let t of e.uitsparingen) {
		let e = t.volledigeBreedte ? t.hoek.endsWith("boven") ? "boven" : "onder" : oe[t.hoek];
		n.push(`- Uitsparing ${e}${t.volledigeHoogte ? " over de hele hoogte" : ""}${t.volledigeBreedte ? " over de hele breedte" : ""} (maten nog te controleren)`);
	}
	let r = {
		draairichting: "Ik twijfel welke draairichting ik moet kiezen. Kunnen jullie dit aan de hand van een foto van mijn deur beoordelen?",
		kozijnmaten: "Ik heb nog vragen over het meten van de breedte en hoogte van mijn kozijn. Kunnen jullie meekijken? Ik kan een foto met mijn meetlint sturen.",
		diepte: e.diepteRoute === "uitsparing" ? "Kunnen jullie meekijken of de gekozen uitsparing en maten voor mijn situatie kloppen? Ik kan een foto van het obstakel sturen." : "Ik weet niet zeker of er genoeg ruimte achter de deur is. Kunnen jullie me helpen bepalen wat ik moet meten en welke oplossing past? Ik kan een foto sturen."
	}[t];
	return [
		...n,
		"",
		`Mijn vraag: ${r}`
	].join("\n");
}
function ue(e, t) {
	return `https://api.whatsapp.com/send?phone=31165799463&text=${encodeURIComponent(le(e, t))}`;
}
//#endregion
//#region src/components/ConfiguratorPanel.tsx
var w = m(), T = (e) => `${e.toLocaleString("nl-NL", { maximumFractionDigits: 1 })} cm`;
function de({ config: e, onChange: t, stap: n, onStap: r, fout: i, bestelBericht: a, bestelBezig: o, webshopBeschikbaar: s, aanbetaling: c, onBestel: l, onView3D: u, onToggleBovenlicht: d }) {
	let f = ae[n], p = ie(e), m = S(e), h = (0, b.useRef)(null), g = (0, b.useRef)(n);
	return (0, b.useEffect)(() => {
		g.current !== n && window.matchMedia("(max-width: 960px)").matches && h.current?.scrollIntoView({
			behavior: "smooth",
			block: "start"
		}), g.current = n;
	}, [n]), /* @__PURE__ */ (0, w.jsxs)("aside", {
		className: "panel",
		"aria-label": "Configurator",
		ref: h,
		children: [
			/* @__PURE__ */ (0, w.jsx)("nav", {
				className: "stappen",
				"aria-label": "Stappen",
				children: ae.map((e, t) => /* @__PURE__ */ (0, w.jsx)("button", {
					type: "button",
					className: `stap-chip ${t === n ? "is-actief" : ""} ${t < n ? "is-klaar" : ""}`,
					"aria-current": t === n ? "step" : void 0,
					"aria-label": `Stap ${t + 1}: ${e.titel}`,
					title: e.titel,
					onClick: () => r(t),
					children: /* @__PURE__ */ (0, w.jsx)("span", {
						className: "stap-nr",
						children: t + 1
					})
				}, e.id))
			}),
			/* @__PURE__ */ (0, w.jsxs)("div", {
				className: "panel-body",
				children: [
					/* @__PURE__ */ (0, w.jsxs)("div", {
						className: "panel-step",
						children: [
							"STAP ",
							n + 1,
							" / ",
							ae.length,
							" · ",
							f.titel.toUpperCase()
						]
					}),
					/* @__PURE__ */ (0, w.jsx)("h2", { children: f.kop }),
					i && /* @__PURE__ */ (0, w.jsx)("div", {
						className: "bestel-fout",
						role: "alert",
						children: i
					}),
					a && /* @__PURE__ */ (0, w.jsx)("div", {
						className: "bestel-succes",
						role: "status",
						children: a
					}),
					/* @__PURE__ */ (0, w.jsx)(fe, {
						id: f.id,
						config: e,
						onChange: t,
						onStap: r,
						aanbetaling: c,
						webshopBeschikbaar: s,
						bestelBezig: o,
						onBestel: l,
						onView3D: u,
						onToggleBovenlicht: d
					})
				]
			}),
			/* @__PURE__ */ (0, w.jsxs)("footer", {
				className: "panel-footer",
				children: [/* @__PURE__ */ (0, w.jsxs)("details", {
					className: "prijsopbouw",
					children: [/* @__PURE__ */ (0, w.jsxs)("summary", { children: [/* @__PURE__ */ (0, w.jsxs)("div", { children: [/* @__PURE__ */ (0, w.jsx)("div", {
						className: "price-label",
						children: "Totaal incl. btw"
					}), /* @__PURE__ */ (0, w.jsx)("div", {
						className: "price-sub",
						children: "Prijsopbouw bekijken"
					})] }), /* @__PURE__ */ (0, w.jsxs)("div", {
						className: "price-value",
						"data-testid": "totaalprijs",
						children: [m && /* @__PURE__ */ (0, w.jsx)("span", {
							className: "price-vanaf",
							children: "vanaf "
						}), C(p)]
					})] }), /* @__PURE__ */ (0, w.jsx)(D, { config: e })]
				}), /* @__PURE__ */ (0, w.jsxs)("div", {
					className: "nav-knoppen",
					children: [/* @__PURE__ */ (0, w.jsx)("button", {
						type: "button",
						className: "knop-secundair",
						disabled: n === 0,
						onClick: () => r(n - 1),
						children: "← Vorige"
					}), n < ae.length - 1 ? /* @__PURE__ */ (0, w.jsxs)("button", {
						type: "button",
						className: "cta",
						onClick: () => r(n + 1),
						children: [ae[n + 1].titel, " →"]
					}) : /* @__PURE__ */ (0, w.jsx)("button", {
						type: "button",
						className: "cta",
						disabled: !s || o,
						onClick: () => l("checkout"),
						children: o ? "Kast toevoegen…" : "Kast bestellen"
					})]
				})]
			})
		]
	});
}
function fe(e) {
	switch (e.id) {
		case "kasttype": return /* @__PURE__ */ (0, w.jsx)(xe, { ...e });
		case "afmetingen": return /* @__PURE__ */ (0, w.jsx)(pe, { ...e });
		case "diepte": return /* @__PURE__ */ (0, w.jsx)(ge, { ...e });
		case "draairichting": return /* @__PURE__ */ (0, w.jsx)(ye, { ...e });
		case "controle": return /* @__PURE__ */ (0, w.jsx)(we, { ...e });
		case "bestellen": return /* @__PURE__ */ (0, w.jsx)(E, { ...e });
	}
}
function pe({ config: e, onChange: r, onToggleBovenlicht: i }) {
	let a = n(e);
	return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		/* @__PURE__ */ (0, w.jsx)("p", {
			className: "panel-hint",
			children: "Meet de dagmaat van je kozijn op het smalste punt, in hele centimeters."
		}),
		/* @__PURE__ */ (0, w.jsxs)(Te, {
			label: "Kozijnbreedte (dagmaat)",
			waarde: `kast ${T(a.kastBreedte)}`,
			children: [/* @__PURE__ */ (0, w.jsx)(Oe, {
				label: "Kozijnbreedte",
				waarde: e.kozijnBreedte,
				onChange: (e) => r({ kozijnBreedte: e }),
				schuifMin: f.kozijnBreedteSchuifMin,
				schuifMax: f.kozijnBreedteSchuifMax,
				invoerMin: f.kozijnBreedteInvoerMin,
				invoerMax: f.kozijnBreedteInvoerMax,
				markeringen: t,
				actieveMarkering: a.standaardKozijnmaat
			}), /* @__PURE__ */ (0, w.jsx)(me, { config: e })]
		}),
		/* @__PURE__ */ (0, w.jsxs)(Te, {
			label: "Kozijnhoogte (dagmaat)",
			waarde: `kast ${T(a.kastHoogte)}`,
			children: [
				/* @__PURE__ */ (0, w.jsx)(ke, {
					aan: e.bovenlicht !== "geen",
					onChange: i,
					titel: "Ik heb een bovenlicht",
					sub: "Meet alleen de opening onder het bovenlicht; het bovenlicht hoort niet bij de dagmaat."
				}),
				/* @__PURE__ */ (0, w.jsx)(Oe, {
					label: "Kozijnhoogte",
					waarde: e.kozijnHoogte,
					onChange: (e) => r({ kozijnHoogte: e }),
					schuifMin: f.kozijnHoogteInvoerMin,
					schuifMax: f.kozijnHoogteInvoerMax,
					invoerMin: f.kozijnHoogteInvoerMin,
					invoerMax: f.kozijnHoogteInvoerMax
				}),
				e.bovenlicht !== "geen" && /* @__PURE__ */ (0, w.jsxs)(Ee, { children: [
					"Meet vanaf de vloer tot de onderkant van de tussendorpel. De ",
					f.bovenlichtHoogte,
					" cm erboven tel je niet mee."
				] }),
				/* @__PURE__ */ (0, w.jsx)(he, { config: e }),
				a.bovenplaatMogelijk && /* @__PURE__ */ (0, w.jsx)(ke, {
					aan: e.bovenplaat,
					onChange: (e) => r({ bovenplaat: e }),
					titel: "Bovenplaat afwerking",
					sub: "3 mm hardboard, wit gelakt, sluit de ruimte boven de balk af",
					prijs: x.bovenplaat
				})
			]
		}),
		/* @__PURE__ */ (0, w.jsx)(De, {
			config: e,
			onderwerp: "kozijnmaten",
			tekst: "Twijfel je over de kozijnmaten? Vraag ons om mee te kijken."
		})
	] });
}
function me({ config: e }) {
	let t = n(e);
	return e.kozijnBreedte < t.minDagmaat ? /* @__PURE__ */ (0, w.jsxs)(Ee, {
		soort: "let-op",
		children: [
			"Een kast van ",
			T(t.kastBreedte),
			" heeft minimaal ",
			T(t.minDagmaat),
			" dagmaat nodig om te kunnen draaien. Neem contact met ons op, dan kijken we samen wat er mogelijk is."
		]
	}) : null;
}
function he({ config: e }) {
	let t = n(e);
	return t.frameHoogteVerplicht ? /* @__PURE__ */ (0, w.jsxs)(Ee, {
		soort: "let-op",
		children: [
			"Lager dan ",
			f.kozijnHoogteMin,
			" cm: ",
			/* @__PURE__ */ (0, w.jsx)("strong", { children: "frameaanpassing in hoogte" }),
			" is verplicht (+",
			C(x.frameHoogte),
			"). De kast wordt ",
			T(t.kastHoogte),
			" hoog."
		]
	}) : null;
}
function ge({ config: e, onChange: t, onView3D: n }) {
	let r = i(e.kozijnBreedte), a = Math.max(f.maatwerkKastdiepteMin, r - 5), o = (0, b.useRef)(null), s = (0, b.useRef)(null), c = (0, b.useRef)(e.diepteRoute);
	(0, b.useEffect)(() => {
		c.current !== e.diepteRoute && window.matchMedia("(max-width: 960px)").matches && (e.diepteRoute === "beperkt" && o.current?.scrollIntoView({
			behavior: "smooth",
			block: "start"
		}), e.diepteRoute === "uitsparing" && s.current?.scrollIntoView({
			behavior: "smooth",
			block: "start"
		})), c.current = e.diepteRoute;
	}, [e.diepteRoute]);
	let l = (e) => {
		t({ diepteRoute: e });
	};
	return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		/* @__PURE__ */ (0, w.jsx)("p", {
			className: "panel-hint",
			children: "Meet vanaf de gesloten deur hoeveel ruimte er achter de deur is, tot 200 cm hoogte."
		}),
		/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "optie-lijst",
			role: "radiogroup",
			"aria-label": "Hoeveel ruimte is er achter de deur?",
			children: [/* @__PURE__ */ (0, w.jsx)(O, {
				actief: e.diepteRoute === "standaard" || e.diepteRoute === "verdiept",
				onClick: () => l("standaard"),
				titel: `Er is meer dan ${T(r + 2)} ruimte`,
				sub: r === 25 ? "Een kast van 25 cm diep past standaard; hieronder kun je ook 30 cm kiezen" : `De standaard kastdiepte van ${T(r)} past zonder meerprijs`,
				prijs: r === 25 ? "" : "geen meerprijs"
			}), /* @__PURE__ */ (0, w.jsx)(O, {
				actief: e.diepteRoute !== "standaard" && e.diepteRoute !== "verdiept" && e.diepteRoute !== "nog-niet-gekozen",
				onClick: () => l("beperkt"),
				titel: "Er is niet genoeg ruimte",
				sub: "Of ik weet het niet zeker",
				prijs: ""
			})]
		}),
		r === 25 && (e.diepteRoute === "standaard" || e.diepteRoute === "verdiept") && /* @__PURE__ */ (0, w.jsx)(ke, {
			aan: e.diepteRoute === "verdiept",
			onChange: (e) => l(e ? "verdiept" : "standaard"),
			titel: "Ik wil toch een kast van 30 cm diep",
			sub: "Alleen mogelijk als er meer dan 32 cm ruimte achter de gesloten deur is.",
			prijs: x.afwijkendeDiepte
		}),
		e.diepteRoute !== "standaard" && e.diepteRoute !== "verdiept" && e.diepteRoute !== "nog-niet-gekozen" && /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
			/* @__PURE__ */ (0, w.jsxs)("div", {
				className: "keuzehulp",
				ref: o,
				children: [
					/* @__PURE__ */ (0, w.jsx)("strong", { children: "Weet je het niet zeker?" }),
					/* @__PURE__ */ (0, w.jsx)("span", { children: "Laat ons de situatie beoordelen of kies hieronder voor inmeten." }),
					/* @__PURE__ */ (0, w.jsx)(De, {
						config: e,
						onderwerp: "diepte",
						tekst: "Vraag hulp bij het meten"
					})
				]
			}),
			/* @__PURE__ */ (0, w.jsx)("h3", {
				className: "sub-kop",
				children: "Welke oplossing past bij jouw situatie?"
			}),
			/* @__PURE__ */ (0, w.jsxs)("div", {
				className: "optie-lijst",
				role: "radiogroup",
				"aria-label": "Oplossing voor beperkte ruimte",
				children: [
					/* @__PURE__ */ (0, w.jsx)(O, {
						actief: e.diepteRoute === "laten-inmeten",
						onClick: () => l("laten-inmeten"),
						titel: "Ik laat het liever inmeten",
						sub: "We nemen contact met je op om de situatie en maten te bespreken.",
						prijs: `+${C(x.inmeetservice)}`
					}),
					r === 30 && /* @__PURE__ */ (0, w.jsx)(O, {
						actief: e.diepteRoute === "verlaagd",
						onClick: () => l("verlaagd"),
						titel: `Er is wel meer dan ${T(a + 2)} ruimte`,
						sub: `We maken de kast ${T(a)} diep`,
						prijs: `+${C(x.afwijkendeDiepte)}`
					}),
					/* @__PURE__ */ (0, w.jsx)(O, {
						actief: e.diepteRoute === "uitsparing",
						onClick: () => l("uitsparing"),
						titel: "Er zit plaatselijk iets in de weg",
						sub: "Kies hieronder waar een hoek van de kast moet worden aangepast",
						prijs: `+${C(x.uitsparing)} per uitsparing`
					}),
					/* @__PURE__ */ (0, w.jsx)(O, {
						actief: e.diepteRoute === "zelf-inmeten",
						onClick: () => l("zelf-inmeten"),
						titel: "Zelf blijven inmeten",
						sub: "Geef de extra maten later door als reactie op de bestelmail, via WhatsApp of via een inmeet-belletje.",
						prijs: ""
					})
				]
			}),
			e.diepteRoute === "uitsparing" && /* @__PURE__ */ (0, w.jsx)("div", {
				ref: s,
				children: /* @__PURE__ */ (0, w.jsx)(ve, {
					config: e,
					onChange: t,
					onView3D: n
				})
			})
		] })
	] });
}
var _e = [
	{
		id: "linksboven",
		label: "Linksboven"
	},
	{
		id: "rechtsboven",
		label: "Rechtsboven"
	},
	{
		id: "linksonder",
		label: "Linksonder"
	},
	{
		id: "rechtsonder",
		label: "Rechtsonder"
	}
];
function ve({ config: e, onChange: t, onView3D: r }) {
	let i = n(e), a = Math.floor((i.kastBreedte - f.profiel - 1) / 5) * 5, o = Math.floor((i.kastHoogte - 1) / 6) * 6, s = (n, r) => {
		let i = (e) => e.hoek !== n && e.hoek.endsWith("boven") === n.endsWith("boven");
		t({ uitsparingen: e.uitsparingen.filter((e) => !(r.volledigeBreedte && i(e))).map((e) => e.hoek === n ? {
			...e,
			...r
		} : e) });
	}, c = (n) => {
		if (e.uitsparingen.some((e) => e.hoek === n)) {
			t({ uitsparingen: e.uitsparingen.filter((e) => e.hoek !== n) });
			return;
		}
		e.uitsparingen.some((e) => e.volledigeBreedte && e.hoek.endsWith("boven") === n.endsWith("boven")) || t({ uitsparingen: [...e.uitsparingen, {
			hoek: n,
			breedte: 10,
			hoogte: 18
		}] });
	};
	return /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "uitsparing-editor",
		children: [
			/* @__PURE__ */ (0, w.jsx)("h3", {
				className: "sub-kop",
				children: "Waar zit het obstakel?"
			}),
			/* @__PURE__ */ (0, w.jsxs)("p", {
				className: "panel-hint",
				children: [
					"Kijk recht tegen de voorkant van de kast aan. Tik op een hoek; je kunt meerdere hoeken kiezen. Een uitsparing kan ook over de hele breedte lopen. Elke uitsparing kost ",
					C(x.uitsparing),
					"."
				]
			}),
			/* @__PURE__ */ (0, w.jsxs)("div", {
				className: "uitsparing-schets",
				role: "group",
				"aria-label": "Hoeken van de kast",
				children: [
					e.uitsparingen.map((e) => /* @__PURE__ */ (0, w.jsx)("span", {
						className: `uitsparing-vorm ${e.hoek.includes("links") ? "links" : "rechts"}`,
						style: {
							width: `${e.volledigeBreedte ? 100 : Math.min(100, e.breedte / i.kastBreedte * 100)}%`,
							height: `${Math.min(100, (e.volledigeHoogte ? i.kastHoogte : e.hoogte) / i.kastHoogte * 100)}%`,
							bottom: e.hoek.endsWith("boven") ? void 0 : "0",
							top: e.hoek.endsWith("boven") ? "0" : void 0
						},
						"aria-hidden": "true"
					}, e.hoek)),
					/* @__PURE__ */ (0, w.jsx)("svg", {
						className: "uitsparing-pijlen",
						viewBox: "0 0 100 100",
						preserveAspectRatio: "none",
						"aria-hidden": "true",
						children: e.uitsparingen.map((e) => {
							let t = e.volledigeBreedte ? 100 : Math.min(100, e.breedte / i.kastBreedte * 100), n = Math.min(100, (e.volledigeHoogte ? i.kastHoogte : e.hoogte) / i.kastHoogte * 100), r = e.hoek.includes("links") ? 0 : 100 - t, a = r + t, o = e.hoek.endsWith("boven") ? 0 : 100 - n, s = o + n, c = e.hoek.endsWith("boven") ? s + 3 : o - 3, l = e.volledigeBreedte ? 97 : e.hoek.includes("links") ? a + 3 : r - 3;
							return /* @__PURE__ */ (0, w.jsxs)("g", {
								className: "uitsparing-pijl",
								children: [
									/* @__PURE__ */ (0, w.jsx)("line", {
										x1: r,
										y1: c,
										x2: a,
										y2: c
									}),
									/* @__PURE__ */ (0, w.jsx)("path", { d: `M ${r + 2} ${c - 2} L ${r} ${c} L ${r + 2} ${c + 2} M ${a - 2} ${c - 2} L ${a} ${c} L ${a - 2} ${c + 2}` }),
									/* @__PURE__ */ (0, w.jsx)("line", {
										x1: l,
										y1: o,
										x2: l,
										y2: s
									}),
									/* @__PURE__ */ (0, w.jsx)("path", { d: `M ${l - 2} ${o + 2} L ${l} ${o} L ${l + 2} ${o + 2} M ${l - 2} ${s - 2} L ${l} ${s} L ${l + 2} ${s - 2}` })
								]
							}, `maatpijlen-${e.hoek}`);
						})
					}),
					_e.map(({ id: t, label: n }) => /* @__PURE__ */ (0, w.jsx)("button", {
						type: "button",
						className: `uitsparing-hoek ${t}`,
						"aria-pressed": e.uitsparingen.some((e) => e.hoek === t),
						disabled: e.uitsparingen.some((e) => e.volledigeBreedte && e.hoek !== t && e.hoek.endsWith("boven") === t.endsWith("boven")),
						onClick: () => c(t),
						children: n
					}, t))
				]
			}),
			/* @__PURE__ */ (0, w.jsx)("p", {
				className: "uitsparing-bijschrift",
				children: "Vooraanzicht van de kast · het stalen frame blijft rechthoekig"
			}),
			/* @__PURE__ */ (0, w.jsxs)("div", {
				className: "uitsparing-maatlegenda",
				"aria-label": "Richtingen van de maten",
				children: [/* @__PURE__ */ (0, w.jsxs)("span", { children: [/* @__PURE__ */ (0, w.jsx)("b", {
					"aria-hidden": "true",
					children: "↔"
				}), " Breedte"] }), /* @__PURE__ */ (0, w.jsxs)("span", { children: [/* @__PURE__ */ (0, w.jsx)("b", {
					"aria-hidden": "true",
					children: "↕"
				}), " Hoogte"] })]
			}),
			e.uitsparingen.length > 0 && /* @__PURE__ */ (0, w.jsxs)("div", {
				className: "uitsparing-live",
				role: "status",
				"aria-live": "polite",
				children: [/* @__PURE__ */ (0, w.jsxs)("span", { children: [
					"3D-weergave bijgewerkt: ",
					e.uitsparingen.map((e) => `${e.volledigeBreedte ? e.hoek.endsWith("boven") ? "Boven" : "Onder" : _e.find((t) => t.id === e.hoek)?.label} ${e.volledigeBreedte ? "volledige breedte" : `${e.breedte} cm breed`} × ${e.volledigeHoogte ? "volledige hoogte" : `${e.hoogte} cm hoog`}`).join(" · "),
					"."
				] }), /* @__PURE__ */ (0, w.jsx)("button", {
					type: "button",
					onClick: r,
					children: "Bekijk 3D-model ↑"
				})]
			}),
			e.uitsparingen.map((t) => {
				let n = h(t.hoek, e.draairichting) ? 10 : 5;
				return /* @__PURE__ */ (0, w.jsxs)("div", {
					className: "uitsparing-maten",
					children: [
						/* @__PURE__ */ (0, w.jsx)("strong", { children: t.volledigeBreedte ? t.hoek.endsWith("boven") ? "Boven" : "Onder" : _e.find((e) => e.id === t.hoek)?.label }),
						/* @__PURE__ */ (0, w.jsxs)(Te, {
							label: "Breedte van de uitsparing",
							waarde: t.volledigeBreedte ? "Volledige breedte" : T(t.breedte),
							children: [!t.volledigeBreedte && /* @__PURE__ */ (0, w.jsx)(Oe, {
								label: `Breedte uitsparing ${t.hoek}`,
								waarde: t.breedte,
								onChange: (e) => s(t.hoek, { breedte: e }),
								schuifMin: n,
								schuifMax: a,
								invoerMin: n,
								invoerMax: a,
								stap: 5
							}), /* @__PURE__ */ (0, w.jsxs)("label", {
								className: "uitsparing-volledige-hoogte",
								children: [/* @__PURE__ */ (0, w.jsx)("input", {
									type: "checkbox",
									checked: !!t.volledigeBreedte,
									onChange: (e) => s(t.hoek, {
										volledigeBreedte: e.target.checked,
										volledigeHoogte: !e.target.checked && t.volledigeHoogte
									})
								}), /* @__PURE__ */ (0, w.jsx)("span", { children: "Uitsparing over de volledige breedte" })]
							})]
						}),
						!t.volledigeBreedte && n === 10 && /* @__PURE__ */ (0, w.jsx)("p", {
							className: "panel-hint",
							children: "Aan de niet-scharnierkant is de uitsparing minimaal 10 cm breed."
						}),
						/* @__PURE__ */ (0, w.jsxs)(Te, {
							label: "Hoogte van de uitsparing",
							waarde: t.volledigeHoogte ? "Volledige hoogte" : T(t.hoogte),
							children: [!t.volledigeHoogte && /* @__PURE__ */ (0, w.jsx)(Oe, {
								label: `Hoogte uitsparing ${t.hoek}`,
								waarde: t.hoogte,
								onChange: (e) => s(t.hoek, { hoogte: e }),
								schuifMin: 6,
								schuifMax: o,
								invoerMin: 6,
								invoerMax: o,
								stap: 6
							}), !t.volledigeBreedte && /* @__PURE__ */ (0, w.jsxs)("label", {
								className: "uitsparing-volledige-hoogte",
								children: [/* @__PURE__ */ (0, w.jsx)("input", {
									type: "checkbox",
									checked: !!t.volledigeHoogte,
									onChange: (e) => s(t.hoek, { volledigeHoogte: e.target.checked })
								}), /* @__PURE__ */ (0, w.jsx)("span", { children: "Uitsparing over de volledige hoogte" })]
							})]
						}),
						/* @__PURE__ */ (0, w.jsx)("p", {
							className: "panel-hint",
							children: t.volledigeHoogte ? "De uitsparing loopt als verticale strook van onder tot boven. Kies links of rechts; boven of onder maakt hierbij niet uit." : t.hoek.endsWith("boven") ? `De aanpassing begint automatisch op ${T(Math.max(0, i.kastHoogte - t.hoogte))} vanaf de vloer.` : "De aanpassing begint automatisch onderaan de kast."
						})
					]
				}, t.hoek);
			})
		]
	});
}
function ye({ config: e, onChange: t }) {
	return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		/* @__PURE__ */ (0, w.jsx)("p", {
			className: "panel-hint",
			children: "Kijk vanuit de gang naar je deur. Zitten de scharnieren links of rechts? De kast draait dezelfde kant op als de deur."
		}),
		/* @__PURE__ */ (0, w.jsx)("div", {
			className: "richting-grid",
			role: "radiogroup",
			"aria-label": "Draairichting",
			children: ["links", "rechts"].map((n) => /* @__PURE__ */ (0, w.jsxs)("button", {
				type: "button",
				role: "radio",
				"aria-label": `Scharnieren ${n}`,
				"aria-checked": e.draairichting === n,
				className: `richting-kaart ${e.draairichting === n ? "is-actief" : ""}`,
				onClick: () => t({
					draairichting: n,
					draairichtingBevestigd: !0
				}),
				children: [/* @__PURE__ */ (0, w.jsx)(be, { richting: n }), /* @__PURE__ */ (0, w.jsxs)("strong", { children: ["Scharnieren ", n] })]
			}, n))
		}),
		/* @__PURE__ */ (0, w.jsx)(De, {
			config: e,
			onderwerp: "draairichting",
			tekst: "Twijfel je over de draairichting? Stuur ons een foto van de deur."
		})
	] });
}
function be({ richting: e }) {
	return /* @__PURE__ */ (0, w.jsx)("svg", {
		viewBox: "-50 -8 100 62",
		width: "96",
		height: "60",
		"aria-hidden": "true",
		children: /* @__PURE__ */ (0, w.jsxs)("g", {
			transform: `scale(${e === "links" ? 1 : -1},1)`,
			children: [
				/* @__PURE__ */ (0, w.jsx)("rect", {
					x: "-50",
					y: "-4",
					width: "12",
					height: "8",
					fill: "#c9c3b8"
				}),
				/* @__PURE__ */ (0, w.jsx)("rect", {
					x: "38",
					y: "-4",
					width: "12",
					height: "8",
					fill: "#c9c3b8"
				}),
				/* @__PURE__ */ (0, w.jsx)("g", {
					transform: "translate(-36,0) rotate(-62)",
					children: /* @__PURE__ */ (0, w.jsx)("rect", {
						x: "0",
						y: "-9",
						width: "72",
						height: "9",
						rx: "1",
						fill: "#c8752b",
						opacity: "0.9"
					})
				}),
				/* @__PURE__ */ (0, w.jsx)("g", {
					transform: "translate(-38,4) rotate(-100)",
					children: /* @__PURE__ */ (0, w.jsx)("rect", {
						x: "0",
						y: "0",
						width: "76",
						height: "3",
						fill: "#1f2a44"
					})
				}),
				/* @__PURE__ */ (0, w.jsx)("circle", {
					cx: "-36",
					cy: "0",
					r: "3",
					fill: "#1f2a44"
				}),
				/* @__PURE__ */ (0, w.jsx)("path", {
					d: "M 20 0 A 56 56 0 0 1 -8 44",
					fill: "none",
					stroke: "#c8752b",
					strokeDasharray: "3 3"
				})
			]
		})
	});
}
function xe(e) {
	let { config: t, onChange: n } = e, r = [
		{
			id: "plankenkast",
			titel: "Plankenkast",
			sub: "1 vaste plank inbegrepen · verstelbare planken optioneel",
			prijs: `vanaf ${C(te[2])}`
		},
		{
			id: "garderobekast",
			titel: "Garderobekast",
			sub: "Met roede of haken",
			prijs: `vanaf ${C(439)}`
		},
		{
			id: "schoenenkast",
			titel: "Schoenenkast",
			sub: "Met schuine schoenenplanken",
			prijs: `vanaf ${C(429)}`
		}
	];
	return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		/* @__PURE__ */ (0, w.jsx)("div", {
			className: "optie-lijst",
			role: "radiogroup",
			"aria-label": "Type kast",
			children: r.map((e) => /* @__PURE__ */ (0, w.jsx)(O, {
				actief: t.type === e.id,
				onClick: () => {
					t.type !== e.id && n({ type: e.id });
				},
				titel: e.titel,
				sub: e.sub,
				prijs: e.prijs
			}, e.id))
		}),
		/* @__PURE__ */ (0, w.jsx)(Se, { ...e }),
		/* @__PURE__ */ (0, w.jsx)(Ce, { ...e })
	] });
}
function Se({ config: e, onChange: t }) {
	let r = n(e), i = s(e, r.kastHoogte - 2 * f.plaatDikte), a = i.planken.filter((e) => e.vast).length, o = i.planken.length - a, c = s({
		...e,
		extraLegplanken: 0
	}, r.kastHoogte - 2 * f.plaatDikte), u = c.planken.filter((e) => e.vast).length, d = c.planken.length - u;
	return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		e.type === "garderobekast" && /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "optie-lijst",
			role: "radiogroup",
			"aria-label": "Garderobe-uitvoering",
			children: [/* @__PURE__ */ (0, w.jsx)(O, {
				actief: e.garderobe === "roede",
				onClick: () => t({ garderobe: "roede" }),
				titel: "Met roede",
				sub: `Roede met ${l.roede} haken`,
				prijs: C(449)
			}), /* @__PURE__ */ (0, w.jsx)(O, {
				actief: e.garderobe === "haken",
				onClick: () => t({ garderobe: "haken" }),
				titel: "Met haken",
				sub: `${l.haken} zwarte plafondhaken met drie armen`,
				prijs: C(439)
			})]
		}), /* @__PURE__ */ (0, w.jsx)(Te, {
			label: "Extra haken",
			waarde: `${p(e)} haken totaal`,
			children: /* @__PURE__ */ (0, w.jsx)(k, {
				label: "Extra haken",
				waarde: e.extraGarderobehaken,
				min: 0,
				max: f.maxExtraHaken,
				onChange: (e) => t({ extraGarderobehaken: e }),
				prijsPerStuk: x.extraGarderobehaak
			})
		})] }),
		/* @__PURE__ */ (0, w.jsx)(Te, {
			label: e.type === "schoenenkast" ? "Aantal schuine schoenenplanken" : "Aantal verstelbare legplanken",
			waarde: `+${C(e.extraLegplanken * x.extraLegplank)}`,
			children: /* @__PURE__ */ (0, w.jsx)(k, {
				label: e.type === "schoenenkast" ? "Aantal schuine schoenenplanken" : "Aantal verstelbare legplanken",
				waarde: e.extraLegplanken,
				min: 0,
				max: f.maxLegplanken,
				onChange: (e) => t({ extraLegplanken: e }),
				prijsPerStuk: x.extraLegplank
			})
		}),
		e.type === "plankenkast" && /* @__PURE__ */ (0, w.jsxs)(Ee, { children: [
			u,
			" vaste plank",
			u === 1 ? "" : "en",
			" inbegrepen",
			d > 0 && `, plus ${d} verstelbare legplank${d === 1 ? "" : "en"}`,
			".",
			e.extraLegplanken > 0 ? ` ${e.extraLegplanken} verstelbare planken zijn geselecteerd (+${C(e.extraLegplanken * x.extraLegplank)}). Zet het aantal op 0 voor de vanafprijs van ${C(te[2])}.` : ` Je ziet nu de vanafprijs van ${C(te[2])}.`
		] }),
		e.type === "schoenenkast" && /* @__PURE__ */ (0, w.jsxs)(Ee, { children: ["De basisuitvoering heeft geen schoenenplanken.", e.extraLegplanken > 0 ? ` ${e.extraLegplanken} schuine planken zijn geselecteerd (+${C(e.extraLegplanken * x.extraLegplank)}). Zet het aantal op 0 voor de vanafprijs van ${C(429)}.` : ` Je ziet nu de vanafprijs van ${C(429)}.`] }),
		e.type === "garderobekast" && /* @__PURE__ */ (0, w.jsxs)(Ee, { children: [
			i.planken.length,
			" legplanken: ",
			a,
			" vast, ",
			o,
			" verstelbaar."
		] })
	] });
}
function Ce({ config: e, onChange: t }) {
	return /* @__PURE__ */ (0, w.jsxs)("section", {
		className: "extra-optie",
		"aria-label": "Kapstok achterop",
		children: [/* @__PURE__ */ (0, w.jsx)("h3", {
			className: "sub-kop",
			children: "Extra optie"
		}), /* @__PURE__ */ (0, w.jsx)(ke, {
			aan: e.kapstokAchterop,
			onChange: (e) => t({ kapstokAchterop: e }),
			titel: "Kapstok achterop",
			sub: "Witte kapstok van 45 cm, vastgeschroefd bovenop de kast; de haken hangen aan de achterkant.",
			prijs: x.kapstokAchterop
		})]
	});
}
function we({ config: e }) {
	let t = n(e), r = {
		"nog-niet-gekozen": "Nog niet gekozen",
		standaard: `Meer dan ${T(i(e.kozijnBreedte) + 2)} ruimte, standaarddiepte`,
		beperkt: "Niet genoeg ruimte; oplossing nog niet gekozen",
		verlaagd: `Kast ${T(t.kastDiepte)} diep (+${C(x.afwijkendeDiepte)})`,
		verdiept: `Kast ${T(t.kastDiepte)} diep (+${C(x.afwijkendeDiepte)}); meer dan 32 cm ruimte bevestigd`,
		uitsparing: `${e.uitsparingen.length} uitsparing${e.uitsparingen.length === 1 ? "" : "en"} voor obstakels`,
		"zelf-inmeten": "Extra maten volgen na bestelling",
		"laten-inmeten": `Laten inmeten (+${C(x.inmeetservice)})`
	}[e.diepteRoute], a = e.type === "plankenkast" ? `Plankenkast, 1 vaste plank en ${e.extraLegplanken} verstelbare plank${e.extraLegplanken === 1 ? "" : "en"}` : e.type === "garderobekast" ? `Garderobekast met ${e.garderobe === "roede" ? "roede" : "plafondhaken"} (${p(e)} stuks)` : "Schoenenkast", o = [
		["Kozijn (dagmaat)", `${T(e.kozijnBreedte)} × ${T(e.kozijnHoogte)}`],
		["Diepte", r],
		["Draairichting", e.draairichtingBevestigd ? `Scharnieren ${e.draairichting}` : "Nog niet gekozen"],
		["Indeling", a]
	];
	return e.burendealCodeBevestigd && e.burendealCode && o.push(["Burendealcode", e.burendealCode]), /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		/* @__PURE__ */ (0, w.jsx)("dl", {
			className: "samenvatting",
			children: o.map(([e, t]) => /* @__PURE__ */ (0, w.jsxs)("div", { children: [/* @__PURE__ */ (0, w.jsx)("dt", { children: e }), /* @__PURE__ */ (0, w.jsx)("dd", { children: t })] }, e))
		}),
		/* @__PURE__ */ (0, w.jsx)("h3", {
			className: "sub-kop",
			children: "Prijsopbouw"
		}),
		/* @__PURE__ */ (0, w.jsx)(D, { config: e })
	] });
}
function E({ config: e, onChange: t, aanbetaling: n, webshopBeschikbaar: r, bestelBezig: i, onBestel: a }) {
	let [o, s] = (0, b.useState)(!!e.burendealCode);
	return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
		/* @__PURE__ */ (0, w.jsx)("p", {
			className: "panel-hint",
			children: "Je betaalt nu de aanbetaling; het restant betaal je bij levering. Montage is inbegrepen."
		}),
		/* @__PURE__ */ (0, w.jsxs)("p", {
			className: "bestel-proces",
			children: [
				"Je ontvangt een bestelbevestiging per e-mail. ",
				/* @__PURE__ */ (0, w.jsx)("a", {
					href: "https://www.handigekasten.nl/pages/levering-en-levertijden",
					target: "_blank",
					rel: "noopener noreferrer",
					children: "Bekijk de actuele levertijd"
				}),
				"."
			]
		}),
		/* @__PURE__ */ (0, w.jsx)("section", {
			className: "burendeal-invoer",
			"aria-label": "Burendealcode",
			children: o ? /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [
				/* @__PURE__ */ (0, w.jsx)("label", {
					className: "burendeal-label",
					htmlFor: "burendeal-code",
					children: "Burendealcode"
				}),
				/* @__PURE__ */ (0, w.jsxs)("div", {
					className: "burendeal-code-rij",
					children: [/* @__PURE__ */ (0, w.jsx)("input", {
						id: "burendeal-code",
						type: "text",
						autoComplete: "off",
						value: e.burendealCode,
						onChange: (e) => {
							t({
								burendealCode: e.target.value,
								burendealCodeBevestigd: !1
							});
						},
						placeholder: "Vul je code in"
					}), /* @__PURE__ */ (0, w.jsx)("button", {
						type: "button",
						className: "cta",
						disabled: !e.burendealCode.trim(),
						onClick: () => {
							t({
								burendealCode: e.burendealCode.trim(),
								burendealCodeBevestigd: !0
							});
						},
						children: "Code meesturen ter controle"
					})]
				}),
				e.burendealCodeBevestigd && /* @__PURE__ */ (0, w.jsx)(Ee, { children: "Je code gaat mee met de bestelling en wordt daarna gecontroleerd. De getoonde prijs verandert nu niet." })
			] }) : /* @__PURE__ */ (0, w.jsx)("button", {
				type: "button",
				className: "knop-secundair",
				onClick: () => s(!0),
				children: "Ik heb een burendealcode"
			})
		}),
		/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "bestel-totaal",
			children: [/* @__PURE__ */ (0, w.jsx)("span", { children: "Totaal incl. btw" }), /* @__PURE__ */ (0, w.jsxs)("strong", { children: [S(e) && "vanaf ", C(ie(e))] })]
		}),
		/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "aanbetaling-overzicht",
			children: [/* @__PURE__ */ (0, w.jsxs)("div", { children: [/* @__PURE__ */ (0, w.jsx)("span", { children: "Nu aanbetalen" }), /* @__PURE__ */ (0, w.jsx)("strong", { children: C(n) })] }), /* @__PURE__ */ (0, w.jsxs)("div", { children: [/* @__PURE__ */ (0, w.jsx)("span", { children: "Restant bij levering" }), /* @__PURE__ */ (0, w.jsx)("strong", { children: C(Math.max(ie(e) - n, 0)) })] })]
		}),
		(e.diepteRoute === "laten-inmeten" || e.diepteRoute === "zelf-inmeten") && /* @__PURE__ */ (0, w.jsx)(Ee, { children: "De definitieve diepte en een eventuele extra dieptemeerprijs worden na het inmeten bepaald." }),
		r ? /* @__PURE__ */ (0, w.jsx)("button", {
			type: "button",
			className: "knop-secundair nog-een-kast",
			disabled: i,
			onClick: () => a("nog-een-kast"),
			children: "Nog een kast toevoegen"
		}) : /* @__PURE__ */ (0, w.jsx)(Ee, { children: "Dit is de lokale voorbeeldweergave. De bestelknop wordt actief op de webshop." })
	] });
}
function D({ config: e }) {
	let t = re(e);
	return /* @__PURE__ */ (0, w.jsxs)("table", {
		className: "prijs-tabel",
		children: [/* @__PURE__ */ (0, w.jsx)("tbody", { children: t.map((e) => /* @__PURE__ */ (0, w.jsxs)("tr", { children: [/* @__PURE__ */ (0, w.jsxs)("td", { children: [e.label, e.detail && /* @__PURE__ */ (0, w.jsx)("small", { children: e.detail })] }), /* @__PURE__ */ (0, w.jsxs)("td", { children: [e.vanaf && "vanaf ", C(e.bedrag)] })] }, e.id)) }), /* @__PURE__ */ (0, w.jsx)("tfoot", { children: /* @__PURE__ */ (0, w.jsxs)("tr", { children: [/* @__PURE__ */ (0, w.jsx)("td", { children: "Totaal" }), /* @__PURE__ */ (0, w.jsx)("td", { children: C(ie(e)) })] }) })]
	});
}
function Te({ label: e, waarde: t, children: n }) {
	return /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "field",
		children: [/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "field-label",
			children: [/* @__PURE__ */ (0, w.jsx)("span", { children: e }), t && /* @__PURE__ */ (0, w.jsx)("span", {
				className: "field-value",
				children: t
			})]
		}), n]
	});
}
function Ee({ children: e, soort: t = "info" }) {
	return /* @__PURE__ */ (0, w.jsx)("div", {
		className: `info info-${t}`,
		children: e
	});
}
function De({ config: e, onderwerp: t, tekst: n }) {
	return /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "contact-hulp",
		children: [/* @__PURE__ */ (0, w.jsx)("span", { children: n }), /* @__PURE__ */ (0, w.jsx)("a", {
			href: ue(e, t),
			target: "_blank",
			rel: "noopener noreferrer",
			children: "Vraag hulp via WhatsApp ↗"
		})]
	});
}
function O({ actief: e, onClick: t, titel: n, sub: r, prijs: i }) {
	return /* @__PURE__ */ (0, w.jsxs)("button", {
		type: "button",
		role: "radio",
		"aria-label": n,
		"aria-checked": e,
		className: `optie-kaart ${e ? "is-actief" : ""}`,
		onClick: t,
		children: [
			/* @__PURE__ */ (0, w.jsx)("span", {
				className: "optie-radio",
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ (0, w.jsxs)("span", {
				className: "optie-tekst",
				children: [/* @__PURE__ */ (0, w.jsx)("strong", { children: n }), /* @__PURE__ */ (0, w.jsx)("small", { children: r })]
			}),
			/* @__PURE__ */ (0, w.jsx)("span", {
				className: "optie-prijs",
				children: i
			})
		]
	});
}
function k({ label: e, waarde: t, onChange: n, min: r = 0, max: i = 99, eenheid: a, prijsPerStuk: o }) {
	return /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "stepper-rij",
		children: [/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "stepper",
			children: [
				/* @__PURE__ */ (0, w.jsx)("button", {
					type: "button",
					onClick: () => n(t - 1),
					disabled: t <= r,
					"aria-label": `${e} verlagen`,
					children: "−"
				}),
				/* @__PURE__ */ (0, w.jsxs)("span", {
					"aria-live": "polite",
					children: [t, a && ` ${a}`]
				}),
				/* @__PURE__ */ (0, w.jsx)("button", {
					type: "button",
					onClick: () => n(t + 1),
					disabled: t >= i,
					"aria-label": `${e} verhogen`,
					children: "+"
				})
			]
		}), o !== void 0 && /* @__PURE__ */ (0, w.jsxs)("span", {
			className: "stepper-prijs",
			children: [C(o), " per stuk"]
		})]
	});
}
var A = (e, t, n) => Math.min(n, Math.max(t, e));
function Oe({ label: e, waarde: t, onChange: n, schuifMin: r, schuifMax: i, invoerMin: a, invoerMax: o, stap: s = 1, markeringen: c, actieveMarkering: l }) {
	let [u, d] = (0, b.useState)(null), f = A(t, r, i), p = (e) => (e - r) / (i - r), m = (e) => {
		let t = Math.round(Number(e.replace(",", "."))), n = Math.round((t - a) / s) * s + a;
		return e.trim() !== "" && Number.isFinite(n) ? n : null;
	}, h = (e) => {
		d(e);
		let t = m(e);
		t !== null && t >= a && t <= o && n(t);
	};
	return /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "maat-schuif",
		children: [/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "maat-schuif-rij",
			children: [/* @__PURE__ */ (0, w.jsxs)("div", {
				className: "maat-schuif-baan",
				children: [/* @__PURE__ */ (0, w.jsx)("input", {
					type: "range",
					min: r,
					max: i,
					step: s,
					value: f,
					"aria-label": `${e} (schuifregelaar)`,
					"aria-valuetext": `${t} cm`,
					style: { "--p": p(f) },
					onChange: (e) => {
						d(null), n(Number(e.target.value));
					}
				}), c && /* @__PURE__ */ (0, w.jsx)("div", {
					className: "maat-schuif-streepjes",
					"aria-hidden": "true",
					children: c.map((e) => /* @__PURE__ */ (0, w.jsx)("span", {
						className: e === l ? "is-actief" : void 0,
						style: { left: `${p(e) * 100}%` }
					}, e))
				})]
			}), /* @__PURE__ */ (0, w.jsxs)("label", {
				className: "maat-invoer",
				children: [/* @__PURE__ */ (0, w.jsx)("input", {
					type: "number",
					inputMode: "numeric",
					step: s,
					min: a,
					max: o,
					"aria-label": `${e} in cm`,
					value: u ?? String(t),
					onChange: (e) => h(e.target.value),
					onBlur: () => {
						if (u === null) return;
						let e = m(u);
						e !== null && n(A(e, a, o)), d(null);
					},
					onKeyDown: (e) => {
						e.key === "Enter" && e.currentTarget.blur(), e.key === "Escape" && d(null);
					}
				}), /* @__PURE__ */ (0, w.jsx)("span", {
					"aria-hidden": "true",
					children: "cm"
				})]
			})]
		}), /* @__PURE__ */ (0, w.jsxs)("div", {
			className: "maat-schuif-schaal",
			"aria-hidden": "true",
			children: [/* @__PURE__ */ (0, w.jsxs)("span", { children: [r, " cm"] }), /* @__PURE__ */ (0, w.jsxs)("span", { children: [i, " cm"] })]
		})]
	});
}
function ke({ aan: e, onChange: t, titel: n, sub: r, prijs: i, uitgeschakeld: a }) {
	return /* @__PURE__ */ (0, w.jsxs)("button", {
		type: "button",
		role: "switch",
		"aria-checked": e,
		"aria-label": n,
		disabled: a,
		className: `schakelaar ${e ? "is-aan" : ""} ${a ? "is-uitgeschakeld" : ""}`,
		onClick: () => t(!e),
		children: [
			/* @__PURE__ */ (0, w.jsx)("span", {
				className: "schakelaar-track",
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ (0, w.jsxs)("span", {
				className: "optie-tekst",
				children: [/* @__PURE__ */ (0, w.jsx)("strong", { children: n }), r && /* @__PURE__ */ (0, w.jsx)("small", { children: r })]
			}),
			i !== void 0 && /* @__PURE__ */ (0, w.jsxs)("span", {
				className: "optie-prijs",
				children: ["+", C(i)]
			})
		]
	});
}
//#endregion
//#region src/components/SceneErrorBoundary.tsx
var Ae = class extends b.Component {
	state = { fout: null };
	static getDerivedStateFromError(e) {
		return { fout: e };
	}
	componentDidCatch(e, t) {
		console.error("3D-scène fout:", e, t.componentStack);
	}
	render() {
		return this.state.fout ? /* @__PURE__ */ (0, w.jsxs)("div", {
			className: "scene-fout",
			role: "alert",
			children: [
				/* @__PURE__ */ (0, w.jsx)("strong", { children: "De 3D-weergave kon niet worden geladen." }),
				/* @__PURE__ */ (0, w.jsx)("span", { children: this.state.fout.message }),
				/* @__PURE__ */ (0, w.jsx)("button", {
					type: "button",
					className: "scene-knop",
					onClick: () => this.setState({ fout: null }),
					children: "Opnieuw proberen"
				})
			]
		}) : this.props.children;
	}
};
function je(e, t) {
	let r = n(e);
	switch (t) {
		case "kasttype": return !Number.isInteger(e.extraLegplanken) || e.extraLegplanken < 0 || e.extraLegplanken > f.maxLegplanken ? "Kies een geldig aantal legplanken." : !Number.isInteger(e.extraGarderobehaken) || e.extraGarderobehaken < 0 || e.extraGarderobehaken > f.maxExtraHaken ? "Kies een geldig aantal extra haken." : null;
		case "afmetingen": return !Number.isInteger(e.kozijnBreedte) || e.kozijnBreedte < f.kozijnBreedteInvoerMin || e.kozijnBreedte > f.kozijnBreedteInvoerMax || !Number.isInteger(e.kozijnHoogte) || e.kozijnHoogte < f.kozijnHoogteInvoerMin || e.kozijnHoogte > f.kozijnHoogteInvoerMax ? "Controleer de breedte en hoogte van je kozijn in hele centimeters." : e.kozijnBreedte < r.minDagmaat ? `Een kast van ${r.kastBreedte} cm heeft minimaal ${r.minDagmaat} cm dagmaat nodig. Neem contact met ons op.` : null;
		case "diepte":
			if (e.diepteRoute === "nog-niet-gekozen" || e.diepteRoute === "beperkt") return "Kies hoeveel ruimte er is en hoe je verder wilt met de diepte.";
			if (e.diepteRoute === "verlaagd" && i(e.kozijnBreedte) !== 30) return "Deze afwijkende diepte is niet beschikbaar bij jouw kozijnbreedte. Kies opnieuw.";
			if (e.diepteRoute === "verdiept" && i(e.kozijnBreedte) !== 25) return "De optie van 30 cm diep is alleen beschikbaar bij een smaller kozijn. Kies opnieuw.";
			if (e.diepteRoute === "uitsparing") {
				if (e.uitsparingen.length === 0) return "Kies waar de kast een uitsparing nodig heeft.";
				if (new Set(e.uitsparingen.map((e) => e.hoek)).size !== e.uitsparingen.length) return "Kies elke hoek maar één keer.";
				for (let t of e.uitsparingen) {
					if (t.volledigeBreedte && t.volledigeHoogte) return "Een uitsparing kan niet tegelijk over de volledige breedte en hoogte lopen.";
					if (t.volledigeBreedte && e.uitsparingen.some((e) => e !== t && e.hoek.endsWith("boven") === t.hoek.endsWith("boven"))) return "Kies boven of onder maar één keer als de uitsparing over de volledige breedte loopt.";
					let n = h(t.hoek, e.draairichting) ? 10 : 5;
					if (!t.volledigeBreedte && (!Number.isInteger(t.breedte) || t.breedte < n || t.breedte % 5 != 0 || t.breedte >= r.kastBreedte - f.profiel) || !t.volledigeHoogte && (!Number.isInteger(t.hoogte) || t.hoogte < 6 || t.hoogte % 6 != 0 || t.hoogte >= r.kastHoogte)) return "Controleer de breedte en hoogte van de uitsparing.";
				}
				let t = e.uitsparingen.find((e) => e.volledigeBreedte && e.hoek.endsWith("boven")), n = e.uitsparingen.find((e) => e.volledigeBreedte && e.hoek.endsWith("onder"));
				if (t && n && t.hoogte + n.hoogte >= r.kastHoogte) return "De uitsparingen boven en onder mogen samen niet de hele kasthoogte beslaan.";
			}
			return null;
		case "draairichting": return e.draairichtingBevestigd && e.draairichting !== "onbekend" ? null : "Kies of de scharnieren links of rechts zitten.";
		case "bestellen": return e.burendealCode.trim() && !e.burendealCodeBevestigd ? "Klik op Code meesturen ter controle voordat je bestelt, of maak het codeveld leeg." : null;
		default: return null;
	}
}
function Me(e) {
	for (let t of [
		"kasttype",
		"draairichting",
		"afmetingen",
		"diepte",
		"bestellen"
	]) {
		let n = je(e, t);
		if (n) return {
			stap: t,
			melding: n
		};
	}
	return null;
}
function Ne(e) {
	return e.type === "plankenkast" ? "Plankenkast" : e.type === "schoenenkast" ? "Schoenenkast" : e.garderobe === "roede" ? "Garderobekast met roede" : "Garderobekast met haken";
}
function Pe(e) {
	let t = n(e);
	switch (e.diepteRoute) {
		case "standaard": return `${t.kastDiepte} cm diep`;
		case "verlaagd": return `${t.kastDiepte} cm diep (+ ${C(x.afwijkendeDiepte)})`;
		case "verdiept": return `${t.kastDiepte} cm diep (+ ${C(x.afwijkendeDiepte)}); klant bevestigt meer dan 32 cm ruimte achter de deur.`;
		case "uitsparing": return `${t.kastDiepte} cm diep, met ${e.uitsparingen.length} uitsparing${e.uitsparingen.length === 1 ? "" : "en"}`;
		case "zelf-inmeten": return "Zelf inmeten; klant geeft extra maten later door via bestelmail, WhatsApp of inmeetbelletje.";
		case "laten-inmeten": return `Laten inmeten (+ ${C(x.inmeetservice)}); definitieve diepte en eventuele meerprijs na inmeten.`;
		default: return "Nog niet gekozen";
	}
}
function Fe(e, t = 50) {
	let r = Me(e);
	if (r) throw Error(r.melding);
	if (!Number.isFinite(t) || t <= 0) throw Error("De aanbetaling is niet geldig.");
	let i = n(e), a = ie(e), o = Math.max(a - t, 0), s = e.diepteRoute === "laten-inmeten" || e.diepteRoute === "zelf-inmeten", c = {
		"Soort kast": Ne(e),
		"Breedte kozijn": `${e.kozijnBreedte} cm`,
		"Hoogte kozijn": `${e.kozijnHoogte} cm`,
		"Diepte kast": Pe(e),
		Draairichting: `Scharnieren ${e.draairichting}`,
		_Aanbetaling: C(t),
		"_Configurator versie": "HK 3D configurator v1"
	};
	return e.type === "plankenkast" && (c["Aantal verstelbare legplanken"] = `${e.extraLegplanken} stuks (+ ${C(e.extraLegplanken * x.extraLegplank)})`), e.type === "schoenenkast" && (c["Aantal schuine schoenenplanken"] = `${e.extraLegplanken} stuks (+ ${C(e.extraLegplanken * x.extraLegplank)})`), e.type === "garderobekast" && (c["Garderobe-uitvoering"] = e.garderobe === "roede" ? "Roede met 5 haken" : "3 plafondhaken", c["Extra haken"] = `${e.extraGarderobehaken} stuks`, c["Extra verstelbare legplanken"] = `${e.extraLegplanken} stuks`), i.frameHoogteVerplicht && (c["Maatwerk frame"] = `Ja (+ ${C(x.frameHoogte)})`), e.bovenplaat && i.bovenplaatMogelijk && (c.Bovenplaat = `Ja (+ ${C(x.bovenplaat)})`), e.kapstokAchterop && (c["Kapstok achterop"] = `Ja (+ ${C(x.kapstokAchterop)})`), e.bovenlicht !== "geen" && (c["Bestaand bovenlicht"] = `${e.bovenlicht === "glas" ? "Glas" : "Plaat"}, ${f.bovenlichtHoogte} cm (niet geleverd)`), e.diepteRoute === "uitsparing" && e.uitsparingen.forEach((e, t) => {
		let n = e.volledigeBreedte ? e.hoek.endsWith("boven") ? "Boven" : "Onder" : {
			linksboven: "Linksboven",
			rechtsboven: "Rechtsboven",
			linksonder: "Linksonder",
			rechtsonder: "Rechtsonder"
		}[e.hoek], r = e.volledigeHoogte ? i.kastHoogte : e.hoogte, a = e.volledigeHoogte ? 0 : n.endsWith("boven") ? i.kastHoogte - r : 0, o = e.volledigeHoogte ? "verticale strook over de volledige kasthoogte, voorkant dichtgezet met spaanplaat" : "kastdeel over de volledige diepte verwijderd, voorkant dichtgezet met spaanplaat en vaste afwerkplank over de volledige breedte";
		c[`Uitsparing ${t + 1}`] = `${n}: ${e.volledigeBreedte ? `volledige breedte (${i.kastBreedte} cm)` : `${e.breedte} cm breed`} × ${e.volledigeHoogte ? "volledige hoogte" : `${r} cm hoog`}, begint op ${a} cm vanaf de vloer (+ ${C(x.uitsparing)}); ${o}`;
	}), e.burendealCode.trim() && (c.Burendeal = "Bestaande code; korting na controle", c["Burendeal-code"] = e.burendealCode.trim()), c["Volledige prijs"] = `${C(a)}${s ? " (excl. eventuele dieptemeerprijs na inmeten)" : ""}`, c["Restant bij levering"] = `${C(o)}${s ? " (excl. eventuele dieptemeerprijs na inmeten)" : ""}`, {
		totaal: a,
		aanbetaling: t,
		restant: o,
		eigenschappen: c
	};
}
//#endregion
//#region src/shopifyCart.ts
function Ie(e, t) {
	let n = new URL(e.cartRoot, t);
	if (n.origin !== t) throw Error("De winkelwagen-URL hoort niet bij deze winkel.");
	let r = n.pathname.endsWith("/") ? n.pathname : `${n.pathname}/`;
	return new URL(`${r}cart/add.js`, t).toString();
}
async function Le(e, t, n = fetch, r = window.location.origin) {
	if (!/^\d{10,20}$/.test(e.depositVariantId)) throw Error("De aanbetalingsvariant is nog niet ingesteld.");
	let i = Number(e.depositVariantId);
	if (!Number.isSafeInteger(i)) throw Error("De aanbetalingsvariant heeft een ongeldig ID.");
	if (e.depositAmount !== t.aanbetaling) throw Error("De aanbetaling in de winkel komt niet overeen met de configurator.");
	let a = await n(Ie(e, r), {
		method: "POST",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json"
		},
		body: JSON.stringify({ items: [{
			id: i,
			quantity: 1,
			properties: t.eigenschappen
		}] })
	});
	if (!a.ok) {
		let e = "";
		try {
			let t = await a.json();
			e = t.description || t.message || "";
		} catch {}
		throw Error(e || "De kast kon niet aan de winkelwagen worden toegevoegd. Probeer het opnieuw.");
	}
}
//#endregion
//#region src/App.tsx
var Re = (0, b.lazy)(() => import("./KastScene-Cklf2R3_.js").then(({ KastScene: e }) => ({ default: e }))), ze = ["draairichting"], Be = ["afmetingen", "diepte"];
function Ve() {
	let e = new URLSearchParams(window.location.search).get("model");
	return e === "coat-rod" ? {
		...o,
		type: "garderobekast",
		garderobe: "roede",
		extraLegplanken: u.garderobekast
	} : e === "coat-hooks" ? {
		...o,
		type: "garderobekast",
		garderobe: "haken",
		extraLegplanken: u.garderobekast
	} : e === "shoes" ? {
		...o,
		type: "schoenenkast",
		extraLegplanken: u.schoenenkast
	} : e && [
		"2",
		"4",
		"6",
		"8"
	].includes(e) ? {
		...o,
		type: "plankenkast",
		extraLegplanken: Number(e) - 2
	} : { ...o };
}
function He({ shopify: e }) {
	let [t, n] = (0, b.useState)(Ve), [r, i] = (0, b.useState)(0), [a, o] = (0, b.useState)(!1), [s, c] = (0, b.useState)(0), [l, d] = (0, b.useState)("glas"), [p, m] = (0, b.useState)(null), [g, _] = (0, b.useState)(!1), [v, y] = (0, b.useState)(null), ee = (0, b.useRef)({}), te = (0, b.useRef)(null), x = ae[r].id;
	function ne(e) {
		let r = e;
		if (e.type && e.type !== t.type && (ee.current[t.type] = t.extraLegplanken, r = {
			...e,
			extraLegplanken: ee.current[e.type] ?? u[e.type]
		}), e.draairichting && e.draairichting !== t.draairichting) {
			let n = r.uitsparingen ?? t.uitsparingen;
			r = {
				...r,
				uitsparingen: n.map((t) => h(t.hoek, e.draairichting) && t.breedte < 10 ? {
					...t,
					breedte: 10
				} : t)
			};
		}
		(r.bovenlicht === "plaat" || r.bovenlicht === "glas") && d(r.bovenlicht), r.kapstokAchterop && o(!0), n((e) => {
			let t = r.kozijnBreedte !== void 0 && r.kozijnBreedte !== e.kozijnBreedte, n = r.kozijnHoogte ?? e.kozijnHoogte;
			return {
				...e,
				...r,
				...t ? { diepteRoute: "nog-niet-gekozen" } : {},
				...n <= f.bovenplaatVanaf ? { bovenplaat: !1 } : {}
			};
		}), m(null), y(null);
	}
	function re() {
		ne({ bovenlicht: t.bovenlicht === "geen" ? l : "geen" });
	}
	function ie() {
		te.current?.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	}
	function S(e) {
		let n = Math.max(0, Math.min(ae.length - 1, e));
		if (n > r) for (let e = 0; e < n; e++) {
			let n = je(t, ae[e].id);
			if (n) {
				i(e), m(n);
				return;
			}
		}
		i(n), m(null), o(ze.includes(ae[n].id));
	}
	async function C(r) {
		if (g) return;
		let a = Me(t);
		if (a) {
			i(ae.findIndex((e) => e.id === a.stap)), m(a.melding);
			return;
		}
		if (!e) {
			m("Bestellen is beschikbaar zodra deze configurator in de Shopify-webshop staat.");
			return;
		}
		_(!0), m(null), y(null);
		try {
			if (await Le(e, Fe(t, e.depositAmount)), r === "checkout") {
				window.location.assign(e.checkoutUrl);
				return;
			}
			n(Ve()), ee.current = {}, i(0), o(!1), y("Je kast is toegevoegd aan de winkelwagen. Stel nu je volgende kast samen.");
		} catch (e) {
			m(e instanceof Error ? e.message : "Bestellen is niet gelukt. Probeer het opnieuw.");
		} finally {
			_(!1);
		}
	}
	return /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "app",
		children: [/* @__PURE__ */ (0, w.jsxs)("header", {
			className: "topbar",
			children: [/* @__PURE__ */ (0, w.jsxs)("div", { children: [/* @__PURE__ */ (0, w.jsx)("span", {
				className: "brand",
				children: "handigekasten · 3D-configurator"
			}), e ? /* @__PURE__ */ (0, w.jsx)("h2", { children: "Ontwerp je draaiende inzetkast" }) : /* @__PURE__ */ (0, w.jsx)("h1", { children: "Ontwerp je draaiende inzetkast" })] }), !e && /* @__PURE__ */ (0, w.jsx)("span", {
				className: "prototype-badge",
				children: "Voorbeeld"
			})]
		}), /* @__PURE__ */ (0, w.jsxs)("div", {
			className: "content",
			children: [
				/* @__PURE__ */ (0, w.jsxs)("div", {
					className: "scene-wrap",
					ref: te,
					children: [/* @__PURE__ */ (0, w.jsx)(Ae, { children: /* @__PURE__ */ (0, w.jsx)(b.Suspense, {
						fallback: /* @__PURE__ */ (0, w.jsx)("div", {
							className: "scene-laden",
							role: "status",
							children: "3D-weergave laden…"
						}),
						children: /* @__PURE__ */ (0, w.jsx)(Re, {
							config: t,
							open: a,
							toonMaten: Be.includes(x),
							cameraReset: s
						})
					}) }), /* @__PURE__ */ (0, w.jsx)("div", {
						className: "scene-hint",
						children: "Sleep om rond te kijken · scroll of knijp om te zoomen"
					})]
				}),
				/* @__PURE__ */ (0, w.jsxs)("div", {
					className: "scene-knoppen",
					role: "group",
					"aria-label": "3D-weergave",
					children: [
						/* @__PURE__ */ (0, w.jsxs)("button", {
							type: "button",
							className: "scene-knop scene-schakelaar",
							role: "switch",
							"aria-checked": a,
							onClick: () => o((e) => !e),
							children: [/* @__PURE__ */ (0, w.jsx)("span", { children: "Draai kast open" }), /* @__PURE__ */ (0, w.jsx)("span", {
								className: "scene-schakelaar-schuif",
								"aria-hidden": "true",
								children: /* @__PURE__ */ (0, w.jsx)("span", { className: "scene-schakelaar-knop" })
							})]
						}),
						/* @__PURE__ */ (0, w.jsx)("button", {
							type: "button",
							className: "scene-knop",
							onClick: () => c((e) => e + 1),
							children: "Standaardaanzicht"
						}),
						/* @__PURE__ */ (0, w.jsxs)("button", {
							type: "button",
							className: "scene-knop scene-schakelaar scene-bovenlicht",
							role: "switch",
							"aria-checked": t.bovenlicht !== "geen",
							onClick: re,
							children: [/* @__PURE__ */ (0, w.jsx)("span", { children: "Ik heb een bovenlicht" }), /* @__PURE__ */ (0, w.jsx)("span", {
								className: "scene-schakelaar-schuif",
								"aria-hidden": "true",
								children: /* @__PURE__ */ (0, w.jsx)("span", { className: "scene-schakelaar-knop" })
							})]
						})
					]
				}),
				/* @__PURE__ */ (0, w.jsx)(de, {
					config: t,
					onChange: ne,
					stap: r,
					onStap: S,
					fout: p,
					bestelBericht: v,
					bestelBezig: g,
					webshopBeschikbaar: !!e,
					onBestel: C,
					onView3D: ie,
					onToggleBovenlicht: re,
					aanbetaling: e?.depositAmount ?? 50
				})
			]
		})]
	});
}
//#endregion
//#region src/App.css?inline
var Ue = ":root{--navy:#222;--accent:#f8692b;--accent-zacht:#fff3ed;--tekst:#222;--tekst-zacht:#696969;--rand:#e8e8e8;--vlak:#f8f8f8}.app{flex-direction:column;width:100%;height:100dvh;display:flex;overflow:hidden}.topbar{background:var(--navy);color:#fff;flex-shrink:0;justify-content:space-between;align-items:center;gap:16px;padding:12px 24px;display:flex}.brand{letter-spacing:1px;text-transform:uppercase;opacity:.7;font-size:12px}.topbar h1,.topbar h2{margin:2px 0 0;font-size:21px;font-weight:600}.prototype-badge{letter-spacing:1px;text-transform:uppercase;white-space:nowrap;border:1px solid #ffffff59;border-radius:999px;padding:4px 10px;font-size:11px;font-weight:700}.content{flex:1;min-height:0;display:flex;position:relative}.scene-wrap{background:#e7e3da;flex:auto;min-width:0;position:relative}.scene-laden{width:100%;height:100%;color:var(--tekst-zacht);place-items:center;font-size:14px;display:grid}.scene-knoppen{z-index:30;flex-wrap:wrap;gap:8px;display:flex;position:absolute;top:16px;left:16px}.scene-knop{color:var(--navy);border:1px solid var(--rand);cursor:pointer;background:#ffffffeb;border-radius:999px;padding:8px 14px;font-size:13px;font-weight:600;box-shadow:0 2px 8px #00000014}.scene-knop:hover{background:#fff}.scene-schakelaar{align-items:center;gap:9px;display:inline-flex}.scene-schakelaar-schuif{box-sizing:border-box;background:#b9b9b9;border-radius:999px;flex:none;width:28px;height:16px;padding:2px;transition:background-color .15s}.scene-schakelaar-knop{background:#fff;border-radius:50%;width:12px;height:12px;transition:transform .15s;display:block;box-shadow:0 1px 3px #0003}.scene-schakelaar[aria-checked=true] .scene-schakelaar-schuif{background:var(--accent)}.scene-schakelaar[aria-checked=true] .scene-schakelaar-knop{transform:translate(12px)}.scene-schakelaar:focus-visible{outline:2px solid var(--accent);outline-offset:2px}.scene-hint{color:#1f2a4499;pointer-events:none;white-space:nowrap;background:#fff9;border-radius:999px;padding:4px 10px;font-size:12px;position:absolute;bottom:12px;left:50%;transform:translate(-50%)}.scene-fout{text-align:center;color:var(--tekst);flex-direction:column;justify-content:center;align-items:center;gap:8px;padding:24px;font-size:14px;display:flex;position:absolute;inset:0}.scene-fout span{color:var(--tekst-zacht);max-width:420px;font-size:12px}.panel{z-index:1;background:#fff;flex-direction:column;flex:0 0 400px;min-width:0;min-height:0;display:flex;box-shadow:-4px 0 16px #0000000f}.stappen{border-bottom:1px solid var(--rand);scrollbar-width:thin;flex-shrink:0;justify-content:space-between;gap:4px;padding:12px 16px;display:flex}.stap-chip{border:1px solid var(--rand);color:var(--tekst-zacht);cursor:pointer;background:#fff;border-radius:999px;flex-shrink:0;align-items:center;gap:6px;padding:3px;font-size:12px;display:inline-flex}.stap-nr{background:var(--vlak);border-radius:50%;place-items:center;width:20px;height:20px;font-size:11px;font-weight:700;display:inline-grid}.stap-chip.is-klaar .stap-nr{background:var(--accent-zacht);color:var(--accent)}.stap-chip.is-actief{border-color:var(--accent);color:var(--tekst);font-weight:600}.stap-chip.is-actief .stap-nr{background:var(--accent);color:#fff}.panel-body{flex:1;padding:20px 24px 8px;overflow-y:auto}.panel-step{letter-spacing:1px;color:var(--accent);font-size:11px;font-weight:700}.panel h2{color:var(--tekst);margin:6px 0 4px;font-size:22px}.panel-hint{color:var(--tekst-zacht);margin:4px 0 18px;font-size:14px;line-height:1.45}.bestel-fout,.bestel-succes{border-radius:9px;margin:12px 0 16px;padding:11px 13px;font-size:13px;line-height:1.45}.bestel-fout{color:#8b2626;background:#fff1f0;border:1px solid #f2c9c5}.bestel-succes{color:#195b39;background:#eaf7ef;border:1px solid #b8dfc7}.aanbetaling-overzicht{gap:7px;margin:14px 0;font-size:14px;display:grid}.aanbetaling-overzicht>div{justify-content:space-between;gap:16px;display:flex}.nog-een-kast{cursor:pointer;width:100%;margin-top:10px;padding:12px 16px}.sub-kop{color:var(--tekst);margin:20px 0 10px;font-size:14px}.uitsparing-editor{padding:2px 0 8px}.uitsparing-schets{background:repeating-linear-gradient(#f5f3ee 0 42px,#d5d0c7 43px 45px,#f5f3ee 46px 55px);border:7px solid #dedbd5;width:180px;height:220px;margin:12px auto 4px;position:relative;box-shadow:0 4px 14px #2222221a}.uitsparing-vorm{z-index:1;outline:2px dashed var(--accent);pointer-events:none;background:#fff;position:absolute}.uitsparing-vorm.links{left:0}.uitsparing-vorm.rechts{right:0}.uitsparing-pijlen{z-index:2;pointer-events:none;width:100%;height:100%;position:absolute;inset:0;overflow:visible}.uitsparing-pijl{fill:none;stroke:var(--accent);stroke-width:1.4px;vector-effect:non-scaling-stroke;paint-order:stroke}.uitsparing-hoek{z-index:2;width:50%;height:50%;color:var(--tekst);cursor:pointer;background:0 0;border:0;padding:8px;font-size:11px;font-weight:700;display:flex;position:absolute}.uitsparing-hoek:hover,.uitsparing-hoek:focus-visible{outline:2px solid var(--accent);outline-offset:-3px;background:0 0}.uitsparing-hoek:hover:not([aria-pressed=true]){background:#f8692b14}.uitsparing-hoek[aria-pressed=true]{color:#0000}.uitsparing-hoek:disabled{cursor:default;opacity:.45}.uitsparing-hoek.linksboven{justify-content:flex-start;align-items:flex-start;top:0;left:0}.uitsparing-hoek.rechtsboven{justify-content:flex-end;align-items:flex-start;top:0;right:0}.uitsparing-hoek.linksonder{justify-content:flex-start;align-items:flex-end;bottom:0;left:0}.uitsparing-hoek.rechtsonder{justify-content:flex-end;align-items:flex-end;bottom:0;right:0}.uitsparing-bijschrift{text-align:center;color:var(--tekst-zacht);margin:0 0 16px;font-size:12px}.uitsparing-maatlegenda{color:var(--tekst-zacht);justify-content:center;gap:20px;margin:-8px 0 12px;font-size:12px;display:flex}.uitsparing-maatlegenda span{align-items:center;gap:5px;display:inline-flex}.uitsparing-maatlegenda b{color:var(--accent);font-size:19px;line-height:1}.uitsparing-live{display:none}.uitsparing-maten{border:1px solid var(--rand);background:#fff;border-radius:10px;margin:12px 0;padding:14px}.uitsparing-maten>strong{margin-bottom:14px;display:block}.uitsparing-volledige-hoogte{color:var(--tekst);cursor:pointer;align-items:flex-start;gap:9px;margin-top:12px;font-size:13px;line-height:1.4;display:flex}.uitsparing-volledige-hoogte input{accent-color:var(--accent);flex:none;margin:2px 0 0}.field{margin-bottom:20px}.field-label{color:var(--tekst);justify-content:space-between;margin-bottom:8px;font-size:14px;font-weight:600;display:flex}.field-value{color:var(--accent);font-weight:700}.vakken-grid{grid-template-columns:repeat(4,1fr);gap:8px;display:grid}.optie-knop{border:1px solid var(--rand);cursor:pointer;color:var(--tekst);background:#fff;border-radius:8px;flex-direction:column;align-items:center;gap:2px;padding:8px 4px;font-size:14px;display:flex}.optie-knop small{color:var(--tekst-zacht);font-size:11px}.optie-knop:hover{border-color:#cfc9bf}.optie-knop.is-actief{border-color:var(--accent);background:var(--accent-zacht);box-shadow:inset 0 0 0 1px var(--accent)}.optie-lijst{flex-direction:column;gap:8px;margin-bottom:18px;display:flex}.optie-kaart,.schakelaar,.status-regel{border:1px solid var(--rand);text-align:left;cursor:pointer;width:100%;color:var(--tekst);font:inherit;background:#fff;border-radius:10px;align-items:center;gap:12px;margin-bottom:8px;padding:11px 14px;display:flex}.optie-lijst .optie-kaart{margin-bottom:0}.optie-kaart.is-actief{border-color:var(--accent);background:var(--accent-zacht);box-shadow:inset 0 0 0 1px var(--accent)}.optie-radio{border:2px solid #c9c4ba;border-radius:50%;flex-shrink:0;width:18px;height:18px}.optie-kaart.is-actief .optie-radio{border-color:var(--accent);background:var(--accent);box-shadow:inset 0 0 0 3px #fff}.optie-tekst{flex-direction:column;flex:1;gap:2px;min-width:0;display:flex}.optie-tekst strong{font-size:14px}.optie-tekst small{color:var(--tekst-zacht);font-size:12px;line-height:1.35}.optie-prijs{color:var(--tekst);white-space:nowrap;font-size:13px;font-weight:700}.schakelaar-track{background:#d9d5ce;border-radius:999px;flex-shrink:0;width:36px;height:20px;transition:background .15s;position:relative}.schakelaar-track:after{content:\"\";background:#fff;border-radius:50%;width:16px;height:16px;transition:transform .15s;position:absolute;top:2px;left:2px;box-shadow:0 1px 2px #0003}.schakelaar.is-aan{border-color:var(--accent);background:var(--accent-zacht)}.schakelaar.is-aan .schakelaar-track{background:var(--accent)}.schakelaar.is-aan .schakelaar-track:after{transform:translate(16px)}.schakelaar.is-uitgeschakeld{cursor:not-allowed;opacity:.55}.status-regel{cursor:default;background:var(--vlak)}.status-regel.is-aan{border-color:var(--accent);background:var(--accent-zacht)}.status-bol{width:20px;height:20px;color:var(--tekst-zacht);background:#e2ded6;border-radius:50%;flex-shrink:0;place-items:center;font-size:12px;font-weight:700;display:grid}.status-regel.is-aan .status-bol{background:var(--accent);color:#fff}.maat-schuif{--duim:22px;--baan:6px;margin-bottom:4px}.maat-schuif-rij{align-items:center;gap:14px;display:flex}.maat-schuif-baan{flex:1;min-width:0;position:relative}.maat-schuif-baan input[type=range]{appearance:none;cursor:pointer;touch-action:pan-y;background:0 0;width:100%;height:36px;margin:0;display:block}.maat-schuif-baan input[type=range]:focus{outline:none}.maat-schuif-baan input[type=range]::-webkit-slider-runnable-track{height:var(--baan);background:linear-gradient(to right, var(--accent) 0 calc(var(--duim) / 2 + (100% - var(--duim)) * var(--p,0)), #e2ded6 0);border-radius:999px}.maat-schuif-baan input[type=range]::-moz-range-track{height:var(--baan);background:linear-gradient(to right, var(--accent) 0 calc(var(--duim) / 2 + (100% - var(--duim)) * var(--p,0)), #e2ded6 0);border-radius:999px}.maat-schuif-baan input[type=range]::-webkit-slider-thumb{appearance:none;box-sizing:border-box;width:var(--duim);height:var(--duim);margin-top:calc((var(--baan) - var(--duim)) / 2);border:2px solid var(--accent);background:#fff;border-radius:50%;transition:box-shadow .15s;box-shadow:0 1px 4px #0003}.maat-schuif-baan input[type=range]::-moz-range-thumb{box-sizing:border-box;width:var(--duim);height:var(--duim);border:2px solid var(--accent);background:#fff;border-radius:50%;box-shadow:0 1px 4px #0003}.maat-schuif-baan input[type=range]:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 4px #c8752b4d}.maat-schuif-baan input[type=range]:focus-visible::-moz-range-thumb{box-shadow:0 0 0 4px #c8752b4d}.maat-schuif-streepjes{left:calc(var(--duim) / 2);right:calc(var(--duim) / 2);pointer-events:none;height:7px;position:absolute;bottom:0}.maat-schuif-streepjes span{background:#c9c4ba;border-radius:1px;width:2px;height:5px;position:absolute;top:0;transform:translate(-50%)}.maat-schuif-streepjes span.is-actief{background:var(--accent);height:7px}.maat-schuif-schaal{color:var(--tekst-zacht);justify-content:space-between;margin-top:2px;margin-right:110px;font-size:11px;display:flex}.maat-invoer{border:1px solid var(--rand);box-sizing:border-box;cursor:text;background:#fff;border-radius:8px;flex:0 0 96px;align-items:center;gap:4px;height:40px;padding:0 10px 0 4px;display:flex}.maat-invoer:focus-within{border-color:var(--accent);box-shadow:0 0 0 1px var(--accent)}.maat-invoer input{width:100%;min-width:0;font:inherit;color:var(--tekst);text-align:right;-moz-appearance:textfield;background:0 0;border:none;outline:none;flex:1;padding:0;font-size:16px;font-weight:700}.maat-invoer input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.maat-invoer input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.maat-invoer span{color:var(--tekst-zacht);font-size:14px}.maat-resultaat{color:var(--tekst);margin-bottom:4px;font-size:14px;display:block}.stepper-rij{align-items:center;gap:12px;margin-bottom:8px;display:flex}.stepper{border:1px solid var(--rand);border-radius:8px;align-items:center;gap:10px;padding:5px 8px;display:inline-flex}.stepper span{text-align:center;min-width:56px;color:var(--tekst);font-size:15px;font-weight:700}.stepper button{cursor:pointer;width:30px;height:30px;color:var(--tekst);background:#f0ede7;border:none;border-radius:6px;font-size:17px}.stepper button:hover:not(:disabled){background:#e6e1d8}.stepper button:disabled{opacity:.35;cursor:not-allowed}.stepper-prijs{color:var(--tekst-zacht);font-size:12px}.info{background:var(--vlak);color:#4a4f5a;border-radius:8px;margin:8px 0 14px;padding:10px 12px;font-size:13px;line-height:1.45}.info-let-op{color:#7a4a17;background:#fff4e5;border:1px solid #f3d3a9}.contact-hulp,.keuzehulp{border:1px solid var(--rand);color:var(--tekst-zacht);background:#fff;border-radius:10px;flex-direction:column;gap:5px;margin:12px 0 18px;padding:12px 14px;font-size:13px;line-height:1.45;display:flex}.keuzehulp{background:var(--vlak)}.keuzehulp .contact-hulp{background:0 0;border:0;margin:2px 0 0;padding:0}.keuzehulp .contact-hulp span{display:none}.keuzehulp strong{color:var(--tekst)}.contact-hulp a,.bestel-proces a{color:var(--accent);text-underline-offset:2px;align-self:flex-start;font-weight:700;text-decoration:underline}.extra-optie{border-top:1px solid var(--rand);margin-top:20px;padding-top:4px}.bestel-proces{color:var(--tekst-zacht);margin:-6px 0 18px;font-size:13px;line-height:1.5}.richting-grid{grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px;display:grid}.richting-kaart{border:1px solid var(--rand);cursor:pointer;color:var(--tekst);background:#fff;border-radius:10px;flex-direction:column;align-items:center;gap:8px;padding:14px 8px;font-size:14px;display:flex}.richting-kaart.is-actief{border-color:var(--accent);background:var(--accent-zacht);box-shadow:inset 0 0 0 1px var(--accent)}.kleur-lijst{flex-direction:column;gap:8px;display:flex}.kleur-optie{border:1px solid var(--rand);cursor:pointer;text-align:left;color:var(--tekst);font:inherit;background:#fff;border-radius:10px;align-items:center;gap:12px;padding:9px 12px;display:flex}.kleur-optie.is-actief{border-color:var(--accent);background:var(--accent-zacht);box-shadow:inset 0 0 0 1px var(--accent)}.swatch{border-radius:50%;flex-shrink:0;width:30px;height:30px;box-shadow:inset 0 0 0 1px #0000002e}.kleur-naam{flex-direction:column;flex:1;display:flex}.kleur-naam strong{font-size:14px}.kleur-naam small,.kleur-prijs{color:var(--tekst-zacht);font-size:12px}.link-knop{color:var(--accent);cursor:pointer;background:0 0;border:none;padding:4px 0;font-size:13px;font-weight:600}.samenvatting{border:1px solid var(--rand);border-radius:10px;margin:0 0 8px;overflow:hidden}.samenvatting div{justify-content:space-between;gap:12px;padding:8px 12px;font-size:13px;display:flex}.samenvatting div:nth-child(odd){background:var(--vlak)}.samenvatting dt{color:var(--tekst-zacht)}.samenvatting dd{text-align:right;color:var(--tekst);margin:0;font-weight:600}.bestel-totaal{background:var(--vlak);color:var(--tekst);border-radius:10px;justify-content:space-between;align-items:baseline;margin-bottom:12px;padding:16px;display:flex}.bestel-totaal strong{font-size:24px}.burendeal-invoer{gap:8px;margin:16px 0;display:grid}.burendeal-invoer>.knop-secundair{justify-self:start}.burendeal-label{font-size:13px;font-weight:700}.burendeal-code-rij{gap:8px;display:flex}.burendeal-code-rij input{border:1px solid var(--rand);min-width:0;font:inherit;color:var(--tekst);border-radius:8px;flex:1;padding:0 12px;font-size:16px}.burendeal-code-rij input:focus{outline:2px solid var(--accent);outline-offset:1px}@media (width<=480px){.burendeal-code-rij{flex-direction:column}}.prijs-tabel{border-collapse:collapse;width:100%;color:var(--tekst);font-size:13px}.prijs-tabel td{vertical-align:top;padding:5px 0}.prijs-tabel td:last-child{text-align:right;white-space:nowrap;padding-left:12px}.prijs-tabel small{color:var(--tekst-zacht);font-size:11px;display:block}.prijs-tabel tfoot td{border-top:1px solid var(--rand);padding-top:8px;font-weight:700}.panel-footer{border-top:1px solid var(--rand);background:#fff;flex-shrink:0;padding:12px 24px 16px}.prijsopbouw summary{cursor:pointer;justify-content:space-between;align-items:flex-end;list-style:none;display:flex}.prijsopbouw summary::-webkit-details-marker{display:none}.prijsopbouw[open] summary{margin-bottom:8px}.prijsopbouw[open] .prijs-tabel{max-height:180px;display:block;overflow-y:auto}.prijsopbouw[open] .prijs-tabel tbody,.prijsopbouw[open] .prijs-tabel tfoot{width:100%;display:table}.price-label{color:var(--tekst-zacht);font-size:13px}.price-sub{color:var(--accent);font-size:11px;text-decoration:underline}.price-value{color:var(--tekst);font-size:26px;font-weight:700}.price-vanaf{color:var(--tekst-zacht);font-size:14px;font-weight:600}.nav-knoppen{gap:10px;margin-top:12px;display:flex}.cta,.knop-secundair{cursor:pointer;border:none;border-radius:10px;padding:13px 14px;font-size:15px;font-weight:600}.cta{background:var(--accent);color:#fff;flex:1}.cta:disabled{cursor:not-allowed;opacity:.55}.knop-secundair{background:var(--vlak);color:var(--tekst)}.knop-secundair:disabled{opacity:.4;cursor:not-allowed}button:focus-visible{outline:2px solid var(--accent);outline-offset:2px}.app{color:var(--tekst);background:#fff}.topbar{color:var(--tekst);border-top:4px solid var(--accent);border-bottom:1px solid var(--rand);background:#fff;padding:14px 24px;position:relative}.brand{color:var(--accent);opacity:1;letter-spacing:.7px;font-weight:700}.topbar h1,.topbar h2{color:var(--tekst);font-weight:600}.prototype-badge{color:#696969;background:#f8f8f8;border-color:#dedede}.scene-wrap{background:#f3f2ef}.scene-knop{border-color:#2222221f;border-radius:50px;transition:background-color .15s,border-color .15s,color .15s;box-shadow:0 2px 10px #22222214}.panel{background:#fff;box-shadow:-6px 0 24px #22222212}.stappen{background:#fff}.stap-chip{border-radius:50px}.stap-chip.is-actief{border-color:var(--accent);color:var(--tekst)}.panel h2{font-weight:600;line-height:1.25}.optie-kaart,.kleur-optie,.richting-kaart,.maat-invoer,.stepper{border-radius:10px;transition:border-color .15s,background-color .15s,box-shadow .15s}.optie-kaart:hover:not(.is-actief),.kleur-optie:hover:not(.is-actief),.richting-kaart:hover:not(.is-actief){border-color:#c9c9c9}.optie-kaart.is-actief,.kleur-optie.is-actief,.richting-kaart.is-actief{border-color:var(--accent);background:var(--accent-zacht);box-shadow:inset 0 0 0 1px var(--accent)}.info{color:#555;background:#f8f8f8}.info-let-op{color:#74410f}.panel-footer{border-top-color:var(--rand);background:#fff}.price-sub,.link-knop{color:var(--accent)}.cta,.knop-secundair{border-radius:50px;font-weight:700;transition:background-color .15s,border-color .15s,transform .15s}.cta{background:var(--accent)}.cta:hover:not(:disabled){background:#e8561d}.knop-secundair{border:1px solid var(--rand);background:#fff}.knop-secundair:hover:not(:disabled){background:#f8f8f8;border-color:#d2d2d2}button:not(:disabled):active{transform:translateY(1px)}@media (width<=960px){.app{height:auto;min-height:100dvh;overflow:visible}.topbar{padding:10px 16px}.topbar h1,.topbar h2{font-size:18px}.content{flex-direction:column}.scene-wrap{flex:none;height:420px}.scene-knoppen{background:#fff;justify-content:center;padding:10px 12px;position:static}.panel{flex:1 0 auto;box-shadow:0 -4px 16px #0000000f}.panel-body{padding:18px 16px 8px;overflow:visible}.panel-footer{padding:10px 16px 14px;position:sticky;bottom:0;box-shadow:0 -4px 12px #0000000f}.stappen{padding:10px 16px}.uitsparing-live{color:var(--tekst-zacht);background:#f8f8f8;border-radius:10px;justify-content:space-between;align-items:center;gap:12px;margin:8px 0 14px;padding:12px 14px;font-size:13px;display:flex}.uitsparing-live button{border:1px solid var(--rand);color:var(--accent);font:inherit;cursor:pointer;background:#fff;border-radius:8px;flex:none;padding:7px 10px;font-weight:700}}@media (width<=480px){.scene-wrap{height:220px}.scene-hint{display:none}.scene-knoppen{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;display:grid}.scene-knop{white-space:nowrap;box-shadow:none;padding:8px;font-size:12px}.scene-schakelaar{justify-content:space-between;gap:6px}.scene-bovenlicht{grid-column:1/-1}}", We = "\n  :host {\n    --navy: #222222;\n    --accent: #f8692b;\n    --accent-zacht: #fff3ed;\n    --tekst: #222222;\n    --tekst-zacht: #696969;\n    --rand: #e8e8e8;\n    --vlak: #f8f8f8;\n    display: block;\n    color-scheme: light;\n    font-family: 'Open Sans', Arial, sans-serif;\n  }\n  *, *::before, *::after { box-sizing: border-box; }\n  button, input, select, textarea { font-family: inherit; }\n  .app { height: min(900px, calc(100dvh - 110px)); min-height: 620px; }\n  @media (max-width: 960px) { .app { height: auto; min-height: 100dvh; } }\n";
function Ge(e) {
	let t = e.dataset.depositVariantId ?? "", n = Number(e.dataset.depositCents);
	if (/^\d{10,20}$/.test(t) && n === 5e3) return {
		cartRoot: e.dataset.cartRoot || "/",
		depositVariantId: t,
		depositAmount: n / 100,
		checkoutUrl: e.dataset.checkoutUrl || "/checkout"
	};
}
document.querySelectorAll("[data-hk-3d-configurator]").forEach((e) => {
	if (e.shadowRoot) return;
	let t = e.attachShadow({ mode: "open" }), n = document.createElement("style");
	n.textContent = `${Ue}\n${We}`;
	let r = document.createElement("div");
	t.append(n, r), (0, ee.createRoot)(r).render(/* @__PURE__ */ (0, w.jsx)(b.StrictMode, { children: /* @__PURE__ */ (0, w.jsx)(He, { shopify: Ge(e) }) }));
});
//#endregion
